// This client was generated by Platformatic from an OpenAPI specification.

import type { Api } from './api-types'
import type * as Types from './api-types'

// The base URL for the API. This can be overridden by calling `setBaseUrl`.
let baseUrl = ''
// The default headers to send within each request. This can be overridden by calling `setDefaultHeaders`.
let defaultHeaders = {}

function sanitizeUrl(url: string) : string {
  if (url.endsWith('/')) { return url.slice(0, -1) } else { return url }
}
export const setBaseUrl = (newUrl: string) : void => { baseUrl = sanitizeUrl(newUrl) }

export const setDefaultHeaders = (headers: Object): void => { defaultHeaders = headers }

type JSON = Record<string, unknown>
/* @ts-ignore */
function headersToJSON(headers: Headers): JSON {
  const output: JSON = {}
  headers.forEach((value, key) => {
    output[key] = value
  })
  return output
}

const _getV1FileUpload = async (url: string, request: Types.GetV1FileUploadRequest): Promise<Types.GetV1FileUploadResponses> => {
  const queryParameters: (keyof Types.GetV1FileUploadRequest)[]  = ['key', 'mimeType', 'partCount']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['file-size'] !== undefined) {
    headers['file-size'] = request['file-size']
    delete request['file-size']
  }

  const response = await fetch(`${url}/v1/file-upload/?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1FileUpload: Api['getV1FileUpload'] = async (request: Types.GetV1FileUploadRequest): Promise<Types.GetV1FileUploadResponses> => {
  return await _getV1FileUpload(baseUrl, request)
}
const _postV1FileUploadMarkComplete = async (url: string, request: Types.PostV1FileUploadMarkCompleteRequest): Promise<Types.PostV1FileUploadMarkCompleteResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/file-upload/mark-complete`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1FileUploadMarkComplete: Api['postV1FileUploadMarkComplete'] = async (request: Types.PostV1FileUploadMarkCompleteRequest): Promise<Types.PostV1FileUploadMarkCompleteResponses> => {
  return await _postV1FileUploadMarkComplete(baseUrl, request)
}
const _postV1DocumentMaster = async (url: string, request: Types.PostV1DocumentMasterRequest): Promise<Types.PostV1DocumentMasterResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/document-master/`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1DocumentMaster: Api['postV1DocumentMaster'] = async (request: Types.PostV1DocumentMasterRequest): Promise<Types.PostV1DocumentMasterResponses> => {
  return await _postV1DocumentMaster(baseUrl, request)
}
const _getV1DocumentMaster = async (url: string, request: Types.GetV1DocumentMasterRequest): Promise<Types.GetV1DocumentMasterResponses> => {
  const queryParameters: (keyof Types.GetV1DocumentMasterRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/document-master/?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1DocumentMaster: Api['getV1DocumentMaster'] = async (request: Types.GetV1DocumentMasterRequest): Promise<Types.GetV1DocumentMasterResponses> => {
  return await _getV1DocumentMaster(baseUrl, request)
}
const _getV1DocumentMasterId = async (url: string, request: Types.GetV1DocumentMasterIdRequest): Promise<Types.GetV1DocumentMasterIdResponses> => {
  const queryParameters: (keyof Types.GetV1DocumentMasterIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/document-master/${request['id']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1DocumentMasterId: Api['getV1DocumentMasterId'] = async (request: Types.GetV1DocumentMasterIdRequest): Promise<Types.GetV1DocumentMasterIdResponses> => {
  return await _getV1DocumentMasterId(baseUrl, request)
}
const _putV1DocumentMasterId = async (url: string, request: Types.PutV1DocumentMasterIdRequest): Promise<Types.PutV1DocumentMasterIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/document-master/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1DocumentMasterId: Api['putV1DocumentMasterId'] = async (request: Types.PutV1DocumentMasterIdRequest): Promise<Types.PutV1DocumentMasterIdResponses> => {
  return await _putV1DocumentMasterId(baseUrl, request)
}
const _deleteV1DocumentMasterId = async (url: string, request: Types.DeleteV1DocumentMasterIdRequest): Promise<Types.DeleteV1DocumentMasterIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/document-master/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1DocumentMasterId: Api['deleteV1DocumentMasterId'] = async (request: Types.DeleteV1DocumentMasterIdRequest): Promise<Types.DeleteV1DocumentMasterIdResponses> => {
  return await _deleteV1DocumentMasterId(baseUrl, request)
}
const _patchV1DocumentMasterIdStatus = async (url: string, request: Types.PatchV1DocumentMasterIdStatusRequest): Promise<Types.PatchV1DocumentMasterIdStatusResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/document-master/${request['id']}/status`, {
    method: 'PATCH',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const patchV1DocumentMasterIdStatus: Api['patchV1DocumentMasterIdStatus'] = async (request: Types.PatchV1DocumentMasterIdStatusRequest): Promise<Types.PatchV1DocumentMasterIdStatusResponses> => {
  return await _patchV1DocumentMasterIdStatus(baseUrl, request)
}
const _postV1DocumentMasterSaveAsDraft = async (url: string, request: Types.PostV1DocumentMasterSaveAsDraftRequest): Promise<Types.PostV1DocumentMasterSaveAsDraftResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/document-master/save-as-draft`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1DocumentMasterSaveAsDraft: Api['postV1DocumentMasterSaveAsDraft'] = async (request: Types.PostV1DocumentMasterSaveAsDraftRequest): Promise<Types.PostV1DocumentMasterSaveAsDraftResponses> => {
  return await _postV1DocumentMasterSaveAsDraft(baseUrl, request)
}
const _patchV1DocumentMasterIdSaveAsDraft = async (url: string, request: Types.PatchV1DocumentMasterIdSaveAsDraftRequest): Promise<Types.PatchV1DocumentMasterIdSaveAsDraftResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/document-master/${request['id']}/save-as-draft`, {
    method: 'PATCH',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const patchV1DocumentMasterIdSaveAsDraft: Api['patchV1DocumentMasterIdSaveAsDraft'] = async (request: Types.PatchV1DocumentMasterIdSaveAsDraftRequest): Promise<Types.PatchV1DocumentMasterIdSaveAsDraftResponses> => {
  return await _patchV1DocumentMasterIdSaveAsDraft(baseUrl, request)
}
const _getV1DocumentMasterGenerateExcel = async (url: string, request: Types.GetV1DocumentMasterGenerateExcelRequest): Promise<Types.GetV1DocumentMasterGenerateExcelResponses> => {
  const queryParameters: (keyof Types.GetV1DocumentMasterGenerateExcelRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['Content-Type'] !== undefined) {
    headers['Content-Type'] = request['Content-Type']
    delete request['Content-Type']
  }

  const response = await fetch(`${url}/v1/document-master/generate-excel?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1DocumentMasterGenerateExcel: Api['getV1DocumentMasterGenerateExcel'] = async (request: Types.GetV1DocumentMasterGenerateExcelRequest): Promise<Types.GetV1DocumentMasterGenerateExcelResponses> => {
  return await _getV1DocumentMasterGenerateExcel(baseUrl, request)
}
const _postV1DocumentMasterImport = async (url: string, request: Types.PostV1DocumentMasterImportRequest): Promise<Types.PostV1DocumentMasterImportResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/document-master/import`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1DocumentMasterImport: Api['postV1DocumentMasterImport'] = async (request: Types.PostV1DocumentMasterImportRequest): Promise<Types.PostV1DocumentMasterImportResponses> => {
  return await _postV1DocumentMasterImport(baseUrl, request)
}
const _postV1CompanyCalendar = async (url: string, request: Types.PostV1CompanyCalendarRequest): Promise<Types.PostV1CompanyCalendarResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/company-calendar/`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1CompanyCalendar: Api['postV1CompanyCalendar'] = async (request: Types.PostV1CompanyCalendarRequest): Promise<Types.PostV1CompanyCalendarResponses> => {
  return await _postV1CompanyCalendar(baseUrl, request)
}
const _getV1CompanyCalendar = async (url: string, request: Types.GetV1CompanyCalendarRequest): Promise<Types.GetV1CompanyCalendarResponses> => {
  const queryParameters: (keyof Types.GetV1CompanyCalendarRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/company-calendar/?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1CompanyCalendar: Api['getV1CompanyCalendar'] = async (request: Types.GetV1CompanyCalendarRequest): Promise<Types.GetV1CompanyCalendarResponses> => {
  return await _getV1CompanyCalendar(baseUrl, request)
}
const _getV1CompanyCalendarId = async (url: string, request: Types.GetV1CompanyCalendarIdRequest): Promise<Types.GetV1CompanyCalendarIdResponses> => {
  const queryParameters: (keyof Types.GetV1CompanyCalendarIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/company-calendar/${request['id']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1CompanyCalendarId: Api['getV1CompanyCalendarId'] = async (request: Types.GetV1CompanyCalendarIdRequest): Promise<Types.GetV1CompanyCalendarIdResponses> => {
  return await _getV1CompanyCalendarId(baseUrl, request)
}
const _putV1CompanyCalendarId = async (url: string, request: Types.PutV1CompanyCalendarIdRequest): Promise<Types.PutV1CompanyCalendarIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/company-calendar/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1CompanyCalendarId: Api['putV1CompanyCalendarId'] = async (request: Types.PutV1CompanyCalendarIdRequest): Promise<Types.PutV1CompanyCalendarIdResponses> => {
  return await _putV1CompanyCalendarId(baseUrl, request)
}
const _deleteV1CompanyCalendarId = async (url: string, request: Types.DeleteV1CompanyCalendarIdRequest): Promise<Types.DeleteV1CompanyCalendarIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/company-calendar/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1CompanyCalendarId: Api['deleteV1CompanyCalendarId'] = async (request: Types.DeleteV1CompanyCalendarIdRequest): Promise<Types.DeleteV1CompanyCalendarIdResponses> => {
  return await _deleteV1CompanyCalendarId(baseUrl, request)
}
const _patchV1CompanyCalendarIdStatus = async (url: string, request: Types.PatchV1CompanyCalendarIdStatusRequest): Promise<Types.PatchV1CompanyCalendarIdStatusResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/company-calendar/${request['id']}/status`, {
    method: 'PATCH',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const patchV1CompanyCalendarIdStatus: Api['patchV1CompanyCalendarIdStatus'] = async (request: Types.PatchV1CompanyCalendarIdStatusRequest): Promise<Types.PatchV1CompanyCalendarIdStatusResponses> => {
  return await _patchV1CompanyCalendarIdStatus(baseUrl, request)
}
const _postV1CompanyCalendarSaveAsDraft = async (url: string, request: Types.PostV1CompanyCalendarSaveAsDraftRequest): Promise<Types.PostV1CompanyCalendarSaveAsDraftResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/company-calendar/save-as-draft`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1CompanyCalendarSaveAsDraft: Api['postV1CompanyCalendarSaveAsDraft'] = async (request: Types.PostV1CompanyCalendarSaveAsDraftRequest): Promise<Types.PostV1CompanyCalendarSaveAsDraftResponses> => {
  return await _postV1CompanyCalendarSaveAsDraft(baseUrl, request)
}
const _patchV1CompanyCalendarIdSaveAsDraft = async (url: string, request: Types.PatchV1CompanyCalendarIdSaveAsDraftRequest): Promise<Types.PatchV1CompanyCalendarIdSaveAsDraftResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/company-calendar/${request['id']}/save-as-draft`, {
    method: 'PATCH',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const patchV1CompanyCalendarIdSaveAsDraft: Api['patchV1CompanyCalendarIdSaveAsDraft'] = async (request: Types.PatchV1CompanyCalendarIdSaveAsDraftRequest): Promise<Types.PatchV1CompanyCalendarIdSaveAsDraftResponses> => {
  return await _patchV1CompanyCalendarIdSaveAsDraft(baseUrl, request)
}
const _getV1CompanyCalendarGenerateExcel = async (url: string, request: Types.GetV1CompanyCalendarGenerateExcelRequest): Promise<Types.GetV1CompanyCalendarGenerateExcelResponses> => {
  const queryParameters: (keyof Types.GetV1CompanyCalendarGenerateExcelRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['Content-Type'] !== undefined) {
    headers['Content-Type'] = request['Content-Type']
    delete request['Content-Type']
  }

  const response = await fetch(`${url}/v1/company-calendar/generate-excel?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1CompanyCalendarGenerateExcel: Api['getV1CompanyCalendarGenerateExcel'] = async (request: Types.GetV1CompanyCalendarGenerateExcelRequest): Promise<Types.GetV1CompanyCalendarGenerateExcelResponses> => {
  return await _getV1CompanyCalendarGenerateExcel(baseUrl, request)
}
const _postV1CompanyCalendarImport = async (url: string, request: Types.PostV1CompanyCalendarImportRequest): Promise<Types.PostV1CompanyCalendarImportResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/company-calendar/import`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1CompanyCalendarImport: Api['postV1CompanyCalendarImport'] = async (request: Types.PostV1CompanyCalendarImportRequest): Promise<Types.PostV1CompanyCalendarImportResponses> => {
  return await _postV1CompanyCalendarImport(baseUrl, request)
}
const _postV1LoanMaster = async (url: string, request: Types.PostV1LoanMasterRequest): Promise<Types.PostV1LoanMasterResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/loan-master/`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1LoanMaster: Api['postV1LoanMaster'] = async (request: Types.PostV1LoanMasterRequest): Promise<Types.PostV1LoanMasterResponses> => {
  return await _postV1LoanMaster(baseUrl, request)
}
const _getV1LoanMaster = async (url: string, request: Types.GetV1LoanMasterRequest): Promise<Types.GetV1LoanMasterResponses> => {
  const queryParameters: (keyof Types.GetV1LoanMasterRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/loan-master/?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1LoanMaster: Api['getV1LoanMaster'] = async (request: Types.GetV1LoanMasterRequest): Promise<Types.GetV1LoanMasterResponses> => {
  return await _getV1LoanMaster(baseUrl, request)
}
const _getV1LoanMasterId = async (url: string, request: Types.GetV1LoanMasterIdRequest): Promise<Types.GetV1LoanMasterIdResponses> => {
  const queryParameters: (keyof Types.GetV1LoanMasterIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/loan-master/${request['id']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1LoanMasterId: Api['getV1LoanMasterId'] = async (request: Types.GetV1LoanMasterIdRequest): Promise<Types.GetV1LoanMasterIdResponses> => {
  return await _getV1LoanMasterId(baseUrl, request)
}
const _putV1LoanMasterId = async (url: string, request: Types.PutV1LoanMasterIdRequest): Promise<Types.PutV1LoanMasterIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/loan-master/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1LoanMasterId: Api['putV1LoanMasterId'] = async (request: Types.PutV1LoanMasterIdRequest): Promise<Types.PutV1LoanMasterIdResponses> => {
  return await _putV1LoanMasterId(baseUrl, request)
}
const _deleteV1LoanMasterId = async (url: string, request: Types.DeleteV1LoanMasterIdRequest): Promise<Types.DeleteV1LoanMasterIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/loan-master/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1LoanMasterId: Api['deleteV1LoanMasterId'] = async (request: Types.DeleteV1LoanMasterIdRequest): Promise<Types.DeleteV1LoanMasterIdResponses> => {
  return await _deleteV1LoanMasterId(baseUrl, request)
}
const _patchV1LoanMasterIdStatus = async (url: string, request: Types.PatchV1LoanMasterIdStatusRequest): Promise<Types.PatchV1LoanMasterIdStatusResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/loan-master/${request['id']}/status`, {
    method: 'PATCH',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const patchV1LoanMasterIdStatus: Api['patchV1LoanMasterIdStatus'] = async (request: Types.PatchV1LoanMasterIdStatusRequest): Promise<Types.PatchV1LoanMasterIdStatusResponses> => {
  return await _patchV1LoanMasterIdStatus(baseUrl, request)
}
const _postV1LoanMasterDraft = async (url: string, request: Types.PostV1LoanMasterDraftRequest): Promise<Types.PostV1LoanMasterDraftResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/loan-master/draft`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1LoanMasterDraft: Api['postV1LoanMasterDraft'] = async (request: Types.PostV1LoanMasterDraftRequest): Promise<Types.PostV1LoanMasterDraftResponses> => {
  return await _postV1LoanMasterDraft(baseUrl, request)
}
const _postV1LoanRequests = async (url: string, request: Types.PostV1LoanRequestsRequest): Promise<Types.PostV1LoanRequestsResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/loan-requests/`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1LoanRequests: Api['postV1LoanRequests'] = async (request: Types.PostV1LoanRequestsRequest): Promise<Types.PostV1LoanRequestsResponses> => {
  return await _postV1LoanRequests(baseUrl, request)
}
const _getV1LoanRequests = async (url: string, request: Types.GetV1LoanRequestsRequest): Promise<Types.GetV1LoanRequestsResponses> => {
  const queryParameters: (keyof Types.GetV1LoanRequestsRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/loan-requests/?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1LoanRequests: Api['getV1LoanRequests'] = async (request: Types.GetV1LoanRequestsRequest): Promise<Types.GetV1LoanRequestsResponses> => {
  return await _getV1LoanRequests(baseUrl, request)
}
const _getV1LoanRequestsEligibilityEmployeeIdLoanMasters = async (url: string, request: Types.GetV1LoanRequestsEligibilityEmployeeIdLoanMastersRequest): Promise<Types.GetV1LoanRequestsEligibilityEmployeeIdLoanMastersResponses> => {
  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/loan-requests/eligibility/${request['employee_id']}/loan-masters`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1LoanRequestsEligibilityEmployeeIdLoanMasters: Api['getV1LoanRequestsEligibilityEmployeeIdLoanMasters'] = async (request: Types.GetV1LoanRequestsEligibilityEmployeeIdLoanMastersRequest): Promise<Types.GetV1LoanRequestsEligibilityEmployeeIdLoanMastersResponses> => {
  return await _getV1LoanRequestsEligibilityEmployeeIdLoanMasters(baseUrl, request)
}
const _postV1LoanRequestsCheckEligibility = async (url: string, request: Types.PostV1LoanRequestsCheckEligibilityRequest): Promise<Types.PostV1LoanRequestsCheckEligibilityResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/loan-requests/check-eligibility`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1LoanRequestsCheckEligibility: Api['postV1LoanRequestsCheckEligibility'] = async (request: Types.PostV1LoanRequestsCheckEligibilityRequest): Promise<Types.PostV1LoanRequestsCheckEligibilityResponses> => {
  return await _postV1LoanRequestsCheckEligibility(baseUrl, request)
}
const _postV1LoanRequestsPreviewEmi = async (url: string, request: Types.PostV1LoanRequestsPreviewEmiRequest): Promise<Types.PostV1LoanRequestsPreviewEmiResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/loan-requests/preview-emi`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1LoanRequestsPreviewEmi: Api['postV1LoanRequestsPreviewEmi'] = async (request: Types.PostV1LoanRequestsPreviewEmiRequest): Promise<Types.PostV1LoanRequestsPreviewEmiResponses> => {
  return await _postV1LoanRequestsPreviewEmi(baseUrl, request)
}
const _getV1LoanRequestsId = async (url: string, request: Types.GetV1LoanRequestsIdRequest): Promise<Types.GetV1LoanRequestsIdResponses> => {
  const queryParameters: (keyof Types.GetV1LoanRequestsIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/loan-requests/${request['id']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1LoanRequestsId: Api['getV1LoanRequestsId'] = async (request: Types.GetV1LoanRequestsIdRequest): Promise<Types.GetV1LoanRequestsIdResponses> => {
  return await _getV1LoanRequestsId(baseUrl, request)
}
const _putV1LoanRequestsId = async (url: string, request: Types.PutV1LoanRequestsIdRequest): Promise<Types.PutV1LoanRequestsIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/loan-requests/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1LoanRequestsId: Api['putV1LoanRequestsId'] = async (request: Types.PutV1LoanRequestsIdRequest): Promise<Types.PutV1LoanRequestsIdResponses> => {
  return await _putV1LoanRequestsId(baseUrl, request)
}
const _deleteV1LoanRequestsId = async (url: string, request: Types.DeleteV1LoanRequestsIdRequest): Promise<Types.DeleteV1LoanRequestsIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/loan-requests/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1LoanRequestsId: Api['deleteV1LoanRequestsId'] = async (request: Types.DeleteV1LoanRequestsIdRequest): Promise<Types.DeleteV1LoanRequestsIdResponses> => {
  return await _deleteV1LoanRequestsId(baseUrl, request)
}
const _getV1LoanRequestsGenerateExcel = async (url: string, request: Types.GetV1LoanRequestsGenerateExcelRequest): Promise<Types.GetV1LoanRequestsGenerateExcelResponses> => {
  const queryParameters: (keyof Types.GetV1LoanRequestsGenerateExcelRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/loan-requests/generate-excel?${searchParams.toString()}`, {
    headers
  })

  const textResponses = [200]
  if (textResponses.includes(response.status)) {
    return {
      statusCode: response.status as 200,
      headers: headersToJSON(response.headers),
      body: await response.text()
    }
  }
  if (response.headers.get('content-type') === 'application/json') {
    return {
      statusCode: response.status as 200,
      headers: headersToJSON(response.headers),
      body: await response.json() as any
    }
  }
  return {
    statusCode: response.status as 200,
    headers: headersToJSON(response.headers),
    body: await response.text() as any
  }
}

export const getV1LoanRequestsGenerateExcel: Api['getV1LoanRequestsGenerateExcel'] = async (request: Types.GetV1LoanRequestsGenerateExcelRequest): Promise<Types.GetV1LoanRequestsGenerateExcelResponses> => {
  return await _getV1LoanRequestsGenerateExcel(baseUrl, request)
}
const _getV1LoanAllotments = async (url: string, request: Types.GetV1LoanAllotmentsRequest): Promise<Types.GetV1LoanAllotmentsResponses> => {
  const queryParameters: (keyof Types.GetV1LoanAllotmentsRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/loan-allotments/?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1LoanAllotments: Api['getV1LoanAllotments'] = async (request: Types.GetV1LoanAllotmentsRequest): Promise<Types.GetV1LoanAllotmentsResponses> => {
  return await _getV1LoanAllotments(baseUrl, request)
}
const _getV1LoanAllotmentsMyApprovals = async (url: string, request: Types.GetV1LoanAllotmentsMyApprovalsRequest): Promise<Types.GetV1LoanAllotmentsMyApprovalsResponses> => {
  const queryParameters: (keyof Types.GetV1LoanAllotmentsMyApprovalsRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select', 'approval_status']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/loan-allotments/my-approvals?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1LoanAllotmentsMyApprovals: Api['getV1LoanAllotmentsMyApprovals'] = async (request: Types.GetV1LoanAllotmentsMyApprovalsRequest): Promise<Types.GetV1LoanAllotmentsMyApprovalsResponses> => {
  return await _getV1LoanAllotmentsMyApprovals(baseUrl, request)
}
const _getV1LoanAllotmentsId = async (url: string, request: Types.GetV1LoanAllotmentsIdRequest): Promise<Types.GetV1LoanAllotmentsIdResponses> => {
  const queryParameters: (keyof Types.GetV1LoanAllotmentsIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/loan-allotments/${request['id']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1LoanAllotmentsId: Api['getV1LoanAllotmentsId'] = async (request: Types.GetV1LoanAllotmentsIdRequest): Promise<Types.GetV1LoanAllotmentsIdResponses> => {
  return await _getV1LoanAllotmentsId(baseUrl, request)
}
const _patchV1LoanAllotmentsIdStatus = async (url: string, request: Types.PatchV1LoanAllotmentsIdStatusRequest): Promise<Types.PatchV1LoanAllotmentsIdStatusResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/loan-allotments/${request['id']}/status`, {
    method: 'PATCH',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const patchV1LoanAllotmentsIdStatus: Api['patchV1LoanAllotmentsIdStatus'] = async (request: Types.PatchV1LoanAllotmentsIdStatusRequest): Promise<Types.PatchV1LoanAllotmentsIdStatusResponses> => {
  return await _patchV1LoanAllotmentsIdStatus(baseUrl, request)
}
const _getV1LoanAllotmentsActiveLoans = async (url: string, request: Types.GetV1LoanAllotmentsActiveLoansRequest): Promise<Types.GetV1LoanAllotmentsActiveLoansResponses> => {
  const queryParameters: (keyof Types.GetV1LoanAllotmentsActiveLoansRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/loan-allotments/active-loans?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1LoanAllotmentsActiveLoans: Api['getV1LoanAllotmentsActiveLoans'] = async (request: Types.GetV1LoanAllotmentsActiveLoansRequest): Promise<Types.GetV1LoanAllotmentsActiveLoansResponses> => {
  return await _getV1LoanAllotmentsActiveLoans(baseUrl, request)
}
const _getV1LoanAllotmentsActiveLoansId = async (url: string, request: Types.GetV1LoanAllotmentsActiveLoansIdRequest): Promise<Types.GetV1LoanAllotmentsActiveLoansIdResponses> => {
  const queryParameters: (keyof Types.GetV1LoanAllotmentsActiveLoansIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/loan-allotments/active-loans/${request['id']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1LoanAllotmentsActiveLoansId: Api['getV1LoanAllotmentsActiveLoansId'] = async (request: Types.GetV1LoanAllotmentsActiveLoansIdRequest): Promise<Types.GetV1LoanAllotmentsActiveLoansIdResponses> => {
  return await _getV1LoanAllotmentsActiveLoansId(baseUrl, request)
}
const _getV1LoanAllotmentsActiveLoansIdEmiScheduleExport = async (url: string, request: Types.GetV1LoanAllotmentsActiveLoansIdEmiScheduleExportRequest): Promise<Types.GetV1LoanAllotmentsActiveLoansIdEmiScheduleExportResponses> => {
  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/loan-allotments/active-loans/${request['id']}/emi-schedule/export`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1LoanAllotmentsActiveLoansIdEmiScheduleExport: Api['getV1LoanAllotmentsActiveLoansIdEmiScheduleExport'] = async (request: Types.GetV1LoanAllotmentsActiveLoansIdEmiScheduleExportRequest): Promise<Types.GetV1LoanAllotmentsActiveLoansIdEmiScheduleExportResponses> => {
  return await _getV1LoanAllotmentsActiveLoansIdEmiScheduleExport(baseUrl, request)
}
const _getV1LeaveCategory = async (url: string, request: Types.GetV1LeaveCategoryRequest): Promise<Types.GetV1LeaveCategoryResponses> => {
  const queryParameters: (keyof Types.GetV1LeaveCategoryRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/leave-category/?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1LeaveCategory: Api['getV1LeaveCategory'] = async (request: Types.GetV1LeaveCategoryRequest): Promise<Types.GetV1LeaveCategoryResponses> => {
  return await _getV1LeaveCategory(baseUrl, request)
}
const _getV1LeaveCategoryId = async (url: string, request: Types.GetV1LeaveCategoryIdRequest): Promise<Types.GetV1LeaveCategoryIdResponses> => {
  const queryParameters: (keyof Types.GetV1LeaveCategoryIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/leave-category/${request['id']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1LeaveCategoryId: Api['getV1LeaveCategoryId'] = async (request: Types.GetV1LeaveCategoryIdRequest): Promise<Types.GetV1LeaveCategoryIdResponses> => {
  return await _getV1LeaveCategoryId(baseUrl, request)
}
const _getV1AccrualType = async (url: string, request: Types.GetV1AccrualTypeRequest): Promise<Types.GetV1AccrualTypeResponses> => {
  const queryParameters: (keyof Types.GetV1AccrualTypeRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/accrual-type/?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1AccrualType: Api['getV1AccrualType'] = async (request: Types.GetV1AccrualTypeRequest): Promise<Types.GetV1AccrualTypeResponses> => {
  return await _getV1AccrualType(baseUrl, request)
}
const _getV1AccrualTypeId = async (url: string, request: Types.GetV1AccrualTypeIdRequest): Promise<Types.GetV1AccrualTypeIdResponses> => {
  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/accrual-type/${request['id']}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1AccrualTypeId: Api['getV1AccrualTypeId'] = async (request: Types.GetV1AccrualTypeIdRequest): Promise<Types.GetV1AccrualTypeIdResponses> => {
  return await _getV1AccrualTypeId(baseUrl, request)
}
const _postV1AccrualMaster = async (url: string, request: Types.PostV1AccrualMasterRequest): Promise<Types.PostV1AccrualMasterResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/accrual-master/`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1AccrualMaster: Api['postV1AccrualMaster'] = async (request: Types.PostV1AccrualMasterRequest): Promise<Types.PostV1AccrualMasterResponses> => {
  return await _postV1AccrualMaster(baseUrl, request)
}
const _getV1AccrualMaster = async (url: string, request: Types.GetV1AccrualMasterRequest): Promise<Types.GetV1AccrualMasterResponses> => {
  const queryParameters: (keyof Types.GetV1AccrualMasterRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/accrual-master/?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1AccrualMaster: Api['getV1AccrualMaster'] = async (request: Types.GetV1AccrualMasterRequest): Promise<Types.GetV1AccrualMasterResponses> => {
  return await _getV1AccrualMaster(baseUrl, request)
}
const _getV1AccrualMasterId = async (url: string, request: Types.GetV1AccrualMasterIdRequest): Promise<Types.GetV1AccrualMasterIdResponses> => {
  const queryParameters: (keyof Types.GetV1AccrualMasterIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/accrual-master/${request['id']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1AccrualMasterId: Api['getV1AccrualMasterId'] = async (request: Types.GetV1AccrualMasterIdRequest): Promise<Types.GetV1AccrualMasterIdResponses> => {
  return await _getV1AccrualMasterId(baseUrl, request)
}
const _putV1AccrualMasterId = async (url: string, request: Types.PutV1AccrualMasterIdRequest): Promise<Types.PutV1AccrualMasterIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/accrual-master/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1AccrualMasterId: Api['putV1AccrualMasterId'] = async (request: Types.PutV1AccrualMasterIdRequest): Promise<Types.PutV1AccrualMasterIdResponses> => {
  return await _putV1AccrualMasterId(baseUrl, request)
}
const _deleteV1AccrualMasterId = async (url: string, request: Types.DeleteV1AccrualMasterIdRequest): Promise<Types.DeleteV1AccrualMasterIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/accrual-master/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1AccrualMasterId: Api['deleteV1AccrualMasterId'] = async (request: Types.DeleteV1AccrualMasterIdRequest): Promise<Types.DeleteV1AccrualMasterIdResponses> => {
  return await _deleteV1AccrualMasterId(baseUrl, request)
}
const _patchV1AccrualMasterIdStatus = async (url: string, request: Types.PatchV1AccrualMasterIdStatusRequest): Promise<Types.PatchV1AccrualMasterIdStatusResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/accrual-master/${request['id']}/status`, {
    method: 'PATCH',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const patchV1AccrualMasterIdStatus: Api['patchV1AccrualMasterIdStatus'] = async (request: Types.PatchV1AccrualMasterIdStatusRequest): Promise<Types.PatchV1AccrualMasterIdStatusResponses> => {
  return await _patchV1AccrualMasterIdStatus(baseUrl, request)
}
const _postV1AccrualMasterDraft = async (url: string, request: Types.PostV1AccrualMasterDraftRequest): Promise<Types.PostV1AccrualMasterDraftResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/accrual-master/draft`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1AccrualMasterDraft: Api['postV1AccrualMasterDraft'] = async (request: Types.PostV1AccrualMasterDraftRequest): Promise<Types.PostV1AccrualMasterDraftResponses> => {
  return await _postV1AccrualMasterDraft(baseUrl, request)
}
const _patchV1AccrualMasterIdDraft = async (url: string, request: Types.PatchV1AccrualMasterIdDraftRequest): Promise<Types.PatchV1AccrualMasterIdDraftResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/accrual-master/${request['id']}/draft`, {
    method: 'PATCH',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const patchV1AccrualMasterIdDraft: Api['patchV1AccrualMasterIdDraft'] = async (request: Types.PatchV1AccrualMasterIdDraftRequest): Promise<Types.PatchV1AccrualMasterIdDraftResponses> => {
  return await _patchV1AccrualMasterIdDraft(baseUrl, request)
}
const _getV1AccrualMasterGenerateExcel = async (url: string, request: Types.GetV1AccrualMasterGenerateExcelRequest): Promise<Types.GetV1AccrualMasterGenerateExcelResponses> => {
  const queryParameters: (keyof Types.GetV1AccrualMasterGenerateExcelRequest)[]  = ['filters', 'order', 'limit', 'skip', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['Content-Type'] !== undefined) {
    headers['Content-Type'] = request['Content-Type']
    delete request['Content-Type']
  }

  const response = await fetch(`${url}/v1/accrual-master/generate-excel?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1AccrualMasterGenerateExcel: Api['getV1AccrualMasterGenerateExcel'] = async (request: Types.GetV1AccrualMasterGenerateExcelRequest): Promise<Types.GetV1AccrualMasterGenerateExcelResponses> => {
  return await _getV1AccrualMasterGenerateExcel(baseUrl, request)
}
const _postV1AccrualMasterImport = async (url: string, request: Types.PostV1AccrualMasterImportRequest): Promise<Types.PostV1AccrualMasterImportResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/accrual-master/import`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1AccrualMasterImport: Api['postV1AccrualMasterImport'] = async (request: Types.PostV1AccrualMasterImportRequest): Promise<Types.PostV1AccrualMasterImportResponses> => {
  return await _postV1AccrualMasterImport(baseUrl, request)
}
const _postV1AccrualMasterCalculateAmount = async (url: string, request: Types.PostV1AccrualMasterCalculateAmountRequest): Promise<Types.PostV1AccrualMasterCalculateAmountResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/accrual-master/calculate-amount`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1AccrualMasterCalculateAmount: Api['postV1AccrualMasterCalculateAmount'] = async (request: Types.PostV1AccrualMasterCalculateAmountRequest): Promise<Types.PostV1AccrualMasterCalculateAmountResponses> => {
  return await _postV1AccrualMasterCalculateAmount(baseUrl, request)
}
const _postV1LeavePolicyMaster = async (url: string, request: Types.PostV1LeavePolicyMasterRequest): Promise<Types.PostV1LeavePolicyMasterResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/leave-policy-master/`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1LeavePolicyMaster: Api['postV1LeavePolicyMaster'] = async (request: Types.PostV1LeavePolicyMasterRequest): Promise<Types.PostV1LeavePolicyMasterResponses> => {
  return await _postV1LeavePolicyMaster(baseUrl, request)
}
const _getV1LeavePolicyMaster = async (url: string, request: Types.GetV1LeavePolicyMasterRequest): Promise<Types.GetV1LeavePolicyMasterResponses> => {
  const queryParameters: (keyof Types.GetV1LeavePolicyMasterRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/leave-policy-master/?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1LeavePolicyMaster: Api['getV1LeavePolicyMaster'] = async (request: Types.GetV1LeavePolicyMasterRequest): Promise<Types.GetV1LeavePolicyMasterResponses> => {
  return await _getV1LeavePolicyMaster(baseUrl, request)
}
const _getV1LeavePolicyMasterId = async (url: string, request: Types.GetV1LeavePolicyMasterIdRequest): Promise<Types.GetV1LeavePolicyMasterIdResponses> => {
  const queryParameters: (keyof Types.GetV1LeavePolicyMasterIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/leave-policy-master/${request['id']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1LeavePolicyMasterId: Api['getV1LeavePolicyMasterId'] = async (request: Types.GetV1LeavePolicyMasterIdRequest): Promise<Types.GetV1LeavePolicyMasterIdResponses> => {
  return await _getV1LeavePolicyMasterId(baseUrl, request)
}
const _putV1LeavePolicyMasterId = async (url: string, request: Types.PutV1LeavePolicyMasterIdRequest): Promise<Types.PutV1LeavePolicyMasterIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/leave-policy-master/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1LeavePolicyMasterId: Api['putV1LeavePolicyMasterId'] = async (request: Types.PutV1LeavePolicyMasterIdRequest): Promise<Types.PutV1LeavePolicyMasterIdResponses> => {
  return await _putV1LeavePolicyMasterId(baseUrl, request)
}
const _deleteV1LeavePolicyMasterId = async (url: string, request: Types.DeleteV1LeavePolicyMasterIdRequest): Promise<Types.DeleteV1LeavePolicyMasterIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/leave-policy-master/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1LeavePolicyMasterId: Api['deleteV1LeavePolicyMasterId'] = async (request: Types.DeleteV1LeavePolicyMasterIdRequest): Promise<Types.DeleteV1LeavePolicyMasterIdResponses> => {
  return await _deleteV1LeavePolicyMasterId(baseUrl, request)
}
const _patchV1LeavePolicyMasterIdStatus = async (url: string, request: Types.PatchV1LeavePolicyMasterIdStatusRequest): Promise<Types.PatchV1LeavePolicyMasterIdStatusResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/leave-policy-master/${request['id']}/status`, {
    method: 'PATCH',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const patchV1LeavePolicyMasterIdStatus: Api['patchV1LeavePolicyMasterIdStatus'] = async (request: Types.PatchV1LeavePolicyMasterIdStatusRequest): Promise<Types.PatchV1LeavePolicyMasterIdStatusResponses> => {
  return await _patchV1LeavePolicyMasterIdStatus(baseUrl, request)
}
const _postV1LeavePolicyMasterSaveAsDraft = async (url: string, request: Types.PostV1LeavePolicyMasterSaveAsDraftRequest): Promise<Types.PostV1LeavePolicyMasterSaveAsDraftResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/leave-policy-master/save-as-draft`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1LeavePolicyMasterSaveAsDraft: Api['postV1LeavePolicyMasterSaveAsDraft'] = async (request: Types.PostV1LeavePolicyMasterSaveAsDraftRequest): Promise<Types.PostV1LeavePolicyMasterSaveAsDraftResponses> => {
  return await _postV1LeavePolicyMasterSaveAsDraft(baseUrl, request)
}
const _patchV1LeavePolicyMasterIdSaveAsDraft = async (url: string, request: Types.PatchV1LeavePolicyMasterIdSaveAsDraftRequest): Promise<Types.PatchV1LeavePolicyMasterIdSaveAsDraftResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/leave-policy-master/${request['id']}/save-as-draft`, {
    method: 'PATCH',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const patchV1LeavePolicyMasterIdSaveAsDraft: Api['patchV1LeavePolicyMasterIdSaveAsDraft'] = async (request: Types.PatchV1LeavePolicyMasterIdSaveAsDraftRequest): Promise<Types.PatchV1LeavePolicyMasterIdSaveAsDraftResponses> => {
  return await _patchV1LeavePolicyMasterIdSaveAsDraft(baseUrl, request)
}
const _getV1LeavePolicyMasterGenerateExcel = async (url: string, request: Types.GetV1LeavePolicyMasterGenerateExcelRequest): Promise<Types.GetV1LeavePolicyMasterGenerateExcelResponses> => {
  const queryParameters: (keyof Types.GetV1LeavePolicyMasterGenerateExcelRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['Content-Type'] !== undefined) {
    headers['Content-Type'] = request['Content-Type']
    delete request['Content-Type']
  }

  const response = await fetch(`${url}/v1/leave-policy-master/generate-excel?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1LeavePolicyMasterGenerateExcel: Api['getV1LeavePolicyMasterGenerateExcel'] = async (request: Types.GetV1LeavePolicyMasterGenerateExcelRequest): Promise<Types.GetV1LeavePolicyMasterGenerateExcelResponses> => {
  return await _getV1LeavePolicyMasterGenerateExcel(baseUrl, request)
}
const _postV1LeavePolicyMasterImport = async (url: string, request: Types.PostV1LeavePolicyMasterImportRequest): Promise<Types.PostV1LeavePolicyMasterImportResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/leave-policy-master/import`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1LeavePolicyMasterImport: Api['postV1LeavePolicyMasterImport'] = async (request: Types.PostV1LeavePolicyMasterImportRequest): Promise<Types.PostV1LeavePolicyMasterImportResponses> => {
  return await _postV1LeavePolicyMasterImport(baseUrl, request)
}
const _postV1Grades = async (url: string, request: Types.PostV1GradesRequest): Promise<Types.PostV1GradesResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/grades/`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1Grades: Api['postV1Grades'] = async (request: Types.PostV1GradesRequest): Promise<Types.PostV1GradesResponses> => {
  return await _postV1Grades(baseUrl, request)
}
const _getV1Grades = async (url: string, request: Types.GetV1GradesRequest): Promise<Types.GetV1GradesResponses> => {
  const queryParameters: (keyof Types.GetV1GradesRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/grades/?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1Grades: Api['getV1Grades'] = async (request: Types.GetV1GradesRequest): Promise<Types.GetV1GradesResponses> => {
  return await _getV1Grades(baseUrl, request)
}
const _getV1GradesId = async (url: string, request: Types.GetV1GradesIdRequest): Promise<Types.GetV1GradesIdResponses> => {
  const queryParameters: (keyof Types.GetV1GradesIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/grades/${request['id']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1GradesId: Api['getV1GradesId'] = async (request: Types.GetV1GradesIdRequest): Promise<Types.GetV1GradesIdResponses> => {
  return await _getV1GradesId(baseUrl, request)
}
const _putV1GradesId = async (url: string, request: Types.PutV1GradesIdRequest): Promise<Types.PutV1GradesIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/grades/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1GradesId: Api['putV1GradesId'] = async (request: Types.PutV1GradesIdRequest): Promise<Types.PutV1GradesIdResponses> => {
  return await _putV1GradesId(baseUrl, request)
}
const _deleteV1GradesId = async (url: string, request: Types.DeleteV1GradesIdRequest): Promise<Types.DeleteV1GradesIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/grades/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1GradesId: Api['deleteV1GradesId'] = async (request: Types.DeleteV1GradesIdRequest): Promise<Types.DeleteV1GradesIdResponses> => {
  return await _deleteV1GradesId(baseUrl, request)
}
const _patchV1GradesIdStatus = async (url: string, request: Types.PatchV1GradesIdStatusRequest): Promise<Types.PatchV1GradesIdStatusResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/grades/${request['id']}/status`, {
    method: 'PATCH',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const patchV1GradesIdStatus: Api['patchV1GradesIdStatus'] = async (request: Types.PatchV1GradesIdStatusRequest): Promise<Types.PatchV1GradesIdStatusResponses> => {
  return await _patchV1GradesIdStatus(baseUrl, request)
}
const _postV1Teams = async (url: string, request: Types.PostV1TeamsRequest): Promise<Types.PostV1TeamsResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/teams/`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1Teams: Api['postV1Teams'] = async (request: Types.PostV1TeamsRequest): Promise<Types.PostV1TeamsResponses> => {
  return await _postV1Teams(baseUrl, request)
}
const _getV1Teams = async (url: string, request: Types.GetV1TeamsRequest): Promise<Types.GetV1TeamsResponses> => {
  const queryParameters: (keyof Types.GetV1TeamsRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/teams/?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1Teams: Api['getV1Teams'] = async (request: Types.GetV1TeamsRequest): Promise<Types.GetV1TeamsResponses> => {
  return await _getV1Teams(baseUrl, request)
}
const _getV1TeamsId = async (url: string, request: Types.GetV1TeamsIdRequest): Promise<Types.GetV1TeamsIdResponses> => {
  const queryParameters: (keyof Types.GetV1TeamsIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/teams/${request['id']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1TeamsId: Api['getV1TeamsId'] = async (request: Types.GetV1TeamsIdRequest): Promise<Types.GetV1TeamsIdResponses> => {
  return await _getV1TeamsId(baseUrl, request)
}
const _putV1TeamsId = async (url: string, request: Types.PutV1TeamsIdRequest): Promise<Types.PutV1TeamsIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/teams/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1TeamsId: Api['putV1TeamsId'] = async (request: Types.PutV1TeamsIdRequest): Promise<Types.PutV1TeamsIdResponses> => {
  return await _putV1TeamsId(baseUrl, request)
}
const _deleteV1TeamsId = async (url: string, request: Types.DeleteV1TeamsIdRequest): Promise<Types.DeleteV1TeamsIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/teams/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1TeamsId: Api['deleteV1TeamsId'] = async (request: Types.DeleteV1TeamsIdRequest): Promise<Types.DeleteV1TeamsIdResponses> => {
  return await _deleteV1TeamsId(baseUrl, request)
}
const _postV1Skills = async (url: string, request: Types.PostV1SkillsRequest): Promise<Types.PostV1SkillsResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/skills/`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1Skills: Api['postV1Skills'] = async (request: Types.PostV1SkillsRequest): Promise<Types.PostV1SkillsResponses> => {
  return await _postV1Skills(baseUrl, request)
}
const _getV1Skills = async (url: string, request: Types.GetV1SkillsRequest): Promise<Types.GetV1SkillsResponses> => {
  const queryParameters: (keyof Types.GetV1SkillsRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/skills/?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1Skills: Api['getV1Skills'] = async (request: Types.GetV1SkillsRequest): Promise<Types.GetV1SkillsResponses> => {
  return await _getV1Skills(baseUrl, request)
}
const _getV1SkillsId = async (url: string, request: Types.GetV1SkillsIdRequest): Promise<Types.GetV1SkillsIdResponses> => {
  const queryParameters: (keyof Types.GetV1SkillsIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/skills/${request['id']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1SkillsId: Api['getV1SkillsId'] = async (request: Types.GetV1SkillsIdRequest): Promise<Types.GetV1SkillsIdResponses> => {
  return await _getV1SkillsId(baseUrl, request)
}
const _putV1SkillsId = async (url: string, request: Types.PutV1SkillsIdRequest): Promise<Types.PutV1SkillsIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/skills/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1SkillsId: Api['putV1SkillsId'] = async (request: Types.PutV1SkillsIdRequest): Promise<Types.PutV1SkillsIdResponses> => {
  return await _putV1SkillsId(baseUrl, request)
}
const _deleteV1SkillsId = async (url: string, request: Types.DeleteV1SkillsIdRequest): Promise<Types.DeleteV1SkillsIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/skills/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1SkillsId: Api['deleteV1SkillsId'] = async (request: Types.DeleteV1SkillsIdRequest): Promise<Types.DeleteV1SkillsIdResponses> => {
  return await _deleteV1SkillsId(baseUrl, request)
}
const _postV1Designation = async (url: string, request: Types.PostV1DesignationRequest): Promise<Types.PostV1DesignationResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/designation/`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1Designation: Api['postV1Designation'] = async (request: Types.PostV1DesignationRequest): Promise<Types.PostV1DesignationResponses> => {
  return await _postV1Designation(baseUrl, request)
}
const _getV1Designation = async (url: string, request: Types.GetV1DesignationRequest): Promise<Types.GetV1DesignationResponses> => {
  const queryParameters: (keyof Types.GetV1DesignationRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/designation/?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1Designation: Api['getV1Designation'] = async (request: Types.GetV1DesignationRequest): Promise<Types.GetV1DesignationResponses> => {
  return await _getV1Designation(baseUrl, request)
}
const _getV1DesignationId = async (url: string, request: Types.GetV1DesignationIdRequest): Promise<Types.GetV1DesignationIdResponses> => {
  const queryParameters: (keyof Types.GetV1DesignationIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/designation/${request['id']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1DesignationId: Api['getV1DesignationId'] = async (request: Types.GetV1DesignationIdRequest): Promise<Types.GetV1DesignationIdResponses> => {
  return await _getV1DesignationId(baseUrl, request)
}
const _putV1DesignationId = async (url: string, request: Types.PutV1DesignationIdRequest): Promise<Types.PutV1DesignationIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/designation/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1DesignationId: Api['putV1DesignationId'] = async (request: Types.PutV1DesignationIdRequest): Promise<Types.PutV1DesignationIdResponses> => {
  return await _putV1DesignationId(baseUrl, request)
}
const _deleteV1DesignationId = async (url: string, request: Types.DeleteV1DesignationIdRequest): Promise<Types.DeleteV1DesignationIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/designation/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1DesignationId: Api['deleteV1DesignationId'] = async (request: Types.DeleteV1DesignationIdRequest): Promise<Types.DeleteV1DesignationIdResponses> => {
  return await _deleteV1DesignationId(baseUrl, request)
}
const _postV1DesignationDraft = async (url: string, request: Types.PostV1DesignationDraftRequest): Promise<Types.PostV1DesignationDraftResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/designation/draft`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1DesignationDraft: Api['postV1DesignationDraft'] = async (request: Types.PostV1DesignationDraftRequest): Promise<Types.PostV1DesignationDraftResponses> => {
  return await _postV1DesignationDraft(baseUrl, request)
}
const _postV1Departments = async (url: string, request: Types.PostV1DepartmentsRequest): Promise<Types.PostV1DepartmentsResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/departments/`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1Departments: Api['postV1Departments'] = async (request: Types.PostV1DepartmentsRequest): Promise<Types.PostV1DepartmentsResponses> => {
  return await _postV1Departments(baseUrl, request)
}
const _getV1Departments = async (url: string, request: Types.GetV1DepartmentsRequest): Promise<Types.GetV1DepartmentsResponses> => {
  const queryParameters: (keyof Types.GetV1DepartmentsRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/departments/?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1Departments: Api['getV1Departments'] = async (request: Types.GetV1DepartmentsRequest): Promise<Types.GetV1DepartmentsResponses> => {
  return await _getV1Departments(baseUrl, request)
}
const _getV1DepartmentsGenerateExcel = async (url: string, request: Types.GetV1DepartmentsGenerateExcelRequest): Promise<Types.GetV1DepartmentsGenerateExcelResponses> => {
  const queryParameters: (keyof Types.GetV1DepartmentsGenerateExcelRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['Content-Type'] !== undefined) {
    headers['Content-Type'] = request['Content-Type']
    delete request['Content-Type']
  }

  const response = await fetch(`${url}/v1/departments/generate-excel?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1DepartmentsGenerateExcel: Api['getV1DepartmentsGenerateExcel'] = async (request: Types.GetV1DepartmentsGenerateExcelRequest): Promise<Types.GetV1DepartmentsGenerateExcelResponses> => {
  return await _getV1DepartmentsGenerateExcel(baseUrl, request)
}
const _getV1DepartmentsId = async (url: string, request: Types.GetV1DepartmentsIdRequest): Promise<Types.GetV1DepartmentsIdResponses> => {
  const queryParameters: (keyof Types.GetV1DepartmentsIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/departments/${request['id']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1DepartmentsId: Api['getV1DepartmentsId'] = async (request: Types.GetV1DepartmentsIdRequest): Promise<Types.GetV1DepartmentsIdResponses> => {
  return await _getV1DepartmentsId(baseUrl, request)
}
const _patchV1DepartmentsId = async (url: string, request: Types.PatchV1DepartmentsIdRequest): Promise<Types.PatchV1DepartmentsIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/departments/${request['id']}`, {
    method: 'PATCH',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const patchV1DepartmentsId: Api['patchV1DepartmentsId'] = async (request: Types.PatchV1DepartmentsIdRequest): Promise<Types.PatchV1DepartmentsIdResponses> => {
  return await _patchV1DepartmentsId(baseUrl, request)
}
const _putV1DepartmentsId = async (url: string, request: Types.PutV1DepartmentsIdRequest): Promise<Types.PutV1DepartmentsIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/departments/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1DepartmentsId: Api['putV1DepartmentsId'] = async (request: Types.PutV1DepartmentsIdRequest): Promise<Types.PutV1DepartmentsIdResponses> => {
  return await _putV1DepartmentsId(baseUrl, request)
}
const _deleteV1DepartmentsId = async (url: string, request: Types.DeleteV1DepartmentsIdRequest): Promise<Types.DeleteV1DepartmentsIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/departments/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1DepartmentsId: Api['deleteV1DepartmentsId'] = async (request: Types.DeleteV1DepartmentsIdRequest): Promise<Types.DeleteV1DepartmentsIdResponses> => {
  return await _deleteV1DepartmentsId(baseUrl, request)
}
const _getV1DepartmentsIdSubDepartments = async (url: string, request: Types.GetV1DepartmentsIdSubDepartmentsRequest): Promise<Types.GetV1DepartmentsIdSubDepartmentsResponses> => {
  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/departments/${request['id']}/sub-departments`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1DepartmentsIdSubDepartments: Api['getV1DepartmentsIdSubDepartments'] = async (request: Types.GetV1DepartmentsIdSubDepartmentsRequest): Promise<Types.GetV1DepartmentsIdSubDepartmentsResponses> => {
  return await _getV1DepartmentsIdSubDepartments(baseUrl, request)
}
const _getV1DepartmentsIdTeams = async (url: string, request: Types.GetV1DepartmentsIdTeamsRequest): Promise<Types.GetV1DepartmentsIdTeamsResponses> => {
  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/departments/${request['id']}/teams`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1DepartmentsIdTeams: Api['getV1DepartmentsIdTeams'] = async (request: Types.GetV1DepartmentsIdTeamsRequest): Promise<Types.GetV1DepartmentsIdTeamsResponses> => {
  return await _getV1DepartmentsIdTeams(baseUrl, request)
}
const _postV1DepartmentsTeams = async (url: string, request: Types.PostV1DepartmentsTeamsRequest): Promise<Types.PostV1DepartmentsTeamsResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/departments/teams`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1DepartmentsTeams: Api['postV1DepartmentsTeams'] = async (request: Types.PostV1DepartmentsTeamsRequest): Promise<Types.PostV1DepartmentsTeamsResponses> => {
  return await _postV1DepartmentsTeams(baseUrl, request)
}
const _patchV1DepartmentsTeamsId = async (url: string, request: Types.PatchV1DepartmentsTeamsIdRequest): Promise<Types.PatchV1DepartmentsTeamsIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/departments/teams/${request['id']}`, {
    method: 'PATCH',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const patchV1DepartmentsTeamsId: Api['patchV1DepartmentsTeamsId'] = async (request: Types.PatchV1DepartmentsTeamsIdRequest): Promise<Types.PatchV1DepartmentsTeamsIdResponses> => {
  return await _patchV1DepartmentsTeamsId(baseUrl, request)
}
const _deleteV1DepartmentsTeamsId = async (url: string, request: Types.DeleteV1DepartmentsTeamsIdRequest): Promise<Types.DeleteV1DepartmentsTeamsIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/departments/teams/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1DepartmentsTeamsId: Api['deleteV1DepartmentsTeamsId'] = async (request: Types.DeleteV1DepartmentsTeamsIdRequest): Promise<Types.DeleteV1DepartmentsTeamsIdResponses> => {
  return await _deleteV1DepartmentsTeamsId(baseUrl, request)
}
const _getV1DepartmentsCheckCode = async (url: string, request: Types.GetV1DepartmentsCheckCodeRequest): Promise<Types.GetV1DepartmentsCheckCodeResponses> => {
  const queryParameters: (keyof Types.GetV1DepartmentsCheckCodeRequest)[]  = ['company_id', 'department_code', 'exclude_id']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/departments/check-code?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1DepartmentsCheckCode: Api['getV1DepartmentsCheckCode'] = async (request: Types.GetV1DepartmentsCheckCodeRequest): Promise<Types.GetV1DepartmentsCheckCodeResponses> => {
  return await _getV1DepartmentsCheckCode(baseUrl, request)
}
const _postV1DepartmentsImport = async (url: string, request: Types.PostV1DepartmentsImportRequest): Promise<Types.PostV1DepartmentsImportResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/departments/import`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1DepartmentsImport: Api['postV1DepartmentsImport'] = async (request: Types.PostV1DepartmentsImportRequest): Promise<Types.PostV1DepartmentsImportResponses> => {
  return await _postV1DepartmentsImport(baseUrl, request)
}
const _postV1DepartmentsDraft = async (url: string, request: Types.PostV1DepartmentsDraftRequest): Promise<Types.PostV1DepartmentsDraftResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/departments/draft`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1DepartmentsDraft: Api['postV1DepartmentsDraft'] = async (request: Types.PostV1DepartmentsDraftRequest): Promise<Types.PostV1DepartmentsDraftResponses> => {
  return await _postV1DepartmentsDraft(baseUrl, request)
}
const _postV1Timezones = async (url: string, request: Types.PostV1TimezonesRequest): Promise<Types.PostV1TimezonesResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/timezones/`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1Timezones: Api['postV1Timezones'] = async (request: Types.PostV1TimezonesRequest): Promise<Types.PostV1TimezonesResponses> => {
  return await _postV1Timezones(baseUrl, request)
}
const _getV1Timezones = async (url: string, request: Types.GetV1TimezonesRequest): Promise<Types.GetV1TimezonesResponses> => {
  const queryParameters: (keyof Types.GetV1TimezonesRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/timezones/?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1Timezones: Api['getV1Timezones'] = async (request: Types.GetV1TimezonesRequest): Promise<Types.GetV1TimezonesResponses> => {
  return await _getV1Timezones(baseUrl, request)
}
const _getV1TimezonesId = async (url: string, request: Types.GetV1TimezonesIdRequest): Promise<Types.GetV1TimezonesIdResponses> => {
  const queryParameters: (keyof Types.GetV1TimezonesIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/timezones/${request['id']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1TimezonesId: Api['getV1TimezonesId'] = async (request: Types.GetV1TimezonesIdRequest): Promise<Types.GetV1TimezonesIdResponses> => {
  return await _getV1TimezonesId(baseUrl, request)
}
const _putV1TimezonesId = async (url: string, request: Types.PutV1TimezonesIdRequest): Promise<Types.PutV1TimezonesIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/timezones/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1TimezonesId: Api['putV1TimezonesId'] = async (request: Types.PutV1TimezonesIdRequest): Promise<Types.PutV1TimezonesIdResponses> => {
  return await _putV1TimezonesId(baseUrl, request)
}
const _deleteV1TimezonesId = async (url: string, request: Types.DeleteV1TimezonesIdRequest): Promise<Types.DeleteV1TimezonesIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/timezones/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1TimezonesId: Api['deleteV1TimezonesId'] = async (request: Types.DeleteV1TimezonesIdRequest): Promise<Types.DeleteV1TimezonesIdResponses> => {
  return await _deleteV1TimezonesId(baseUrl, request)
}
const _postV1SalaryStructureMaster = async (url: string, request: Types.PostV1SalaryStructureMasterRequest): Promise<Types.PostV1SalaryStructureMasterResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/salary-structure-master/`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1SalaryStructureMaster: Api['postV1SalaryStructureMaster'] = async (request: Types.PostV1SalaryStructureMasterRequest): Promise<Types.PostV1SalaryStructureMasterResponses> => {
  return await _postV1SalaryStructureMaster(baseUrl, request)
}
const _getV1SalaryStructureMaster = async (url: string, request: Types.GetV1SalaryStructureMasterRequest): Promise<Types.GetV1SalaryStructureMasterResponses> => {
  const queryParameters: (keyof Types.GetV1SalaryStructureMasterRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/salary-structure-master/?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1SalaryStructureMaster: Api['getV1SalaryStructureMaster'] = async (request: Types.GetV1SalaryStructureMasterRequest): Promise<Types.GetV1SalaryStructureMasterResponses> => {
  return await _getV1SalaryStructureMaster(baseUrl, request)
}
const _getV1SalaryStructureMasterId = async (url: string, request: Types.GetV1SalaryStructureMasterIdRequest): Promise<Types.GetV1SalaryStructureMasterIdResponses> => {
  const queryParameters: (keyof Types.GetV1SalaryStructureMasterIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/salary-structure-master/${request['id']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1SalaryStructureMasterId: Api['getV1SalaryStructureMasterId'] = async (request: Types.GetV1SalaryStructureMasterIdRequest): Promise<Types.GetV1SalaryStructureMasterIdResponses> => {
  return await _getV1SalaryStructureMasterId(baseUrl, request)
}
const _putV1SalaryStructureMasterId = async (url: string, request: Types.PutV1SalaryStructureMasterIdRequest): Promise<Types.PutV1SalaryStructureMasterIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/salary-structure-master/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1SalaryStructureMasterId: Api['putV1SalaryStructureMasterId'] = async (request: Types.PutV1SalaryStructureMasterIdRequest): Promise<Types.PutV1SalaryStructureMasterIdResponses> => {
  return await _putV1SalaryStructureMasterId(baseUrl, request)
}
const _deleteV1SalaryStructureMasterId = async (url: string, request: Types.DeleteV1SalaryStructureMasterIdRequest): Promise<Types.DeleteV1SalaryStructureMasterIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/salary-structure-master/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1SalaryStructureMasterId: Api['deleteV1SalaryStructureMasterId'] = async (request: Types.DeleteV1SalaryStructureMasterIdRequest): Promise<Types.DeleteV1SalaryStructureMasterIdResponses> => {
  return await _deleteV1SalaryStructureMasterId(baseUrl, request)
}
const _patchV1SalaryStructureMasterIdStatus = async (url: string, request: Types.PatchV1SalaryStructureMasterIdStatusRequest): Promise<Types.PatchV1SalaryStructureMasterIdStatusResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/salary-structure-master/${request['id']}/status`, {
    method: 'PATCH',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const patchV1SalaryStructureMasterIdStatus: Api['patchV1SalaryStructureMasterIdStatus'] = async (request: Types.PatchV1SalaryStructureMasterIdStatusRequest): Promise<Types.PatchV1SalaryStructureMasterIdStatusResponses> => {
  return await _patchV1SalaryStructureMasterIdStatus(baseUrl, request)
}
const _postV1SalaryStructureMasterSaveAsDraft = async (url: string, request: Types.PostV1SalaryStructureMasterSaveAsDraftRequest): Promise<Types.PostV1SalaryStructureMasterSaveAsDraftResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/salary-structure-master/save-as-draft`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1SalaryStructureMasterSaveAsDraft: Api['postV1SalaryStructureMasterSaveAsDraft'] = async (request: Types.PostV1SalaryStructureMasterSaveAsDraftRequest): Promise<Types.PostV1SalaryStructureMasterSaveAsDraftResponses> => {
  return await _postV1SalaryStructureMasterSaveAsDraft(baseUrl, request)
}
const _patchV1SalaryStructureMasterIdSaveAsDraft = async (url: string, request: Types.PatchV1SalaryStructureMasterIdSaveAsDraftRequest): Promise<Types.PatchV1SalaryStructureMasterIdSaveAsDraftResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/salary-structure-master/${request['id']}/save-as-draft`, {
    method: 'PATCH',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const patchV1SalaryStructureMasterIdSaveAsDraft: Api['patchV1SalaryStructureMasterIdSaveAsDraft'] = async (request: Types.PatchV1SalaryStructureMasterIdSaveAsDraftRequest): Promise<Types.PatchV1SalaryStructureMasterIdSaveAsDraftResponses> => {
  return await _patchV1SalaryStructureMasterIdSaveAsDraft(baseUrl, request)
}
const _postV1SalaryStructureMasterCalculate = async (url: string, request: Types.PostV1SalaryStructureMasterCalculateRequest): Promise<Types.PostV1SalaryStructureMasterCalculateResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/salary-structure-master/calculate`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1SalaryStructureMasterCalculate: Api['postV1SalaryStructureMasterCalculate'] = async (request: Types.PostV1SalaryStructureMasterCalculateRequest): Promise<Types.PostV1SalaryStructureMasterCalculateResponses> => {
  return await _postV1SalaryStructureMasterCalculate(baseUrl, request)
}
const _getV1SalaryStructureMasterGenerateExcel = async (url: string, request: Types.GetV1SalaryStructureMasterGenerateExcelRequest): Promise<Types.GetV1SalaryStructureMasterGenerateExcelResponses> => {
  const queryParameters: (keyof Types.GetV1SalaryStructureMasterGenerateExcelRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['Content-Type'] !== undefined) {
    headers['Content-Type'] = request['Content-Type']
    delete request['Content-Type']
  }

  const response = await fetch(`${url}/v1/salary-structure-master/generate-excel?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1SalaryStructureMasterGenerateExcel: Api['getV1SalaryStructureMasterGenerateExcel'] = async (request: Types.GetV1SalaryStructureMasterGenerateExcelRequest): Promise<Types.GetV1SalaryStructureMasterGenerateExcelResponses> => {
  return await _getV1SalaryStructureMasterGenerateExcel(baseUrl, request)
}
const _postV1SalaryStructureMasterImport = async (url: string, request: Types.PostV1SalaryStructureMasterImportRequest): Promise<Types.PostV1SalaryStructureMasterImportResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/salary-structure-master/import`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1SalaryStructureMasterImport: Api['postV1SalaryStructureMasterImport'] = async (request: Types.PostV1SalaryStructureMasterImportRequest): Promise<Types.PostV1SalaryStructureMasterImportResponses> => {
  return await _postV1SalaryStructureMasterImport(baseUrl, request)
}
const _postV1Employee = async (url: string, request: Types.PostV1EmployeeRequest): Promise<Types.PostV1EmployeeResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/employee/`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1Employee: Api['postV1Employee'] = async (request: Types.PostV1EmployeeRequest): Promise<Types.PostV1EmployeeResponses> => {
  return await _postV1Employee(baseUrl, request)
}
const _getV1Employee = async (url: string, request: Types.GetV1EmployeeRequest): Promise<Types.GetV1EmployeeResponses> => {
  const queryParameters: (keyof Types.GetV1EmployeeRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/employee/?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1Employee: Api['getV1Employee'] = async (request: Types.GetV1EmployeeRequest): Promise<Types.GetV1EmployeeResponses> => {
  return await _getV1Employee(baseUrl, request)
}
const _getV1EmployeeId = async (url: string, request: Types.GetV1EmployeeIdRequest): Promise<Types.GetV1EmployeeIdResponses> => {
  const queryParameters: (keyof Types.GetV1EmployeeIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/employee/${request['id']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1EmployeeId: Api['getV1EmployeeId'] = async (request: Types.GetV1EmployeeIdRequest): Promise<Types.GetV1EmployeeIdResponses> => {
  return await _getV1EmployeeId(baseUrl, request)
}
const _putV1EmployeeId = async (url: string, request: Types.PutV1EmployeeIdRequest): Promise<Types.PutV1EmployeeIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/employee/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1EmployeeId: Api['putV1EmployeeId'] = async (request: Types.PutV1EmployeeIdRequest): Promise<Types.PutV1EmployeeIdResponses> => {
  return await _putV1EmployeeId(baseUrl, request)
}
const _deleteV1EmployeeId = async (url: string, request: Types.DeleteV1EmployeeIdRequest): Promise<Types.DeleteV1EmployeeIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/employee/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1EmployeeId: Api['deleteV1EmployeeId'] = async (request: Types.DeleteV1EmployeeIdRequest): Promise<Types.DeleteV1EmployeeIdResponses> => {
  return await _deleteV1EmployeeId(baseUrl, request)
}
const _patchV1EmployeeIdStatus = async (url: string, request: Types.PatchV1EmployeeIdStatusRequest): Promise<Types.PatchV1EmployeeIdStatusResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/employee/${request['id']}/status`, {
    method: 'PATCH',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const patchV1EmployeeIdStatus: Api['patchV1EmployeeIdStatus'] = async (request: Types.PatchV1EmployeeIdStatusRequest): Promise<Types.PatchV1EmployeeIdStatusResponses> => {
  return await _patchV1EmployeeIdStatus(baseUrl, request)
}
const _postV1EmployeeSaveAsDraft = async (url: string, request: Types.PostV1EmployeeSaveAsDraftRequest): Promise<Types.PostV1EmployeeSaveAsDraftResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/employee/save-as-draft`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1EmployeeSaveAsDraft: Api['postV1EmployeeSaveAsDraft'] = async (request: Types.PostV1EmployeeSaveAsDraftRequest): Promise<Types.PostV1EmployeeSaveAsDraftResponses> => {
  return await _postV1EmployeeSaveAsDraft(baseUrl, request)
}
const _patchV1EmployeeIdSaveAsDraft = async (url: string, request: Types.PatchV1EmployeeIdSaveAsDraftRequest): Promise<Types.PatchV1EmployeeIdSaveAsDraftResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/employee/${request['id']}/save-as-draft`, {
    method: 'PATCH',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const patchV1EmployeeIdSaveAsDraft: Api['patchV1EmployeeIdSaveAsDraft'] = async (request: Types.PatchV1EmployeeIdSaveAsDraftRequest): Promise<Types.PatchV1EmployeeIdSaveAsDraftResponses> => {
  return await _patchV1EmployeeIdSaveAsDraft(baseUrl, request)
}
const _getV1EmployeeIdContracts = async (url: string, request: Types.GetV1EmployeeIdContractsRequest): Promise<Types.GetV1EmployeeIdContractsResponses> => {
  const queryParameters: (keyof Types.GetV1EmployeeIdContractsRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/employee/${request['id']}/contracts?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1EmployeeIdContracts: Api['getV1EmployeeIdContracts'] = async (request: Types.GetV1EmployeeIdContractsRequest): Promise<Types.GetV1EmployeeIdContractsResponses> => {
  return await _getV1EmployeeIdContracts(baseUrl, request)
}
const _getV1EmployeeIdContractsContractId = async (url: string, request: Types.GetV1EmployeeIdContractsContractIdRequest): Promise<Types.GetV1EmployeeIdContractsContractIdResponses> => {
  const queryParameters: (keyof Types.GetV1EmployeeIdContractsContractIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/employee/${request['id']}/contracts/${request['contract_id']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1EmployeeIdContractsContractId: Api['getV1EmployeeIdContractsContractId'] = async (request: Types.GetV1EmployeeIdContractsContractIdRequest): Promise<Types.GetV1EmployeeIdContractsContractIdResponses> => {
  return await _getV1EmployeeIdContractsContractId(baseUrl, request)
}
const _getV1EmployeeGenerateExcel = async (url: string, request: Types.GetV1EmployeeGenerateExcelRequest): Promise<Types.GetV1EmployeeGenerateExcelResponses> => {
  const queryParameters: (keyof Types.GetV1EmployeeGenerateExcelRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['Content-Type'] !== undefined) {
    headers['Content-Type'] = request['Content-Type']
    delete request['Content-Type']
  }

  const response = await fetch(`${url}/v1/employee/generate-excel?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1EmployeeGenerateExcel: Api['getV1EmployeeGenerateExcel'] = async (request: Types.GetV1EmployeeGenerateExcelRequest): Promise<Types.GetV1EmployeeGenerateExcelResponses> => {
  return await _getV1EmployeeGenerateExcel(baseUrl, request)
}
const _postV1EmployeeImport = async (url: string, request: Types.PostV1EmployeeImportRequest): Promise<Types.PostV1EmployeeImportResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/employee/import`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1EmployeeImport: Api['postV1EmployeeImport'] = async (request: Types.PostV1EmployeeImportRequest): Promise<Types.PostV1EmployeeImportResponses> => {
  return await _postV1EmployeeImport(baseUrl, request)
}
const _postV1EmployeeContracts = async (url: string, request: Types.PostV1EmployeeContractsRequest): Promise<Types.PostV1EmployeeContractsResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/employee-contracts/`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1EmployeeContracts: Api['postV1EmployeeContracts'] = async (request: Types.PostV1EmployeeContractsRequest): Promise<Types.PostV1EmployeeContractsResponses> => {
  return await _postV1EmployeeContracts(baseUrl, request)
}
const _getV1EmployeeContracts = async (url: string, request: Types.GetV1EmployeeContractsRequest): Promise<Types.GetV1EmployeeContractsResponses> => {
  const queryParameters: (keyof Types.GetV1EmployeeContractsRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/employee-contracts/?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1EmployeeContracts: Api['getV1EmployeeContracts'] = async (request: Types.GetV1EmployeeContractsRequest): Promise<Types.GetV1EmployeeContractsResponses> => {
  return await _getV1EmployeeContracts(baseUrl, request)
}
const _getV1EmployeeContractsId = async (url: string, request: Types.GetV1EmployeeContractsIdRequest): Promise<Types.GetV1EmployeeContractsIdResponses> => {
  const queryParameters: (keyof Types.GetV1EmployeeContractsIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/employee-contracts/${request['id']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1EmployeeContractsId: Api['getV1EmployeeContractsId'] = async (request: Types.GetV1EmployeeContractsIdRequest): Promise<Types.GetV1EmployeeContractsIdResponses> => {
  return await _getV1EmployeeContractsId(baseUrl, request)
}
const _putV1EmployeeContractsId = async (url: string, request: Types.PutV1EmployeeContractsIdRequest): Promise<Types.PutV1EmployeeContractsIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/employee-contracts/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1EmployeeContractsId: Api['putV1EmployeeContractsId'] = async (request: Types.PutV1EmployeeContractsIdRequest): Promise<Types.PutV1EmployeeContractsIdResponses> => {
  return await _putV1EmployeeContractsId(baseUrl, request)
}
const _deleteV1EmployeeContractsId = async (url: string, request: Types.DeleteV1EmployeeContractsIdRequest): Promise<Types.DeleteV1EmployeeContractsIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/employee-contracts/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1EmployeeContractsId: Api['deleteV1EmployeeContractsId'] = async (request: Types.DeleteV1EmployeeContractsIdRequest): Promise<Types.DeleteV1EmployeeContractsIdResponses> => {
  return await _deleteV1EmployeeContractsId(baseUrl, request)
}
const _patchV1EmployeeContractsIdStatus = async (url: string, request: Types.PatchV1EmployeeContractsIdStatusRequest): Promise<Types.PatchV1EmployeeContractsIdStatusResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/employee-contracts/${request['id']}/status`, {
    method: 'PATCH',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const patchV1EmployeeContractsIdStatus: Api['patchV1EmployeeContractsIdStatus'] = async (request: Types.PatchV1EmployeeContractsIdStatusRequest): Promise<Types.PatchV1EmployeeContractsIdStatusResponses> => {
  return await _patchV1EmployeeContractsIdStatus(baseUrl, request)
}
const _getV1EmployeeContractsExportExcel = async (url: string, request: Types.GetV1EmployeeContractsExportExcelRequest): Promise<Types.GetV1EmployeeContractsExportExcelResponses> => {
  const queryParameters: (keyof Types.GetV1EmployeeContractsExportExcelRequest)[]  = ['filters', 'search', 'order', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/employee-contracts/export/excel?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1EmployeeContractsExportExcel: Api['getV1EmployeeContractsExportExcel'] = async (request: Types.GetV1EmployeeContractsExportExcelRequest): Promise<Types.GetV1EmployeeContractsExportExcelResponses> => {
  return await _getV1EmployeeContractsExportExcel(baseUrl, request)
}
const _postV1HireRequests = async (url: string, request: Types.PostV1HireRequestsRequest): Promise<Types.PostV1HireRequestsResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/hire-requests/`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1HireRequests: Api['postV1HireRequests'] = async (request: Types.PostV1HireRequestsRequest): Promise<Types.PostV1HireRequestsResponses> => {
  return await _postV1HireRequests(baseUrl, request)
}
const _getV1HireRequests = async (url: string, request: Types.GetV1HireRequestsRequest): Promise<Types.GetV1HireRequestsResponses> => {
  const queryParameters: (keyof Types.GetV1HireRequestsRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/hire-requests/?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1HireRequests: Api['getV1HireRequests'] = async (request: Types.GetV1HireRequestsRequest): Promise<Types.GetV1HireRequestsResponses> => {
  return await _getV1HireRequests(baseUrl, request)
}
const _getV1HireRequestsRequisitionManagement = async (url: string, request: Types.GetV1HireRequestsRequisitionManagementRequest): Promise<Types.GetV1HireRequestsRequisitionManagementResponses> => {
  const queryParameters: (keyof Types.GetV1HireRequestsRequisitionManagementRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/hire-requests/requisition-management?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1HireRequestsRequisitionManagement: Api['getV1HireRequestsRequisitionManagement'] = async (request: Types.GetV1HireRequestsRequisitionManagementRequest): Promise<Types.GetV1HireRequestsRequisitionManagementResponses> => {
  return await _getV1HireRequestsRequisitionManagement(baseUrl, request)
}
const _getV1HireRequestsIdCandidatesByStage = async (url: string, request: Types.GetV1HireRequestsIdCandidatesByStageRequest): Promise<Types.GetV1HireRequestsIdCandidatesByStageResponses> => {
  const queryParameters: (keyof Types.GetV1HireRequestsIdCandidatesByStageRequest)[]  = ['stage', 'limit', 'skip']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/hire-requests/${request['id']}/candidates-by-stage?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1HireRequestsIdCandidatesByStage: Api['getV1HireRequestsIdCandidatesByStage'] = async (request: Types.GetV1HireRequestsIdCandidatesByStageRequest): Promise<Types.GetV1HireRequestsIdCandidatesByStageResponses> => {
  return await _getV1HireRequestsIdCandidatesByStage(baseUrl, request)
}
const _getV1HireRequestsId = async (url: string, request: Types.GetV1HireRequestsIdRequest): Promise<Types.GetV1HireRequestsIdResponses> => {
  const queryParameters: (keyof Types.GetV1HireRequestsIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/hire-requests/${request['id']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1HireRequestsId: Api['getV1HireRequestsId'] = async (request: Types.GetV1HireRequestsIdRequest): Promise<Types.GetV1HireRequestsIdResponses> => {
  return await _getV1HireRequestsId(baseUrl, request)
}
const _putV1HireRequestsId = async (url: string, request: Types.PutV1HireRequestsIdRequest): Promise<Types.PutV1HireRequestsIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/hire-requests/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1HireRequestsId: Api['putV1HireRequestsId'] = async (request: Types.PutV1HireRequestsIdRequest): Promise<Types.PutV1HireRequestsIdResponses> => {
  return await _putV1HireRequestsId(baseUrl, request)
}
const _deleteV1HireRequestsId = async (url: string, request: Types.DeleteV1HireRequestsIdRequest): Promise<Types.DeleteV1HireRequestsIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/hire-requests/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1HireRequestsId: Api['deleteV1HireRequestsId'] = async (request: Types.DeleteV1HireRequestsIdRequest): Promise<Types.DeleteV1HireRequestsIdResponses> => {
  return await _deleteV1HireRequestsId(baseUrl, request)
}
const _patchV1HireRequestsIdStatus = async (url: string, request: Types.PatchV1HireRequestsIdStatusRequest): Promise<Types.PatchV1HireRequestsIdStatusResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/hire-requests/${request['id']}/status`, {
    method: 'PATCH',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const patchV1HireRequestsIdStatus: Api['patchV1HireRequestsIdStatus'] = async (request: Types.PatchV1HireRequestsIdStatusRequest): Promise<Types.PatchV1HireRequestsIdStatusResponses> => {
  return await _patchV1HireRequestsIdStatus(baseUrl, request)
}
const _postV1HireRequestsSaveAsDraft = async (url: string, request: Types.PostV1HireRequestsSaveAsDraftRequest): Promise<Types.PostV1HireRequestsSaveAsDraftResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/hire-requests/save-as-draft`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1HireRequestsSaveAsDraft: Api['postV1HireRequestsSaveAsDraft'] = async (request: Types.PostV1HireRequestsSaveAsDraftRequest): Promise<Types.PostV1HireRequestsSaveAsDraftResponses> => {
  return await _postV1HireRequestsSaveAsDraft(baseUrl, request)
}
const _patchV1HireRequestsIdSaveAsDraft = async (url: string, request: Types.PatchV1HireRequestsIdSaveAsDraftRequest): Promise<Types.PatchV1HireRequestsIdSaveAsDraftResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/hire-requests/${request['id']}/save-as-draft`, {
    method: 'PATCH',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const patchV1HireRequestsIdSaveAsDraft: Api['patchV1HireRequestsIdSaveAsDraft'] = async (request: Types.PatchV1HireRequestsIdSaveAsDraftRequest): Promise<Types.PatchV1HireRequestsIdSaveAsDraftResponses> => {
  return await _patchV1HireRequestsIdSaveAsDraft(baseUrl, request)
}
const _getV1HireRequestsGenerateExcel = async (url: string, request: Types.GetV1HireRequestsGenerateExcelRequest): Promise<Types.GetV1HireRequestsGenerateExcelResponses> => {
  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/hire-requests/generate-excel`, {
    headers
  })

  const textResponses = [200]
  if (textResponses.includes(response.status)) {
    return {
      statusCode: response.status as 200,
      headers: headersToJSON(response.headers),
      body: await response.text()
    }
  }
  if (response.headers.get('content-type') === 'application/json') {
    return {
      statusCode: response.status as 200,
      headers: headersToJSON(response.headers),
      body: await response.json() as any
    }
  }
  return {
    statusCode: response.status as 200,
    headers: headersToJSON(response.headers),
    body: await response.text() as any
  }
}

export const getV1HireRequestsGenerateExcel: Api['getV1HireRequestsGenerateExcel'] = async (request: Types.GetV1HireRequestsGenerateExcelRequest): Promise<Types.GetV1HireRequestsGenerateExcelResponses> => {
  return await _getV1HireRequestsGenerateExcel(baseUrl, request)
}
const _postV1HireRequestsImport = async (url: string, request: Types.PostV1HireRequestsImportRequest): Promise<Types.PostV1HireRequestsImportResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/hire-requests/import`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  const textResponses = [200]
  if (textResponses.includes(response.status)) {
    return {
      statusCode: response.status as 200,
      headers: headersToJSON(response.headers),
      body: await response.text()
    }
  }
  if (response.headers.get('content-type') === 'application/json') {
    return {
      statusCode: response.status as 200,
      headers: headersToJSON(response.headers),
      body: await response.json() as any
    }
  }
  return {
    statusCode: response.status as 200,
    headers: headersToJSON(response.headers),
    body: await response.text() as any
  }
}

export const postV1HireRequestsImport: Api['postV1HireRequestsImport'] = async (request: Types.PostV1HireRequestsImportRequest): Promise<Types.PostV1HireRequestsImportResponses> => {
  return await _postV1HireRequestsImport(baseUrl, request)
}
const _postV1HireRequestsHireRequestIdBudgets = async (url: string, request: Types.PostV1HireRequestsHireRequestIdBudgetsRequest): Promise<Types.PostV1HireRequestsHireRequestIdBudgetsResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/hire-requests/${request['hire_request_id']}/budgets`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1HireRequestsHireRequestIdBudgets: Api['postV1HireRequestsHireRequestIdBudgets'] = async (request: Types.PostV1HireRequestsHireRequestIdBudgetsRequest): Promise<Types.PostV1HireRequestsHireRequestIdBudgetsResponses> => {
  return await _postV1HireRequestsHireRequestIdBudgets(baseUrl, request)
}
const _putV1HireRequestsHireRequestIdBudgetsId = async (url: string, request: Types.PutV1HireRequestsHireRequestIdBudgetsIdRequest): Promise<Types.PutV1HireRequestsHireRequestIdBudgetsIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/hire-requests/${request['hire_request_id']}/budgets/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1HireRequestsHireRequestIdBudgetsId: Api['putV1HireRequestsHireRequestIdBudgetsId'] = async (request: Types.PutV1HireRequestsHireRequestIdBudgetsIdRequest): Promise<Types.PutV1HireRequestsHireRequestIdBudgetsIdResponses> => {
  return await _putV1HireRequestsHireRequestIdBudgetsId(baseUrl, request)
}
const _postV1JobPosts = async (url: string, request: Types.PostV1JobPostsRequest): Promise<Types.PostV1JobPostsResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/job-posts/`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1JobPosts: Api['postV1JobPosts'] = async (request: Types.PostV1JobPostsRequest): Promise<Types.PostV1JobPostsResponses> => {
  return await _postV1JobPosts(baseUrl, request)
}
const _getV1JobPosts = async (url: string, request: Types.GetV1JobPostsRequest): Promise<Types.GetV1JobPostsResponses> => {
  const queryParameters: (keyof Types.GetV1JobPostsRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/job-posts/?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1JobPosts: Api['getV1JobPosts'] = async (request: Types.GetV1JobPostsRequest): Promise<Types.GetV1JobPostsResponses> => {
  return await _getV1JobPosts(baseUrl, request)
}
const _getV1JobPostsId = async (url: string, request: Types.GetV1JobPostsIdRequest): Promise<Types.GetV1JobPostsIdResponses> => {
  const queryParameters: (keyof Types.GetV1JobPostsIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/job-posts/${request['id']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1JobPostsId: Api['getV1JobPostsId'] = async (request: Types.GetV1JobPostsIdRequest): Promise<Types.GetV1JobPostsIdResponses> => {
  return await _getV1JobPostsId(baseUrl, request)
}
const _putV1JobPostsId = async (url: string, request: Types.PutV1JobPostsIdRequest): Promise<Types.PutV1JobPostsIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/job-posts/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1JobPostsId: Api['putV1JobPostsId'] = async (request: Types.PutV1JobPostsIdRequest): Promise<Types.PutV1JobPostsIdResponses> => {
  return await _putV1JobPostsId(baseUrl, request)
}
const _deleteV1JobPostsId = async (url: string, request: Types.DeleteV1JobPostsIdRequest): Promise<Types.DeleteV1JobPostsIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/job-posts/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1JobPostsId: Api['deleteV1JobPostsId'] = async (request: Types.DeleteV1JobPostsIdRequest): Promise<Types.DeleteV1JobPostsIdResponses> => {
  return await _deleteV1JobPostsId(baseUrl, request)
}
const _patchV1JobPostsIdStatus = async (url: string, request: Types.PatchV1JobPostsIdStatusRequest): Promise<Types.PatchV1JobPostsIdStatusResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/job-posts/${request['id']}/status`, {
    method: 'PATCH',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const patchV1JobPostsIdStatus: Api['patchV1JobPostsIdStatus'] = async (request: Types.PatchV1JobPostsIdStatusRequest): Promise<Types.PatchV1JobPostsIdStatusResponses> => {
  return await _patchV1JobPostsIdStatus(baseUrl, request)
}
const _postV1JobPostsSaveAsDraft = async (url: string, request: Types.PostV1JobPostsSaveAsDraftRequest): Promise<Types.PostV1JobPostsSaveAsDraftResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/job-posts/save-as-draft`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1JobPostsSaveAsDraft: Api['postV1JobPostsSaveAsDraft'] = async (request: Types.PostV1JobPostsSaveAsDraftRequest): Promise<Types.PostV1JobPostsSaveAsDraftResponses> => {
  return await _postV1JobPostsSaveAsDraft(baseUrl, request)
}
const _patchV1JobPostsIdSaveAsDraft = async (url: string, request: Types.PatchV1JobPostsIdSaveAsDraftRequest): Promise<Types.PatchV1JobPostsIdSaveAsDraftResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/job-posts/${request['id']}/save-as-draft`, {
    method: 'PATCH',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const patchV1JobPostsIdSaveAsDraft: Api['patchV1JobPostsIdSaveAsDraft'] = async (request: Types.PatchV1JobPostsIdSaveAsDraftRequest): Promise<Types.PatchV1JobPostsIdSaveAsDraftResponses> => {
  return await _patchV1JobPostsIdSaveAsDraft(baseUrl, request)
}
const _postV1InterviewRounds = async (url: string, request: Types.PostV1InterviewRoundsRequest): Promise<Types.PostV1InterviewRoundsResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/interview-rounds/`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1InterviewRounds: Api['postV1InterviewRounds'] = async (request: Types.PostV1InterviewRoundsRequest): Promise<Types.PostV1InterviewRoundsResponses> => {
  return await _postV1InterviewRounds(baseUrl, request)
}
const _getV1InterviewRounds = async (url: string, request: Types.GetV1InterviewRoundsRequest): Promise<Types.GetV1InterviewRoundsResponses> => {
  const queryParameters: (keyof Types.GetV1InterviewRoundsRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/interview-rounds/?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1InterviewRounds: Api['getV1InterviewRounds'] = async (request: Types.GetV1InterviewRoundsRequest): Promise<Types.GetV1InterviewRoundsResponses> => {
  return await _getV1InterviewRounds(baseUrl, request)
}
const _getV1InterviewRoundsId = async (url: string, request: Types.GetV1InterviewRoundsIdRequest): Promise<Types.GetV1InterviewRoundsIdResponses> => {
  const queryParameters: (keyof Types.GetV1InterviewRoundsIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/interview-rounds/${request['id']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1InterviewRoundsId: Api['getV1InterviewRoundsId'] = async (request: Types.GetV1InterviewRoundsIdRequest): Promise<Types.GetV1InterviewRoundsIdResponses> => {
  return await _getV1InterviewRoundsId(baseUrl, request)
}
const _putV1InterviewRoundsId = async (url: string, request: Types.PutV1InterviewRoundsIdRequest): Promise<Types.PutV1InterviewRoundsIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/interview-rounds/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1InterviewRoundsId: Api['putV1InterviewRoundsId'] = async (request: Types.PutV1InterviewRoundsIdRequest): Promise<Types.PutV1InterviewRoundsIdResponses> => {
  return await _putV1InterviewRoundsId(baseUrl, request)
}
const _deleteV1InterviewRoundsId = async (url: string, request: Types.DeleteV1InterviewRoundsIdRequest): Promise<Types.DeleteV1InterviewRoundsIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/interview-rounds/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1InterviewRoundsId: Api['deleteV1InterviewRoundsId'] = async (request: Types.DeleteV1InterviewRoundsIdRequest): Promise<Types.DeleteV1InterviewRoundsIdResponses> => {
  return await _deleteV1InterviewRoundsId(baseUrl, request)
}
const _patchV1InterviewRoundsIdReschedule = async (url: string, request: Types.PatchV1InterviewRoundsIdRescheduleRequest): Promise<Types.PatchV1InterviewRoundsIdRescheduleResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/interview-rounds/${request['id']}/reschedule`, {
    method: 'PATCH',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const patchV1InterviewRoundsIdReschedule: Api['patchV1InterviewRoundsIdReschedule'] = async (request: Types.PatchV1InterviewRoundsIdRescheduleRequest): Promise<Types.PatchV1InterviewRoundsIdRescheduleResponses> => {
  return await _patchV1InterviewRoundsIdReschedule(baseUrl, request)
}
const _postV1Candidates = async (url: string, request: Types.PostV1CandidatesRequest): Promise<Types.PostV1CandidatesResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/candidates/`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1Candidates: Api['postV1Candidates'] = async (request: Types.PostV1CandidatesRequest): Promise<Types.PostV1CandidatesResponses> => {
  return await _postV1Candidates(baseUrl, request)
}
const _getV1Candidates = async (url: string, request: Types.GetV1CandidatesRequest): Promise<Types.GetV1CandidatesResponses> => {
  const queryParameters: (keyof Types.GetV1CandidatesRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/candidates/?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1Candidates: Api['getV1Candidates'] = async (request: Types.GetV1CandidatesRequest): Promise<Types.GetV1CandidatesResponses> => {
  return await _getV1Candidates(baseUrl, request)
}
const _getV1CandidatesId = async (url: string, request: Types.GetV1CandidatesIdRequest): Promise<Types.GetV1CandidatesIdResponses> => {
  const queryParameters: (keyof Types.GetV1CandidatesIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/candidates/${request['id']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1CandidatesId: Api['getV1CandidatesId'] = async (request: Types.GetV1CandidatesIdRequest): Promise<Types.GetV1CandidatesIdResponses> => {
  return await _getV1CandidatesId(baseUrl, request)
}
const _putV1CandidatesId = async (url: string, request: Types.PutV1CandidatesIdRequest): Promise<Types.PutV1CandidatesIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/candidates/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1CandidatesId: Api['putV1CandidatesId'] = async (request: Types.PutV1CandidatesIdRequest): Promise<Types.PutV1CandidatesIdResponses> => {
  return await _putV1CandidatesId(baseUrl, request)
}
const _deleteV1CandidatesId = async (url: string, request: Types.DeleteV1CandidatesIdRequest): Promise<Types.DeleteV1CandidatesIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/candidates/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1CandidatesId: Api['deleteV1CandidatesId'] = async (request: Types.DeleteV1CandidatesIdRequest): Promise<Types.DeleteV1CandidatesIdResponses> => {
  return await _deleteV1CandidatesId(baseUrl, request)
}
const _patchV1CandidatesIdStatus = async (url: string, request: Types.PatchV1CandidatesIdStatusRequest): Promise<Types.PatchV1CandidatesIdStatusResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/candidates/${request['id']}/status`, {
    method: 'PATCH',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const patchV1CandidatesIdStatus: Api['patchV1CandidatesIdStatus'] = async (request: Types.PatchV1CandidatesIdStatusRequest): Promise<Types.PatchV1CandidatesIdStatusResponses> => {
  return await _patchV1CandidatesIdStatus(baseUrl, request)
}
const _postV1CandidatesSaveAsDraft = async (url: string, request: Types.PostV1CandidatesSaveAsDraftRequest): Promise<Types.PostV1CandidatesSaveAsDraftResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/candidates/save-as-draft`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1CandidatesSaveAsDraft: Api['postV1CandidatesSaveAsDraft'] = async (request: Types.PostV1CandidatesSaveAsDraftRequest): Promise<Types.PostV1CandidatesSaveAsDraftResponses> => {
  return await _postV1CandidatesSaveAsDraft(baseUrl, request)
}
const _patchV1CandidatesIdSaveAsDraft = async (url: string, request: Types.PatchV1CandidatesIdSaveAsDraftRequest): Promise<Types.PatchV1CandidatesIdSaveAsDraftResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/candidates/${request['id']}/save-as-draft`, {
    method: 'PATCH',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const patchV1CandidatesIdSaveAsDraft: Api['patchV1CandidatesIdSaveAsDraft'] = async (request: Types.PatchV1CandidatesIdSaveAsDraftRequest): Promise<Types.PatchV1CandidatesIdSaveAsDraftResponses> => {
  return await _patchV1CandidatesIdSaveAsDraft(baseUrl, request)
}
const _patchV1CandidatesCandidateIdInterviewRoundsCandidateInterviewRoundIdReschedule = async (url: string, request: Types.PatchV1CandidatesCandidateIdInterviewRoundsCandidateInterviewRoundIdRescheduleRequest): Promise<Types.PatchV1CandidatesCandidateIdInterviewRoundsCandidateInterviewRoundIdRescheduleResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/candidates/${request['candidate_id']}/interview-rounds/${request['candidate_interview_round_id']}/reschedule`, {
    method: 'PATCH',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const patchV1CandidatesCandidateIdInterviewRoundsCandidateInterviewRoundIdReschedule: Api['patchV1CandidatesCandidateIdInterviewRoundsCandidateInterviewRoundIdReschedule'] = async (request: Types.PatchV1CandidatesCandidateIdInterviewRoundsCandidateInterviewRoundIdRescheduleRequest): Promise<Types.PatchV1CandidatesCandidateIdInterviewRoundsCandidateInterviewRoundIdRescheduleResponses> => {
  return await _patchV1CandidatesCandidateIdInterviewRoundsCandidateInterviewRoundIdReschedule(baseUrl, request)
}
const _getV1CandidatesGenerateExcel = async (url: string, request: Types.GetV1CandidatesGenerateExcelRequest): Promise<Types.GetV1CandidatesGenerateExcelResponses> => {
  const queryParameters: (keyof Types.GetV1CandidatesGenerateExcelRequest)[]  = ['resource', 'filters', 'order', 'search', 'hire_request_id']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['Content-Type'] !== undefined) {
    headers['Content-Type'] = request['Content-Type']
    delete request['Content-Type']
  }

  const response = await fetch(`${url}/v1/candidates/generate-excel?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1CandidatesGenerateExcel: Api['getV1CandidatesGenerateExcel'] = async (request: Types.GetV1CandidatesGenerateExcelRequest): Promise<Types.GetV1CandidatesGenerateExcelResponses> => {
  return await _getV1CandidatesGenerateExcel(baseUrl, request)
}
const _postV1CandidatesImport = async (url: string, request: Types.PostV1CandidatesImportRequest): Promise<Types.PostV1CandidatesImportResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/candidates/import`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1CandidatesImport: Api['postV1CandidatesImport'] = async (request: Types.PostV1CandidatesImportRequest): Promise<Types.PostV1CandidatesImportResponses> => {
  return await _postV1CandidatesImport(baseUrl, request)
}
const _postV1InterviewFeedbacks = async (url: string, request: Types.PostV1InterviewFeedbacksRequest): Promise<Types.PostV1InterviewFeedbacksResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/interview-feedbacks/`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1InterviewFeedbacks: Api['postV1InterviewFeedbacks'] = async (request: Types.PostV1InterviewFeedbacksRequest): Promise<Types.PostV1InterviewFeedbacksResponses> => {
  return await _postV1InterviewFeedbacks(baseUrl, request)
}
const _getV1InterviewFeedbacks = async (url: string, request: Types.GetV1InterviewFeedbacksRequest): Promise<Types.GetV1InterviewFeedbacksResponses> => {
  const queryParameters: (keyof Types.GetV1InterviewFeedbacksRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/interview-feedbacks/?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1InterviewFeedbacks: Api['getV1InterviewFeedbacks'] = async (request: Types.GetV1InterviewFeedbacksRequest): Promise<Types.GetV1InterviewFeedbacksResponses> => {
  return await _getV1InterviewFeedbacks(baseUrl, request)
}
const _getV1InterviewFeedbacksId = async (url: string, request: Types.GetV1InterviewFeedbacksIdRequest): Promise<Types.GetV1InterviewFeedbacksIdResponses> => {
  const queryParameters: (keyof Types.GetV1InterviewFeedbacksIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/interview-feedbacks/${request['id']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1InterviewFeedbacksId: Api['getV1InterviewFeedbacksId'] = async (request: Types.GetV1InterviewFeedbacksIdRequest): Promise<Types.GetV1InterviewFeedbacksIdResponses> => {
  return await _getV1InterviewFeedbacksId(baseUrl, request)
}
const _putV1InterviewFeedbacksId = async (url: string, request: Types.PutV1InterviewFeedbacksIdRequest): Promise<Types.PutV1InterviewFeedbacksIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/interview-feedbacks/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1InterviewFeedbacksId: Api['putV1InterviewFeedbacksId'] = async (request: Types.PutV1InterviewFeedbacksIdRequest): Promise<Types.PutV1InterviewFeedbacksIdResponses> => {
  return await _putV1InterviewFeedbacksId(baseUrl, request)
}
const _deleteV1InterviewFeedbacksId = async (url: string, request: Types.DeleteV1InterviewFeedbacksIdRequest): Promise<Types.DeleteV1InterviewFeedbacksIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/interview-feedbacks/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1InterviewFeedbacksId: Api['deleteV1InterviewFeedbacksId'] = async (request: Types.DeleteV1InterviewFeedbacksIdRequest): Promise<Types.DeleteV1InterviewFeedbacksIdResponses> => {
  return await _deleteV1InterviewFeedbacksId(baseUrl, request)
}
const _getV1TalentPoolDashboard = async (url: string, request: Types.GetV1TalentPoolDashboardRequest): Promise<Types.GetV1TalentPoolDashboardResponses> => {
  const queryParameters: (keyof Types.GetV1TalentPoolDashboardRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select', 'filter']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/talent-pool-dashboard/?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1TalentPoolDashboard: Api['getV1TalentPoolDashboard'] = async (request: Types.GetV1TalentPoolDashboardRequest): Promise<Types.GetV1TalentPoolDashboardResponses> => {
  return await _getV1TalentPoolDashboard(baseUrl, request)
}
const _getV1TalentPoolDashboardSummaryStats = async (url: string, request: Types.GetV1TalentPoolDashboardSummaryStatsRequest): Promise<Types.GetV1TalentPoolDashboardSummaryStatsResponses> => {
  const queryParameters: (keyof Types.GetV1TalentPoolDashboardSummaryStatsRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select', 'filter']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/talent-pool-dashboard/summary-stats?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1TalentPoolDashboardSummaryStats: Api['getV1TalentPoolDashboardSummaryStats'] = async (request: Types.GetV1TalentPoolDashboardSummaryStatsRequest): Promise<Types.GetV1TalentPoolDashboardSummaryStatsResponses> => {
  return await _getV1TalentPoolDashboardSummaryStats(baseUrl, request)
}
const _getV1TalentPoolDashboardRecentCandidates = async (url: string, request: Types.GetV1TalentPoolDashboardRecentCandidatesRequest): Promise<Types.GetV1TalentPoolDashboardRecentCandidatesResponses> => {
  const queryParameters: (keyof Types.GetV1TalentPoolDashboardRecentCandidatesRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select', 'filter']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/talent-pool-dashboard/recent-candidates?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1TalentPoolDashboardRecentCandidates: Api['getV1TalentPoolDashboardRecentCandidates'] = async (request: Types.GetV1TalentPoolDashboardRecentCandidatesRequest): Promise<Types.GetV1TalentPoolDashboardRecentCandidatesResponses> => {
  return await _getV1TalentPoolDashboardRecentCandidates(baseUrl, request)
}
const _getV1TalentPoolDashboardRecentEvaluations = async (url: string, request: Types.GetV1TalentPoolDashboardRecentEvaluationsRequest): Promise<Types.GetV1TalentPoolDashboardRecentEvaluationsResponses> => {
  const queryParameters: (keyof Types.GetV1TalentPoolDashboardRecentEvaluationsRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select', 'filter']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/talent-pool-dashboard/recent-evaluations?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1TalentPoolDashboardRecentEvaluations: Api['getV1TalentPoolDashboardRecentEvaluations'] = async (request: Types.GetV1TalentPoolDashboardRecentEvaluationsRequest): Promise<Types.GetV1TalentPoolDashboardRecentEvaluationsResponses> => {
  return await _getV1TalentPoolDashboardRecentEvaluations(baseUrl, request)
}
const _getV1TalentPoolDashboardUpcomingInterviews = async (url: string, request: Types.GetV1TalentPoolDashboardUpcomingInterviewsRequest): Promise<Types.GetV1TalentPoolDashboardUpcomingInterviewsResponses> => {
  const queryParameters: (keyof Types.GetV1TalentPoolDashboardUpcomingInterviewsRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select', 'filter']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/talent-pool-dashboard/upcoming-interviews?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1TalentPoolDashboardUpcomingInterviews: Api['getV1TalentPoolDashboardUpcomingInterviews'] = async (request: Types.GetV1TalentPoolDashboardUpcomingInterviewsRequest): Promise<Types.GetV1TalentPoolDashboardUpcomingInterviewsResponses> => {
  return await _getV1TalentPoolDashboardUpcomingInterviews(baseUrl, request)
}
const _getV1Dashboard = async (url: string, request: Types.GetV1DashboardRequest): Promise<Types.GetV1DashboardResponses> => {
  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/dashboard/`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1Dashboard: Api['getV1Dashboard'] = async (request: Types.GetV1DashboardRequest): Promise<Types.GetV1DashboardResponses> => {
  return await _getV1Dashboard(baseUrl, request)
}
const _getV1DashboardHeaderStats = async (url: string, request: Types.GetV1DashboardHeaderStatsRequest): Promise<Types.GetV1DashboardHeaderStatsResponses> => {
  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/dashboard/header-stats`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1DashboardHeaderStats: Api['getV1DashboardHeaderStats'] = async (request: Types.GetV1DashboardHeaderStatsRequest): Promise<Types.GetV1DashboardHeaderStatsResponses> => {
  return await _getV1DashboardHeaderStats(baseUrl, request)
}
const _getV1DashboardEmployeesByDepartment = async (url: string, request: Types.GetV1DashboardEmployeesByDepartmentRequest): Promise<Types.GetV1DashboardEmployeesByDepartmentResponses> => {
  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/dashboard/employees-by-department`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1DashboardEmployeesByDepartment: Api['getV1DashboardEmployeesByDepartment'] = async (request: Types.GetV1DashboardEmployeesByDepartmentRequest): Promise<Types.GetV1DashboardEmployeesByDepartmentResponses> => {
  return await _getV1DashboardEmployeesByDepartment(baseUrl, request)
}
const _getV1DashboardAvailabilityStats = async (url: string, request: Types.GetV1DashboardAvailabilityStatsRequest): Promise<Types.GetV1DashboardAvailabilityStatsResponses> => {
  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/dashboard/availability-stats`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1DashboardAvailabilityStats: Api['getV1DashboardAvailabilityStats'] = async (request: Types.GetV1DashboardAvailabilityStatsRequest): Promise<Types.GetV1DashboardAvailabilityStatsResponses> => {
  return await _getV1DashboardAvailabilityStats(baseUrl, request)
}
const _getV1DashboardResourceAllocation = async (url: string, request: Types.GetV1DashboardResourceAllocationRequest): Promise<Types.GetV1DashboardResourceAllocationResponses> => {
  const queryParameters: (keyof Types.GetV1DashboardResourceAllocationRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select', 'status', 'months', 'days', 'tab']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/dashboard/resource-allocation?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1DashboardResourceAllocation: Api['getV1DashboardResourceAllocation'] = async (request: Types.GetV1DashboardResourceAllocationRequest): Promise<Types.GetV1DashboardResourceAllocationResponses> => {
  return await _getV1DashboardResourceAllocation(baseUrl, request)
}
const _getV1DashboardBirthdayDashboard = async (url: string, request: Types.GetV1DashboardBirthdayDashboardRequest): Promise<Types.GetV1DashboardBirthdayDashboardResponses> => {
  const queryParameters: (keyof Types.GetV1DashboardBirthdayDashboardRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select', 'status', 'months', 'days', 'tab']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/dashboard/birthday-dashboard?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1DashboardBirthdayDashboard: Api['getV1DashboardBirthdayDashboard'] = async (request: Types.GetV1DashboardBirthdayDashboardRequest): Promise<Types.GetV1DashboardBirthdayDashboardResponses> => {
  return await _getV1DashboardBirthdayDashboard(baseUrl, request)
}
const _getV1DashboardLeaveRequests = async (url: string, request: Types.GetV1DashboardLeaveRequestsRequest): Promise<Types.GetV1DashboardLeaveRequestsResponses> => {
  const queryParameters: (keyof Types.GetV1DashboardLeaveRequestsRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select', 'status', 'months', 'days', 'tab']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/dashboard/leave-requests?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1DashboardLeaveRequests: Api['getV1DashboardLeaveRequests'] = async (request: Types.GetV1DashboardLeaveRequestsRequest): Promise<Types.GetV1DashboardLeaveRequestsResponses> => {
  return await _getV1DashboardLeaveRequests(baseUrl, request)
}
const _getV1DashboardResignationRequests = async (url: string, request: Types.GetV1DashboardResignationRequestsRequest): Promise<Types.GetV1DashboardResignationRequestsResponses> => {
  const queryParameters: (keyof Types.GetV1DashboardResignationRequestsRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select', 'status', 'months', 'days', 'tab']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/dashboard/resignation-requests?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1DashboardResignationRequests: Api['getV1DashboardResignationRequests'] = async (request: Types.GetV1DashboardResignationRequestsRequest): Promise<Types.GetV1DashboardResignationRequestsResponses> => {
  return await _getV1DashboardResignationRequests(baseUrl, request)
}
const _getV1DashboardIssueHrLetters = async (url: string, request: Types.GetV1DashboardIssueHrLettersRequest): Promise<Types.GetV1DashboardIssueHrLettersResponses> => {
  const queryParameters: (keyof Types.GetV1DashboardIssueHrLettersRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select', 'status', 'months', 'days', 'tab']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/dashboard/issue-hr-letters?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1DashboardIssueHrLetters: Api['getV1DashboardIssueHrLetters'] = async (request: Types.GetV1DashboardIssueHrLettersRequest): Promise<Types.GetV1DashboardIssueHrLettersResponses> => {
  return await _getV1DashboardIssueHrLetters(baseUrl, request)
}
const _getV1DashboardApprovalDashboard = async (url: string, request: Types.GetV1DashboardApprovalDashboardRequest): Promise<Types.GetV1DashboardApprovalDashboardResponses> => {
  const queryParameters: (keyof Types.GetV1DashboardApprovalDashboardRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select', 'status', 'months', 'days', 'tab']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/dashboard/approval-dashboard?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1DashboardApprovalDashboard: Api['getV1DashboardApprovalDashboard'] = async (request: Types.GetV1DashboardApprovalDashboardRequest): Promise<Types.GetV1DashboardApprovalDashboardResponses> => {
  return await _getV1DashboardApprovalDashboard(baseUrl, request)
}
const _getV1DashboardOngoingJobs = async (url: string, request: Types.GetV1DashboardOngoingJobsRequest): Promise<Types.GetV1DashboardOngoingJobsResponses> => {
  const queryParameters: (keyof Types.GetV1DashboardOngoingJobsRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select', 'status', 'months', 'days', 'tab']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/dashboard/ongoing-jobs?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1DashboardOngoingJobs: Api['getV1DashboardOngoingJobs'] = async (request: Types.GetV1DashboardOngoingJobsRequest): Promise<Types.GetV1DashboardOngoingJobsResponses> => {
  return await _getV1DashboardOngoingJobs(baseUrl, request)
}
const _getV1DashboardNewHireRequests = async (url: string, request: Types.GetV1DashboardNewHireRequestsRequest): Promise<Types.GetV1DashboardNewHireRequestsResponses> => {
  const queryParameters: (keyof Types.GetV1DashboardNewHireRequestsRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select', 'status', 'months', 'days', 'tab']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/dashboard/new-hire-requests?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1DashboardNewHireRequests: Api['getV1DashboardNewHireRequests'] = async (request: Types.GetV1DashboardNewHireRequestsRequest): Promise<Types.GetV1DashboardNewHireRequestsResponses> => {
  return await _getV1DashboardNewHireRequests(baseUrl, request)
}
const _getV1DashboardEventsDashboard = async (url: string, request: Types.GetV1DashboardEventsDashboardRequest): Promise<Types.GetV1DashboardEventsDashboardResponses> => {
  const queryParameters: (keyof Types.GetV1DashboardEventsDashboardRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select', 'status', 'months', 'days', 'tab']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/dashboard/events-dashboard?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1DashboardEventsDashboard: Api['getV1DashboardEventsDashboard'] = async (request: Types.GetV1DashboardEventsDashboardRequest): Promise<Types.GetV1DashboardEventsDashboardResponses> => {
  return await _getV1DashboardEventsDashboard(baseUrl, request)
}
const _getV1DashboardTaskSignoffs = async (url: string, request: Types.GetV1DashboardTaskSignoffsRequest): Promise<Types.GetV1DashboardTaskSignoffsResponses> => {
  const queryParameters: (keyof Types.GetV1DashboardTaskSignoffsRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select', 'status', 'months', 'days', 'tab']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/dashboard/task-signoffs?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1DashboardTaskSignoffs: Api['getV1DashboardTaskSignoffs'] = async (request: Types.GetV1DashboardTaskSignoffsRequest): Promise<Types.GetV1DashboardTaskSignoffsResponses> => {
  return await _getV1DashboardTaskSignoffs(baseUrl, request)
}
const _getV1DashboardKpiStatistics = async (url: string, request: Types.GetV1DashboardKpiStatisticsRequest): Promise<Types.GetV1DashboardKpiStatisticsResponses> => {
  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/dashboard/kpi-statistics`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1DashboardKpiStatistics: Api['getV1DashboardKpiStatistics'] = async (request: Types.GetV1DashboardKpiStatisticsRequest): Promise<Types.GetV1DashboardKpiStatisticsResponses> => {
  return await _getV1DashboardKpiStatistics(baseUrl, request)
}
const _getV1DashboardRpsStatistics = async (url: string, request: Types.GetV1DashboardRpsStatisticsRequest): Promise<Types.GetV1DashboardRpsStatisticsResponses> => {
  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/dashboard/rps-statistics`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1DashboardRpsStatistics: Api['getV1DashboardRpsStatistics'] = async (request: Types.GetV1DashboardRpsStatisticsRequest): Promise<Types.GetV1DashboardRpsStatisticsResponses> => {
  return await _getV1DashboardRpsStatistics(baseUrl, request)
}
const _getV1DashboardPayrollStatistics = async (url: string, request: Types.GetV1DashboardPayrollStatisticsRequest): Promise<Types.GetV1DashboardPayrollStatisticsResponses> => {
  const queryParameters: (keyof Types.GetV1DashboardPayrollStatisticsRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select', 'status', 'months', 'days', 'tab']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/dashboard/payroll-statistics?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1DashboardPayrollStatistics: Api['getV1DashboardPayrollStatistics'] = async (request: Types.GetV1DashboardPayrollStatisticsRequest): Promise<Types.GetV1DashboardPayrollStatisticsResponses> => {
  return await _getV1DashboardPayrollStatistics(baseUrl, request)
}
const _getV1DashboardAttendanceTrends = async (url: string, request: Types.GetV1DashboardAttendanceTrendsRequest): Promise<Types.GetV1DashboardAttendanceTrendsResponses> => {
  const queryParameters: (keyof Types.GetV1DashboardAttendanceTrendsRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select', 'status', 'months', 'days', 'tab']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/dashboard/attendance-trends?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1DashboardAttendanceTrends: Api['getV1DashboardAttendanceTrends'] = async (request: Types.GetV1DashboardAttendanceTrendsRequest): Promise<Types.GetV1DashboardAttendanceTrendsResponses> => {
  return await _getV1DashboardAttendanceTrends(baseUrl, request)
}
const _getV1DashboardDepartmentHeadcount = async (url: string, request: Types.GetV1DashboardDepartmentHeadcountRequest): Promise<Types.GetV1DashboardDepartmentHeadcountResponses> => {
  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/dashboard/department-headcount`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1DashboardDepartmentHeadcount: Api['getV1DashboardDepartmentHeadcount'] = async (request: Types.GetV1DashboardDepartmentHeadcountRequest): Promise<Types.GetV1DashboardDepartmentHeadcountResponses> => {
  return await _getV1DashboardDepartmentHeadcount(baseUrl, request)
}
const _getV1DashboardLeaveBalanceSummary = async (url: string, request: Types.GetV1DashboardLeaveBalanceSummaryRequest): Promise<Types.GetV1DashboardLeaveBalanceSummaryResponses> => {
  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/dashboard/leave-balance-summary`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1DashboardLeaveBalanceSummary: Api['getV1DashboardLeaveBalanceSummary'] = async (request: Types.GetV1DashboardLeaveBalanceSummaryRequest): Promise<Types.GetV1DashboardLeaveBalanceSummaryResponses> => {
  return await _getV1DashboardLeaveBalanceSummary(baseUrl, request)
}
const _getV1DashboardRecruitmentFunnel = async (url: string, request: Types.GetV1DashboardRecruitmentFunnelRequest): Promise<Types.GetV1DashboardRecruitmentFunnelResponses> => {
  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/dashboard/recruitment-funnel`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1DashboardRecruitmentFunnel: Api['getV1DashboardRecruitmentFunnel'] = async (request: Types.GetV1DashboardRecruitmentFunnelRequest): Promise<Types.GetV1DashboardRecruitmentFunnelResponses> => {
  return await _getV1DashboardRecruitmentFunnel(baseUrl, request)
}
const _getV1DashboardTeamCalendar = async (url: string, request: Types.GetV1DashboardTeamCalendarRequest): Promise<Types.GetV1DashboardTeamCalendarResponses> => {
  const queryParameters: (keyof Types.GetV1DashboardTeamCalendarRequest)[]  = ['month', 'year']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/dashboard/team-calendar?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1DashboardTeamCalendar: Api['getV1DashboardTeamCalendar'] = async (request: Types.GetV1DashboardTeamCalendarRequest): Promise<Types.GetV1DashboardTeamCalendarResponses> => {
  return await _getV1DashboardTeamCalendar(baseUrl, request)
}
const _getV1DashboardTaskOverview = async (url: string, request: Types.GetV1DashboardTaskOverviewRequest): Promise<Types.GetV1DashboardTaskOverviewResponses> => {
  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/dashboard/task-overview`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1DashboardTaskOverview: Api['getV1DashboardTaskOverview'] = async (request: Types.GetV1DashboardTaskOverviewRequest): Promise<Types.GetV1DashboardTaskOverviewResponses> => {
  return await _getV1DashboardTaskOverview(baseUrl, request)
}
const _getV1DashboardAnnouncements = async (url: string, request: Types.GetV1DashboardAnnouncementsRequest): Promise<Types.GetV1DashboardAnnouncementsResponses> => {
  const queryParameters: (keyof Types.GetV1DashboardAnnouncementsRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select', 'status', 'months', 'days', 'tab']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/dashboard/announcements?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1DashboardAnnouncements: Api['getV1DashboardAnnouncements'] = async (request: Types.GetV1DashboardAnnouncementsRequest): Promise<Types.GetV1DashboardAnnouncementsResponses> => {
  return await _getV1DashboardAnnouncements(baseUrl, request)
}
const _getV1DashboardLeaveStatistics = async (url: string, request: Types.GetV1DashboardLeaveStatisticsRequest): Promise<Types.GetV1DashboardLeaveStatisticsResponses> => {
  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/dashboard/leave-statistics`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1DashboardLeaveStatistics: Api['getV1DashboardLeaveStatistics'] = async (request: Types.GetV1DashboardLeaveStatisticsRequest): Promise<Types.GetV1DashboardLeaveStatisticsResponses> => {
  return await _getV1DashboardLeaveStatistics(baseUrl, request)
}
const _getV1DashboardPendingInterviews = async (url: string, request: Types.GetV1DashboardPendingInterviewsRequest): Promise<Types.GetV1DashboardPendingInterviewsResponses> => {
  const queryParameters: (keyof Types.GetV1DashboardPendingInterviewsRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select', 'status', 'months', 'days', 'tab']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/dashboard/pending-interviews?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1DashboardPendingInterviews: Api['getV1DashboardPendingInterviews'] = async (request: Types.GetV1DashboardPendingInterviewsRequest): Promise<Types.GetV1DashboardPendingInterviewsResponses> => {
  return await _getV1DashboardPendingInterviews(baseUrl, request)
}
const _getV1DashboardVacationPlanConflicts = async (url: string, request: Types.GetV1DashboardVacationPlanConflictsRequest): Promise<Types.GetV1DashboardVacationPlanConflictsResponses> => {
  const queryParameters: (keyof Types.GetV1DashboardVacationPlanConflictsRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select', 'status', 'months', 'days', 'tab']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/dashboard/vacation-plan-conflicts?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1DashboardVacationPlanConflicts: Api['getV1DashboardVacationPlanConflicts'] = async (request: Types.GetV1DashboardVacationPlanConflictsRequest): Promise<Types.GetV1DashboardVacationPlanConflictsResponses> => {
  return await _getV1DashboardVacationPlanConflicts(baseUrl, request)
}
const _getV1DashboardManagerHeaderStats = async (url: string, request: Types.GetV1DashboardManagerHeaderStatsRequest): Promise<Types.GetV1DashboardManagerHeaderStatsResponses> => {
  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/dashboard/manager-header-stats`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1DashboardManagerHeaderStats: Api['getV1DashboardManagerHeaderStats'] = async (request: Types.GetV1DashboardManagerHeaderStatsRequest): Promise<Types.GetV1DashboardManagerHeaderStatsResponses> => {
  return await _getV1DashboardManagerHeaderStats(baseUrl, request)
}
const _getV1DashboardManagerKpiStatistics = async (url: string, request: Types.GetV1DashboardManagerKpiStatisticsRequest): Promise<Types.GetV1DashboardManagerKpiStatisticsResponses> => {
  const queryParameters: (keyof Types.GetV1DashboardManagerKpiStatisticsRequest)[]  = ['months']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/dashboard/manager-kpi-statistics?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1DashboardManagerKpiStatistics: Api['getV1DashboardManagerKpiStatistics'] = async (request: Types.GetV1DashboardManagerKpiStatisticsRequest): Promise<Types.GetV1DashboardManagerKpiStatisticsResponses> => {
  return await _getV1DashboardManagerKpiStatistics(baseUrl, request)
}
const _getV1DashboardEmployee = async (url: string, request: Types.GetV1DashboardEmployeeRequest): Promise<Types.GetV1DashboardEmployeeResponses> => {
  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/dashboard/employee`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1DashboardEmployee: Api['getV1DashboardEmployee'] = async (request: Types.GetV1DashboardEmployeeRequest): Promise<Types.GetV1DashboardEmployeeResponses> => {
  return await _getV1DashboardEmployee(baseUrl, request)
}
const _getV1DashboardEmployeeWorkingHours = async (url: string, request: Types.GetV1DashboardEmployeeWorkingHoursRequest): Promise<Types.GetV1DashboardEmployeeWorkingHoursResponses> => {
  const queryParameters: (keyof Types.GetV1DashboardEmployeeWorkingHoursRequest)[]  = ['start_date', 'end_date', 'source']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/dashboard/employee/working-hours?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1DashboardEmployeeWorkingHours: Api['getV1DashboardEmployeeWorkingHours'] = async (request: Types.GetV1DashboardEmployeeWorkingHoursRequest): Promise<Types.GetV1DashboardEmployeeWorkingHoursResponses> => {
  return await _getV1DashboardEmployeeWorkingHours(baseUrl, request)
}
const _getV1DashboardEmployeeAttendance = async (url: string, request: Types.GetV1DashboardEmployeeAttendanceRequest): Promise<Types.GetV1DashboardEmployeeAttendanceResponses> => {
  const queryParameters: (keyof Types.GetV1DashboardEmployeeAttendanceRequest)[]  = ['date']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/dashboard/employee/attendance?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1DashboardEmployeeAttendance: Api['getV1DashboardEmployeeAttendance'] = async (request: Types.GetV1DashboardEmployeeAttendanceRequest): Promise<Types.GetV1DashboardEmployeeAttendanceResponses> => {
  return await _getV1DashboardEmployeeAttendance(baseUrl, request)
}
const _getV1DashboardEmployeeAttendanceBreaks = async (url: string, request: Types.GetV1DashboardEmployeeAttendanceBreaksRequest): Promise<Types.GetV1DashboardEmployeeAttendanceBreaksResponses> => {
  const queryParameters: (keyof Types.GetV1DashboardEmployeeAttendanceBreaksRequest)[]  = ['date']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/dashboard/employee/attendance-breaks?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1DashboardEmployeeAttendanceBreaks: Api['getV1DashboardEmployeeAttendanceBreaks'] = async (request: Types.GetV1DashboardEmployeeAttendanceBreaksRequest): Promise<Types.GetV1DashboardEmployeeAttendanceBreaksResponses> => {
  return await _getV1DashboardEmployeeAttendanceBreaks(baseUrl, request)
}
const _getV1DashboardEmployeeAttendanceHistory = async (url: string, request: Types.GetV1DashboardEmployeeAttendanceHistoryRequest): Promise<Types.GetV1DashboardEmployeeAttendanceHistoryResponses> => {
  const queryParameters: (keyof Types.GetV1DashboardEmployeeAttendanceHistoryRequest)[]  = ['start_date', 'end_date', 'skip', 'limit']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/dashboard/employee/attendance-history?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1DashboardEmployeeAttendanceHistory: Api['getV1DashboardEmployeeAttendanceHistory'] = async (request: Types.GetV1DashboardEmployeeAttendanceHistoryRequest): Promise<Types.GetV1DashboardEmployeeAttendanceHistoryResponses> => {
  return await _getV1DashboardEmployeeAttendanceHistory(baseUrl, request)
}
const _getV1DashboardEmployeeRequests = async (url: string, request: Types.GetV1DashboardEmployeeRequestsRequest): Promise<Types.GetV1DashboardEmployeeRequestsResponses> => {
  const queryParameters: (keyof Types.GetV1DashboardEmployeeRequestsRequest)[]  = ['skip', 'limit', 'request_type', 'status', 'duration']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/dashboard/employee/requests?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1DashboardEmployeeRequests: Api['getV1DashboardEmployeeRequests'] = async (request: Types.GetV1DashboardEmployeeRequestsRequest): Promise<Types.GetV1DashboardEmployeeRequestsResponses> => {
  return await _getV1DashboardEmployeeRequests(baseUrl, request)
}
const _getV1DashboardEmployeeLoans = async (url: string, request: Types.GetV1DashboardEmployeeLoansRequest): Promise<Types.GetV1DashboardEmployeeLoansResponses> => {
  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/dashboard/employee/loans`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1DashboardEmployeeLoans: Api['getV1DashboardEmployeeLoans'] = async (request: Types.GetV1DashboardEmployeeLoansRequest): Promise<Types.GetV1DashboardEmployeeLoansResponses> => {
  return await _getV1DashboardEmployeeLoans(baseUrl, request)
}
const _getV1DashboardEmployeeHolidaysEvents = async (url: string, request: Types.GetV1DashboardEmployeeHolidaysEventsRequest): Promise<Types.GetV1DashboardEmployeeHolidaysEventsResponses> => {
  const queryParameters: (keyof Types.GetV1DashboardEmployeeHolidaysEventsRequest)[]  = ['skip', 'limit']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/dashboard/employee/holidays-events?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1DashboardEmployeeHolidaysEvents: Api['getV1DashboardEmployeeHolidaysEvents'] = async (request: Types.GetV1DashboardEmployeeHolidaysEventsRequest): Promise<Types.GetV1DashboardEmployeeHolidaysEventsResponses> => {
  return await _getV1DashboardEmployeeHolidaysEvents(baseUrl, request)
}
const _getV1DashboardEmployeeAssets = async (url: string, request: Types.GetV1DashboardEmployeeAssetsRequest): Promise<Types.GetV1DashboardEmployeeAssetsResponses> => {
  const queryParameters: (keyof Types.GetV1DashboardEmployeeAssetsRequest)[]  = ['skip', 'limit']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/dashboard/employee/assets?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1DashboardEmployeeAssets: Api['getV1DashboardEmployeeAssets'] = async (request: Types.GetV1DashboardEmployeeAssetsRequest): Promise<Types.GetV1DashboardEmployeeAssetsResponses> => {
  return await _getV1DashboardEmployeeAssets(baseUrl, request)
}
const _getV1DashboardEmployeeActivities = async (url: string, request: Types.GetV1DashboardEmployeeActivitiesRequest): Promise<Types.GetV1DashboardEmployeeActivitiesResponses> => {
  const queryParameters: (keyof Types.GetV1DashboardEmployeeActivitiesRequest)[]  = ['skip', 'limit']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/dashboard/employee/activities?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1DashboardEmployeeActivities: Api['getV1DashboardEmployeeActivities'] = async (request: Types.GetV1DashboardEmployeeActivitiesRequest): Promise<Types.GetV1DashboardEmployeeActivitiesResponses> => {
  return await _getV1DashboardEmployeeActivities(baseUrl, request)
}
const _getV1DashboardEmployeeWorkingStatistics = async (url: string, request: Types.GetV1DashboardEmployeeWorkingStatisticsRequest): Promise<Types.GetV1DashboardEmployeeWorkingStatisticsResponses> => {
  const queryParameters: (keyof Types.GetV1DashboardEmployeeWorkingStatisticsRequest)[]  = ['months', 'source']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/dashboard/employee/working-statistics?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1DashboardEmployeeWorkingStatistics: Api['getV1DashboardEmployeeWorkingStatistics'] = async (request: Types.GetV1DashboardEmployeeWorkingStatisticsRequest): Promise<Types.GetV1DashboardEmployeeWorkingStatisticsResponses> => {
  return await _getV1DashboardEmployeeWorkingStatistics(baseUrl, request)
}
const _getV1DashboardEmployeeTasks = async (url: string, request: Types.GetV1DashboardEmployeeTasksRequest): Promise<Types.GetV1DashboardEmployeeTasksResponses> => {
  const queryParameters: (keyof Types.GetV1DashboardEmployeeTasksRequest)[]  = ['skip', 'limit', 'status']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/dashboard/employee/tasks?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1DashboardEmployeeTasks: Api['getV1DashboardEmployeeTasks'] = async (request: Types.GetV1DashboardEmployeeTasksRequest): Promise<Types.GetV1DashboardEmployeeTasksResponses> => {
  return await _getV1DashboardEmployeeTasks(baseUrl, request)
}
const _postV1OfferLetters = async (url: string, request: Types.PostV1OfferLettersRequest): Promise<Types.PostV1OfferLettersResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/offer-letters/`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1OfferLetters: Api['postV1OfferLetters'] = async (request: Types.PostV1OfferLettersRequest): Promise<Types.PostV1OfferLettersResponses> => {
  return await _postV1OfferLetters(baseUrl, request)
}
const _getV1OfferLetters = async (url: string, request: Types.GetV1OfferLettersRequest): Promise<Types.GetV1OfferLettersResponses> => {
  const queryParameters: (keyof Types.GetV1OfferLettersRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/offer-letters/?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1OfferLetters: Api['getV1OfferLetters'] = async (request: Types.GetV1OfferLettersRequest): Promise<Types.GetV1OfferLettersResponses> => {
  return await _getV1OfferLetters(baseUrl, request)
}
const _getV1OfferLettersId = async (url: string, request: Types.GetV1OfferLettersIdRequest): Promise<Types.GetV1OfferLettersIdResponses> => {
  const queryParameters: (keyof Types.GetV1OfferLettersIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/offer-letters/${request['id']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1OfferLettersId: Api['getV1OfferLettersId'] = async (request: Types.GetV1OfferLettersIdRequest): Promise<Types.GetV1OfferLettersIdResponses> => {
  return await _getV1OfferLettersId(baseUrl, request)
}
const _putV1OfferLettersId = async (url: string, request: Types.PutV1OfferLettersIdRequest): Promise<Types.PutV1OfferLettersIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/offer-letters/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1OfferLettersId: Api['putV1OfferLettersId'] = async (request: Types.PutV1OfferLettersIdRequest): Promise<Types.PutV1OfferLettersIdResponses> => {
  return await _putV1OfferLettersId(baseUrl, request)
}
const _deleteV1OfferLettersId = async (url: string, request: Types.DeleteV1OfferLettersIdRequest): Promise<Types.DeleteV1OfferLettersIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/offer-letters/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1OfferLettersId: Api['deleteV1OfferLettersId'] = async (request: Types.DeleteV1OfferLettersIdRequest): Promise<Types.DeleteV1OfferLettersIdResponses> => {
  return await _deleteV1OfferLettersId(baseUrl, request)
}
const _patchV1OfferLettersIdStatus = async (url: string, request: Types.PatchV1OfferLettersIdStatusRequest): Promise<Types.PatchV1OfferLettersIdStatusResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/offer-letters/${request['id']}/status`, {
    method: 'PATCH',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const patchV1OfferLettersIdStatus: Api['patchV1OfferLettersIdStatus'] = async (request: Types.PatchV1OfferLettersIdStatusRequest): Promise<Types.PatchV1OfferLettersIdStatusResponses> => {
  return await _patchV1OfferLettersIdStatus(baseUrl, request)
}
const _patchV1OfferLettersIdDocumentsDocumentId = async (url: string, request: Types.PatchV1OfferLettersIdDocumentsDocumentIdRequest): Promise<Types.PatchV1OfferLettersIdDocumentsDocumentIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/offer-letters/${request['id']}/documents/${request['document_id']}`, {
    method: 'PATCH',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const patchV1OfferLettersIdDocumentsDocumentId: Api['patchV1OfferLettersIdDocumentsDocumentId'] = async (request: Types.PatchV1OfferLettersIdDocumentsDocumentIdRequest): Promise<Types.PatchV1OfferLettersIdDocumentsDocumentIdResponses> => {
  return await _patchV1OfferLettersIdDocumentsDocumentId(baseUrl, request)
}
const _postV1OfferLettersIdDocumentsDocumentIdVerify = async (url: string, request: Types.PostV1OfferLettersIdDocumentsDocumentIdVerifyRequest): Promise<Types.PostV1OfferLettersIdDocumentsDocumentIdVerifyResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/offer-letters/${request['id']}/documents/${request['document_id']}/verify`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1OfferLettersIdDocumentsDocumentIdVerify: Api['postV1OfferLettersIdDocumentsDocumentIdVerify'] = async (request: Types.PostV1OfferLettersIdDocumentsDocumentIdVerifyRequest): Promise<Types.PostV1OfferLettersIdDocumentsDocumentIdVerifyResponses> => {
  return await _postV1OfferLettersIdDocumentsDocumentIdVerify(baseUrl, request)
}
const _getV1OfferLettersGenerateExcel = async (url: string, request: Types.GetV1OfferLettersGenerateExcelRequest): Promise<Types.GetV1OfferLettersGenerateExcelResponses> => {
  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/offer-letters/generate-excel`, {
    headers
  })

  const textResponses = [200]
  if (textResponses.includes(response.status)) {
    return {
      statusCode: response.status as 200,
      headers: headersToJSON(response.headers),
      body: await response.text()
    }
  }
  if (response.headers.get('content-type') === 'application/json') {
    return {
      statusCode: response.status as 200,
      headers: headersToJSON(response.headers),
      body: await response.json() as any
    }
  }
  return {
    statusCode: response.status as 200,
    headers: headersToJSON(response.headers),
    body: await response.text() as any
  }
}

export const getV1OfferLettersGenerateExcel: Api['getV1OfferLettersGenerateExcel'] = async (request: Types.GetV1OfferLettersGenerateExcelRequest): Promise<Types.GetV1OfferLettersGenerateExcelResponses> => {
  return await _getV1OfferLettersGenerateExcel(baseUrl, request)
}
const _postV1OfferLettersImport = async (url: string, request: Types.PostV1OfferLettersImportRequest): Promise<Types.PostV1OfferLettersImportResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/offer-letters/import`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  const textResponses = [200]
  if (textResponses.includes(response.status)) {
    return {
      statusCode: response.status as 200,
      headers: headersToJSON(response.headers),
      body: await response.text()
    }
  }
  if (response.headers.get('content-type') === 'application/json') {
    return {
      statusCode: response.status as 200,
      headers: headersToJSON(response.headers),
      body: await response.json() as any
    }
  }
  return {
    statusCode: response.status as 200,
    headers: headersToJSON(response.headers),
    body: await response.text() as any
  }
}

export const postV1OfferLettersImport: Api['postV1OfferLettersImport'] = async (request: Types.PostV1OfferLettersImportRequest): Promise<Types.PostV1OfferLettersImportResponses> => {
  return await _postV1OfferLettersImport(baseUrl, request)
}
const _getV1OfferLettersExportExcel = async (url: string, request: Types.GetV1OfferLettersExportExcelRequest): Promise<Types.GetV1OfferLettersExportExcelResponses> => {
  const queryParameters: (keyof Types.GetV1OfferLettersExportExcelRequest)[]  = ['filters', 'order', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/offer-letters/export/excel?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1OfferLettersExportExcel: Api['getV1OfferLettersExportExcel'] = async (request: Types.GetV1OfferLettersExportExcelRequest): Promise<Types.GetV1OfferLettersExportExcelResponses> => {
  return await _getV1OfferLettersExportExcel(baseUrl, request)
}
const _postV1OfferLettersSaveAsDraft = async (url: string, request: Types.PostV1OfferLettersSaveAsDraftRequest): Promise<Types.PostV1OfferLettersSaveAsDraftResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/offer-letters/save-as-draft`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1OfferLettersSaveAsDraft: Api['postV1OfferLettersSaveAsDraft'] = async (request: Types.PostV1OfferLettersSaveAsDraftRequest): Promise<Types.PostV1OfferLettersSaveAsDraftResponses> => {
  return await _postV1OfferLettersSaveAsDraft(baseUrl, request)
}
const _patchV1OfferLettersIdSaveAsDraft = async (url: string, request: Types.PatchV1OfferLettersIdSaveAsDraftRequest): Promise<Types.PatchV1OfferLettersIdSaveAsDraftResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/offer-letters/${request['id']}/save-as-draft`, {
    method: 'PATCH',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const patchV1OfferLettersIdSaveAsDraft: Api['patchV1OfferLettersIdSaveAsDraft'] = async (request: Types.PatchV1OfferLettersIdSaveAsDraftRequest): Promise<Types.PatchV1OfferLettersIdSaveAsDraftResponses> => {
  return await _patchV1OfferLettersIdSaveAsDraft(baseUrl, request)
}
const _getV1OfferLettersIdPreviewPdf = async (url: string, request: Types.GetV1OfferLettersIdPreviewPdfRequest): Promise<Types.GetV1OfferLettersIdPreviewPdfResponses> => {
  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/offer-letters/${request['id']}/preview-pdf`, {
    headers
  })

  const textResponses = [200]
  if (textResponses.includes(response.status)) {
    return {
      statusCode: response.status as 200,
      headers: headersToJSON(response.headers),
      body: await response.text()
    }
  }
  if (response.headers.get('content-type') === 'application/json') {
    return {
      statusCode: response.status as 200,
      headers: headersToJSON(response.headers),
      body: await response.json() as any
    }
  }
  return {
    statusCode: response.status as 200,
    headers: headersToJSON(response.headers),
    body: await response.text() as any
  }
}

export const getV1OfferLettersIdPreviewPdf: Api['getV1OfferLettersIdPreviewPdf'] = async (request: Types.GetV1OfferLettersIdPreviewPdfRequest): Promise<Types.GetV1OfferLettersIdPreviewPdfResponses> => {
  return await _getV1OfferLettersIdPreviewPdf(baseUrl, request)
}
const _postV1OfferLettersIdSend = async (url: string, request: Types.PostV1OfferLettersIdSendRequest): Promise<Types.PostV1OfferLettersIdSendResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/offer-letters/${request['id']}/send`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1OfferLettersIdSend: Api['postV1OfferLettersIdSend'] = async (request: Types.PostV1OfferLettersIdSendRequest): Promise<Types.PostV1OfferLettersIdSendResponses> => {
  return await _postV1OfferLettersIdSend(baseUrl, request)
}
const _getV1OfferLettersPublicWelcomeToken = async (url: string, request: Types.GetV1OfferLettersPublicWelcomeTokenRequest): Promise<Types.GetV1OfferLettersPublicWelcomeTokenResponses> => {
  const headers = {
    ...defaultHeaders
  }

  const response = await fetch(`${url}/v1/offer-letters/public/welcome/${request['token']}`, {
    headers
  })

  const textResponses = [200]
  if (textResponses.includes(response.status)) {
    return {
      statusCode: response.status as 200,
      headers: headersToJSON(response.headers),
      body: await response.text()
    }
  }
  if (response.headers.get('content-type') === 'application/json') {
    return {
      statusCode: response.status as 200,
      headers: headersToJSON(response.headers),
      body: await response.json() as any
    }
  }
  return {
    statusCode: response.status as 200,
    headers: headersToJSON(response.headers),
    body: await response.text() as any
  }
}

export const getV1OfferLettersPublicWelcomeToken: Api['getV1OfferLettersPublicWelcomeToken'] = async (request: Types.GetV1OfferLettersPublicWelcomeTokenRequest): Promise<Types.GetV1OfferLettersPublicWelcomeTokenResponses> => {
  return await _getV1OfferLettersPublicWelcomeToken(baseUrl, request)
}
const _getV1OfferLettersPublicWelcomeTokenPdf = async (url: string, request: Types.GetV1OfferLettersPublicWelcomeTokenPdfRequest): Promise<Types.GetV1OfferLettersPublicWelcomeTokenPdfResponses> => {
  const headers = {
    ...defaultHeaders
  }

  const response = await fetch(`${url}/v1/offer-letters/public/welcome/${request['token']}/pdf`, {
    headers
  })

  const textResponses = [200]
  if (textResponses.includes(response.status)) {
    return {
      statusCode: response.status as 200,
      headers: headersToJSON(response.headers),
      body: await response.text()
    }
  }
  if (response.headers.get('content-type') === 'application/json') {
    return {
      statusCode: response.status as 200,
      headers: headersToJSON(response.headers),
      body: await response.json() as any
    }
  }
  return {
    statusCode: response.status as 200,
    headers: headersToJSON(response.headers),
    body: await response.text() as any
  }
}

export const getV1OfferLettersPublicWelcomeTokenPdf: Api['getV1OfferLettersPublicWelcomeTokenPdf'] = async (request: Types.GetV1OfferLettersPublicWelcomeTokenPdfRequest): Promise<Types.GetV1OfferLettersPublicWelcomeTokenPdfResponses> => {
  return await _getV1OfferLettersPublicWelcomeTokenPdf(baseUrl, request)
}
const _postV1OfferLettersPublicWelcomeTokenAccept = async (url: string, request: Types.PostV1OfferLettersPublicWelcomeTokenAcceptRequest): Promise<Types.PostV1OfferLettersPublicWelcomeTokenAcceptResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }

  const response = await fetch(`${url}/v1/offer-letters/public/welcome/${request['token']}/accept`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  const textResponses = [200]
  if (textResponses.includes(response.status)) {
    return {
      statusCode: response.status as 200,
      headers: headersToJSON(response.headers),
      body: await response.text()
    }
  }
  if (response.headers.get('content-type') === 'application/json') {
    return {
      statusCode: response.status as 200,
      headers: headersToJSON(response.headers),
      body: await response.json() as any
    }
  }
  return {
    statusCode: response.status as 200,
    headers: headersToJSON(response.headers),
    body: await response.text() as any
  }
}

export const postV1OfferLettersPublicWelcomeTokenAccept: Api['postV1OfferLettersPublicWelcomeTokenAccept'] = async (request: Types.PostV1OfferLettersPublicWelcomeTokenAcceptRequest): Promise<Types.PostV1OfferLettersPublicWelcomeTokenAcceptResponses> => {
  return await _postV1OfferLettersPublicWelcomeTokenAccept(baseUrl, request)
}
const _postV1OfferLettersPublicWelcomeTokenReject = async (url: string, request: Types.PostV1OfferLettersPublicWelcomeTokenRejectRequest): Promise<Types.PostV1OfferLettersPublicWelcomeTokenRejectResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }

  const response = await fetch(`${url}/v1/offer-letters/public/welcome/${request['token']}/reject`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  const textResponses = [200]
  if (textResponses.includes(response.status)) {
    return {
      statusCode: response.status as 200,
      headers: headersToJSON(response.headers),
      body: await response.text()
    }
  }
  if (response.headers.get('content-type') === 'application/json') {
    return {
      statusCode: response.status as 200,
      headers: headersToJSON(response.headers),
      body: await response.json() as any
    }
  }
  return {
    statusCode: response.status as 200,
    headers: headersToJSON(response.headers),
    body: await response.text() as any
  }
}

export const postV1OfferLettersPublicWelcomeTokenReject: Api['postV1OfferLettersPublicWelcomeTokenReject'] = async (request: Types.PostV1OfferLettersPublicWelcomeTokenRejectRequest): Promise<Types.PostV1OfferLettersPublicWelcomeTokenRejectResponses> => {
  return await _postV1OfferLettersPublicWelcomeTokenReject(baseUrl, request)
}
const _patchV1OfferLettersPublicWelcomeTokenDocumentsDocumentId = async (url: string, request: Types.PatchV1OfferLettersPublicWelcomeTokenDocumentsDocumentIdRequest): Promise<Types.PatchV1OfferLettersPublicWelcomeTokenDocumentsDocumentIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }

  const response = await fetch(`${url}/v1/offer-letters/public/welcome/${request['token']}/documents/${request['document_id']}`, {
    method: 'PATCH',
    body: JSON.stringify(request),
    headers
  })

  const textResponses = [200]
  if (textResponses.includes(response.status)) {
    return {
      statusCode: response.status as 200,
      headers: headersToJSON(response.headers),
      body: await response.text()
    }
  }
  if (response.headers.get('content-type') === 'application/json') {
    return {
      statusCode: response.status as 200,
      headers: headersToJSON(response.headers),
      body: await response.json() as any
    }
  }
  return {
    statusCode: response.status as 200,
    headers: headersToJSON(response.headers),
    body: await response.text() as any
  }
}

export const patchV1OfferLettersPublicWelcomeTokenDocumentsDocumentId: Api['patchV1OfferLettersPublicWelcomeTokenDocumentsDocumentId'] = async (request: Types.PatchV1OfferLettersPublicWelcomeTokenDocumentsDocumentIdRequest): Promise<Types.PatchV1OfferLettersPublicWelcomeTokenDocumentsDocumentIdResponses> => {
  return await _patchV1OfferLettersPublicWelcomeTokenDocumentsDocumentId(baseUrl, request)
}
const _postV1OfferLettersPublicWelcomeTokenSubmit = async (url: string, request: Types.PostV1OfferLettersPublicWelcomeTokenSubmitRequest): Promise<Types.PostV1OfferLettersPublicWelcomeTokenSubmitResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }

  const response = await fetch(`${url}/v1/offer-letters/public/welcome/${request['token']}/submit`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  const textResponses = [200]
  if (textResponses.includes(response.status)) {
    return {
      statusCode: response.status as 200,
      headers: headersToJSON(response.headers),
      body: await response.text()
    }
  }
  if (response.headers.get('content-type') === 'application/json') {
    return {
      statusCode: response.status as 200,
      headers: headersToJSON(response.headers),
      body: await response.json() as any
    }
  }
  return {
    statusCode: response.status as 200,
    headers: headersToJSON(response.headers),
    body: await response.text() as any
  }
}

export const postV1OfferLettersPublicWelcomeTokenSubmit: Api['postV1OfferLettersPublicWelcomeTokenSubmit'] = async (request: Types.PostV1OfferLettersPublicWelcomeTokenSubmitRequest): Promise<Types.PostV1OfferLettersPublicWelcomeTokenSubmitResponses> => {
  return await _postV1OfferLettersPublicWelcomeTokenSubmit(baseUrl, request)
}
const _postV1OfferLettersPublicWelcomeTokenDraft = async (url: string, request: Types.PostV1OfferLettersPublicWelcomeTokenDraftRequest): Promise<Types.PostV1OfferLettersPublicWelcomeTokenDraftResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }

  const response = await fetch(`${url}/v1/offer-letters/public/welcome/${request['token']}/draft`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  const textResponses = [200]
  if (textResponses.includes(response.status)) {
    return {
      statusCode: response.status as 200,
      headers: headersToJSON(response.headers),
      body: await response.text()
    }
  }
  if (response.headers.get('content-type') === 'application/json') {
    return {
      statusCode: response.status as 200,
      headers: headersToJSON(response.headers),
      body: await response.json() as any
    }
  }
  return {
    statusCode: response.status as 200,
    headers: headersToJSON(response.headers),
    body: await response.text() as any
  }
}

export const postV1OfferLettersPublicWelcomeTokenDraft: Api['postV1OfferLettersPublicWelcomeTokenDraft'] = async (request: Types.PostV1OfferLettersPublicWelcomeTokenDraftRequest): Promise<Types.PostV1OfferLettersPublicWelcomeTokenDraftResponses> => {
  return await _postV1OfferLettersPublicWelcomeTokenDraft(baseUrl, request)
}
const _postV1TimeCards = async (url: string, request: Types.PostV1TimeCardsRequest): Promise<Types.PostV1TimeCardsResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/time-cards/`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1TimeCards: Api['postV1TimeCards'] = async (request: Types.PostV1TimeCardsRequest): Promise<Types.PostV1TimeCardsResponses> => {
  return await _postV1TimeCards(baseUrl, request)
}
const _getV1TimeCards = async (url: string, request: Types.GetV1TimeCardsRequest): Promise<Types.GetV1TimeCardsResponses> => {
  const queryParameters: (keyof Types.GetV1TimeCardsRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/time-cards/?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1TimeCards: Api['getV1TimeCards'] = async (request: Types.GetV1TimeCardsRequest): Promise<Types.GetV1TimeCardsResponses> => {
  return await _getV1TimeCards(baseUrl, request)
}
const _getV1TimeCardsId = async (url: string, request: Types.GetV1TimeCardsIdRequest): Promise<Types.GetV1TimeCardsIdResponses> => {
  const queryParameters: (keyof Types.GetV1TimeCardsIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/time-cards/${request['id']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1TimeCardsId: Api['getV1TimeCardsId'] = async (request: Types.GetV1TimeCardsIdRequest): Promise<Types.GetV1TimeCardsIdResponses> => {
  return await _getV1TimeCardsId(baseUrl, request)
}
const _putV1TimeCardsId = async (url: string, request: Types.PutV1TimeCardsIdRequest): Promise<Types.PutV1TimeCardsIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/time-cards/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1TimeCardsId: Api['putV1TimeCardsId'] = async (request: Types.PutV1TimeCardsIdRequest): Promise<Types.PutV1TimeCardsIdResponses> => {
  return await _putV1TimeCardsId(baseUrl, request)
}
const _deleteV1TimeCardsId = async (url: string, request: Types.DeleteV1TimeCardsIdRequest): Promise<Types.DeleteV1TimeCardsIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/time-cards/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1TimeCardsId: Api['deleteV1TimeCardsId'] = async (request: Types.DeleteV1TimeCardsIdRequest): Promise<Types.DeleteV1TimeCardsIdResponses> => {
  return await _deleteV1TimeCardsId(baseUrl, request)
}
const _postV1TimeCardsSaveAsDraft = async (url: string, request: Types.PostV1TimeCardsSaveAsDraftRequest): Promise<Types.PostV1TimeCardsSaveAsDraftResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/time-cards/save-as-draft`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1TimeCardsSaveAsDraft: Api['postV1TimeCardsSaveAsDraft'] = async (request: Types.PostV1TimeCardsSaveAsDraftRequest): Promise<Types.PostV1TimeCardsSaveAsDraftResponses> => {
  return await _postV1TimeCardsSaveAsDraft(baseUrl, request)
}
const _patchV1TimeCardsIdSaveAsDraft = async (url: string, request: Types.PatchV1TimeCardsIdSaveAsDraftRequest): Promise<Types.PatchV1TimeCardsIdSaveAsDraftResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/time-cards/${request['id']}/save-as-draft`, {
    method: 'PATCH',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const patchV1TimeCardsIdSaveAsDraft: Api['patchV1TimeCardsIdSaveAsDraft'] = async (request: Types.PatchV1TimeCardsIdSaveAsDraftRequest): Promise<Types.PatchV1TimeCardsIdSaveAsDraftResponses> => {
  return await _patchV1TimeCardsIdSaveAsDraft(baseUrl, request)
}
const _postV1TimeCardsIdPost = async (url: string, request: Types.PostV1TimeCardsIdPostRequest): Promise<Types.PostV1TimeCardsIdPostResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/time-cards/${request['id']}/post`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1TimeCardsIdPost: Api['postV1TimeCardsIdPost'] = async (request: Types.PostV1TimeCardsIdPostRequest): Promise<Types.PostV1TimeCardsIdPostResponses> => {
  return await _postV1TimeCardsIdPost(baseUrl, request)
}
const _getV1TimeCardsGenerateExcel = async (url: string, request: Types.GetV1TimeCardsGenerateExcelRequest): Promise<Types.GetV1TimeCardsGenerateExcelResponses> => {
  const queryParameters: (keyof Types.GetV1TimeCardsGenerateExcelRequest)[]  = ['resource', 'filters', 'order', 'search', 'company_id']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['Content-Type'] !== undefined) {
    headers['Content-Type'] = request['Content-Type']
    delete request['Content-Type']
  }

  const response = await fetch(`${url}/v1/time-cards/generate-excel?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1TimeCardsGenerateExcel: Api['getV1TimeCardsGenerateExcel'] = async (request: Types.GetV1TimeCardsGenerateExcelRequest): Promise<Types.GetV1TimeCardsGenerateExcelResponses> => {
  return await _getV1TimeCardsGenerateExcel(baseUrl, request)
}
const _postV1TimeCardsImport = async (url: string, request: Types.PostV1TimeCardsImportRequest): Promise<Types.PostV1TimeCardsImportResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/time-cards/import`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1TimeCardsImport: Api['postV1TimeCardsImport'] = async (request: Types.PostV1TimeCardsImportRequest): Promise<Types.PostV1TimeCardsImportResponses> => {
  return await _postV1TimeCardsImport(baseUrl, request)
}
const _getV1TimeCardsIdEmployees = async (url: string, request: Types.GetV1TimeCardsIdEmployeesRequest): Promise<Types.GetV1TimeCardsIdEmployeesResponses> => {
  const queryParameters: (keyof Types.GetV1TimeCardsIdEmployeesRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/time-cards/${request['id']}/employees?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1TimeCardsIdEmployees: Api['getV1TimeCardsIdEmployees'] = async (request: Types.GetV1TimeCardsIdEmployeesRequest): Promise<Types.GetV1TimeCardsIdEmployeesResponses> => {
  return await _getV1TimeCardsIdEmployees(baseUrl, request)
}
const _postV1TimeCardsEmployees = async (url: string, request: Types.PostV1TimeCardsEmployeesRequest): Promise<Types.PostV1TimeCardsEmployeesResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/time-cards/employees`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1TimeCardsEmployees: Api['postV1TimeCardsEmployees'] = async (request: Types.PostV1TimeCardsEmployeesRequest): Promise<Types.PostV1TimeCardsEmployeesResponses> => {
  return await _postV1TimeCardsEmployees(baseUrl, request)
}
const _getV1TimeCardsIdEmployeeEmployeeId = async (url: string, request: Types.GetV1TimeCardsIdEmployeeEmployeeIdRequest): Promise<Types.GetV1TimeCardsIdEmployeeEmployeeIdResponses> => {
  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/time-cards/${request['id']}/employee/${request['employeeId']}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1TimeCardsIdEmployeeEmployeeId: Api['getV1TimeCardsIdEmployeeEmployeeId'] = async (request: Types.GetV1TimeCardsIdEmployeeEmployeeIdRequest): Promise<Types.GetV1TimeCardsIdEmployeeEmployeeIdResponses> => {
  return await _getV1TimeCardsIdEmployeeEmployeeId(baseUrl, request)
}
const _postV1TimeCardsEmployeeEmployeeId = async (url: string, request: Types.PostV1TimeCardsEmployeeEmployeeIdRequest): Promise<Types.PostV1TimeCardsEmployeeEmployeeIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/time-cards/employee/${request['employeeId']}`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1TimeCardsEmployeeEmployeeId: Api['postV1TimeCardsEmployeeEmployeeId'] = async (request: Types.PostV1TimeCardsEmployeeEmployeeIdRequest): Promise<Types.PostV1TimeCardsEmployeeEmployeeIdResponses> => {
  return await _postV1TimeCardsEmployeeEmployeeId(baseUrl, request)
}
const _postV1Timesheets = async (url: string, request: Types.PostV1TimesheetsRequest): Promise<Types.PostV1TimesheetsResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/timesheets/`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1Timesheets: Api['postV1Timesheets'] = async (request: Types.PostV1TimesheetsRequest): Promise<Types.PostV1TimesheetsResponses> => {
  return await _postV1Timesheets(baseUrl, request)
}
const _getV1Timesheets = async (url: string, request: Types.GetV1TimesheetsRequest): Promise<Types.GetV1TimesheetsResponses> => {
  const queryParameters: (keyof Types.GetV1TimesheetsRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/timesheets/?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1Timesheets: Api['getV1Timesheets'] = async (request: Types.GetV1TimesheetsRequest): Promise<Types.GetV1TimesheetsResponses> => {
  return await _getV1Timesheets(baseUrl, request)
}
const _getV1TimesheetsId = async (url: string, request: Types.GetV1TimesheetsIdRequest): Promise<Types.GetV1TimesheetsIdResponses> => {
  const queryParameters: (keyof Types.GetV1TimesheetsIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/timesheets/${request['id']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1TimesheetsId: Api['getV1TimesheetsId'] = async (request: Types.GetV1TimesheetsIdRequest): Promise<Types.GetV1TimesheetsIdResponses> => {
  return await _getV1TimesheetsId(baseUrl, request)
}
const _putV1TimesheetsId = async (url: string, request: Types.PutV1TimesheetsIdRequest): Promise<Types.PutV1TimesheetsIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/timesheets/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1TimesheetsId: Api['putV1TimesheetsId'] = async (request: Types.PutV1TimesheetsIdRequest): Promise<Types.PutV1TimesheetsIdResponses> => {
  return await _putV1TimesheetsId(baseUrl, request)
}
const _deleteV1TimesheetsId = async (url: string, request: Types.DeleteV1TimesheetsIdRequest): Promise<Types.DeleteV1TimesheetsIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/timesheets/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1TimesheetsId: Api['deleteV1TimesheetsId'] = async (request: Types.DeleteV1TimesheetsIdRequest): Promise<Types.DeleteV1TimesheetsIdResponses> => {
  return await _deleteV1TimesheetsId(baseUrl, request)
}
const _patchV1TimesheetsIdStatus = async (url: string, request: Types.PatchV1TimesheetsIdStatusRequest): Promise<Types.PatchV1TimesheetsIdStatusResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/timesheets/${request['id']}/status`, {
    method: 'PATCH',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const patchV1TimesheetsIdStatus: Api['patchV1TimesheetsIdStatus'] = async (request: Types.PatchV1TimesheetsIdStatusRequest): Promise<Types.PatchV1TimesheetsIdStatusResponses> => {
  return await _patchV1TimesheetsIdStatus(baseUrl, request)
}
const _postV1TimesheetsSaveAsDraft = async (url: string, request: Types.PostV1TimesheetsSaveAsDraftRequest): Promise<Types.PostV1TimesheetsSaveAsDraftResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/timesheets/save-as-draft`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1TimesheetsSaveAsDraft: Api['postV1TimesheetsSaveAsDraft'] = async (request: Types.PostV1TimesheetsSaveAsDraftRequest): Promise<Types.PostV1TimesheetsSaveAsDraftResponses> => {
  return await _postV1TimesheetsSaveAsDraft(baseUrl, request)
}
const _patchV1TimesheetsIdSaveAsDraft = async (url: string, request: Types.PatchV1TimesheetsIdSaveAsDraftRequest): Promise<Types.PatchV1TimesheetsIdSaveAsDraftResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/timesheets/${request['id']}/save-as-draft`, {
    method: 'PATCH',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const patchV1TimesheetsIdSaveAsDraft: Api['patchV1TimesheetsIdSaveAsDraft'] = async (request: Types.PatchV1TimesheetsIdSaveAsDraftRequest): Promise<Types.PatchV1TimesheetsIdSaveAsDraftResponses> => {
  return await _patchV1TimesheetsIdSaveAsDraft(baseUrl, request)
}
const _postV1TimesheetsGenerate = async (url: string, request: Types.PostV1TimesheetsGenerateRequest): Promise<Types.PostV1TimesheetsGenerateResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/timesheets/generate`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1TimesheetsGenerate: Api['postV1TimesheetsGenerate'] = async (request: Types.PostV1TimesheetsGenerateRequest): Promise<Types.PostV1TimesheetsGenerateResponses> => {
  return await _postV1TimesheetsGenerate(baseUrl, request)
}
const _getV1TimesheetsIdApprovalHistory = async (url: string, request: Types.GetV1TimesheetsIdApprovalHistoryRequest): Promise<Types.GetV1TimesheetsIdApprovalHistoryResponses> => {
  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/timesheets/${request['id']}/approval-history`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1TimesheetsIdApprovalHistory: Api['getV1TimesheetsIdApprovalHistory'] = async (request: Types.GetV1TimesheetsIdApprovalHistoryRequest): Promise<Types.GetV1TimesheetsIdApprovalHistoryResponses> => {
  return await _getV1TimesheetsIdApprovalHistory(baseUrl, request)
}
const _getV1TimesheetsIdPdf = async (url: string, request: Types.GetV1TimesheetsIdPdfRequest): Promise<Types.GetV1TimesheetsIdPdfResponses> => {
  const queryParameters: (keyof Types.GetV1TimesheetsIdPdfRequest)[]  = ['page']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/timesheets/${request['id']}/pdf?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1TimesheetsIdPdf: Api['getV1TimesheetsIdPdf'] = async (request: Types.GetV1TimesheetsIdPdfRequest): Promise<Types.GetV1TimesheetsIdPdfResponses> => {
  return await _getV1TimesheetsIdPdf(baseUrl, request)
}
const _postV1OrganisationStructure = async (url: string, request: Types.PostV1OrganisationStructureRequest): Promise<Types.PostV1OrganisationStructureResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/organisation-structure/`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1OrganisationStructure: Api['postV1OrganisationStructure'] = async (request: Types.PostV1OrganisationStructureRequest): Promise<Types.PostV1OrganisationStructureResponses> => {
  return await _postV1OrganisationStructure(baseUrl, request)
}
const _getV1OrganisationStructure = async (url: string, request: Types.GetV1OrganisationStructureRequest): Promise<Types.GetV1OrganisationStructureResponses> => {
  const queryParameters: (keyof Types.GetV1OrganisationStructureRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/organisation-structure/?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1OrganisationStructure: Api['getV1OrganisationStructure'] = async (request: Types.GetV1OrganisationStructureRequest): Promise<Types.GetV1OrganisationStructureResponses> => {
  return await _getV1OrganisationStructure(baseUrl, request)
}
const _getV1OrganisationStructureId = async (url: string, request: Types.GetV1OrganisationStructureIdRequest): Promise<Types.GetV1OrganisationStructureIdResponses> => {
  const queryParameters: (keyof Types.GetV1OrganisationStructureIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/organisation-structure/${request['id']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1OrganisationStructureId: Api['getV1OrganisationStructureId'] = async (request: Types.GetV1OrganisationStructureIdRequest): Promise<Types.GetV1OrganisationStructureIdResponses> => {
  return await _getV1OrganisationStructureId(baseUrl, request)
}
const _putV1OrganisationStructureId = async (url: string, request: Types.PutV1OrganisationStructureIdRequest): Promise<Types.PutV1OrganisationStructureIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/organisation-structure/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1OrganisationStructureId: Api['putV1OrganisationStructureId'] = async (request: Types.PutV1OrganisationStructureIdRequest): Promise<Types.PutV1OrganisationStructureIdResponses> => {
  return await _putV1OrganisationStructureId(baseUrl, request)
}
const _deleteV1OrganisationStructureId = async (url: string, request: Types.DeleteV1OrganisationStructureIdRequest): Promise<Types.DeleteV1OrganisationStructureIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/organisation-structure/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1OrganisationStructureId: Api['deleteV1OrganisationStructureId'] = async (request: Types.DeleteV1OrganisationStructureIdRequest): Promise<Types.DeleteV1OrganisationStructureIdResponses> => {
  return await _deleteV1OrganisationStructureId(baseUrl, request)
}
const _putV1OrganisationStructureIdTeamsTeamNodeIdTransferMembers = async (url: string, request: Types.PutV1OrganisationStructureIdTeamsTeamNodeIdTransferMembersRequest): Promise<Types.PutV1OrganisationStructureIdTeamsTeamNodeIdTransferMembersResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/organisation-structure/${request['id']}/teams/${request['team_node_id']}/transfer-members`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1OrganisationStructureIdTeamsTeamNodeIdTransferMembers: Api['putV1OrganisationStructureIdTeamsTeamNodeIdTransferMembers'] = async (request: Types.PutV1OrganisationStructureIdTeamsTeamNodeIdTransferMembersRequest): Promise<Types.PutV1OrganisationStructureIdTeamsTeamNodeIdTransferMembersResponses> => {
  return await _putV1OrganisationStructureIdTeamsTeamNodeIdTransferMembers(baseUrl, request)
}
const _getV1OrganisationStructureHierarchyLevels = async (url: string, request: Types.GetV1OrganisationStructureHierarchyLevelsRequest): Promise<Types.GetV1OrganisationStructureHierarchyLevelsResponses> => {
  const queryParameters: (keyof Types.GetV1OrganisationStructureHierarchyLevelsRequest)[]  = ['company_ids', 'location_ids']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/organisation-structure/hierarchy/levels?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1OrganisationStructureHierarchyLevels: Api['getV1OrganisationStructureHierarchyLevels'] = async (request: Types.GetV1OrganisationStructureHierarchyLevelsRequest): Promise<Types.GetV1OrganisationStructureHierarchyLevelsResponses> => {
  return await _getV1OrganisationStructureHierarchyLevels(baseUrl, request)
}
const _getV1OrganisationStructureHierarchy = async (url: string, request: Types.GetV1OrganisationStructureHierarchyRequest): Promise<Types.GetV1OrganisationStructureHierarchyResponses> => {
  const queryParameters: (keyof Types.GetV1OrganisationStructureHierarchyRequest)[]  = ['employee_id', 'type']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/organisation-structure/hierarchy?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1OrganisationStructureHierarchy: Api['getV1OrganisationStructureHierarchy'] = async (request: Types.GetV1OrganisationStructureHierarchyRequest): Promise<Types.GetV1OrganisationStructureHierarchyResponses> => {
  return await _getV1OrganisationStructureHierarchy(baseUrl, request)
}
const _postV1AssetRequests = async (url: string, request: Types.PostV1AssetRequestsRequest): Promise<Types.PostV1AssetRequestsResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/asset-requests/`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1AssetRequests: Api['postV1AssetRequests'] = async (request: Types.PostV1AssetRequestsRequest): Promise<Types.PostV1AssetRequestsResponses> => {
  return await _postV1AssetRequests(baseUrl, request)
}
const _getV1AssetRequests = async (url: string, request: Types.GetV1AssetRequestsRequest): Promise<Types.GetV1AssetRequestsResponses> => {
  const queryParameters: (keyof Types.GetV1AssetRequestsRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/asset-requests/?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1AssetRequests: Api['getV1AssetRequests'] = async (request: Types.GetV1AssetRequestsRequest): Promise<Types.GetV1AssetRequestsResponses> => {
  return await _getV1AssetRequests(baseUrl, request)
}
const _getV1AssetRequestsMyApprovals = async (url: string, request: Types.GetV1AssetRequestsMyApprovalsRequest): Promise<Types.GetV1AssetRequestsMyApprovalsResponses> => {
  const queryParameters: (keyof Types.GetV1AssetRequestsMyApprovalsRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select', 'approval_status']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/asset-requests/my-approvals?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1AssetRequestsMyApprovals: Api['getV1AssetRequestsMyApprovals'] = async (request: Types.GetV1AssetRequestsMyApprovalsRequest): Promise<Types.GetV1AssetRequestsMyApprovalsResponses> => {
  return await _getV1AssetRequestsMyApprovals(baseUrl, request)
}
const _getV1AssetRequestsId = async (url: string, request: Types.GetV1AssetRequestsIdRequest): Promise<Types.GetV1AssetRequestsIdResponses> => {
  const queryParameters: (keyof Types.GetV1AssetRequestsIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/asset-requests/${request['id']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1AssetRequestsId: Api['getV1AssetRequestsId'] = async (request: Types.GetV1AssetRequestsIdRequest): Promise<Types.GetV1AssetRequestsIdResponses> => {
  return await _getV1AssetRequestsId(baseUrl, request)
}
const _putV1AssetRequestsId = async (url: string, request: Types.PutV1AssetRequestsIdRequest): Promise<Types.PutV1AssetRequestsIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/asset-requests/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1AssetRequestsId: Api['putV1AssetRequestsId'] = async (request: Types.PutV1AssetRequestsIdRequest): Promise<Types.PutV1AssetRequestsIdResponses> => {
  return await _putV1AssetRequestsId(baseUrl, request)
}
const _deleteV1AssetRequestsId = async (url: string, request: Types.DeleteV1AssetRequestsIdRequest): Promise<Types.DeleteV1AssetRequestsIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/asset-requests/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1AssetRequestsId: Api['deleteV1AssetRequestsId'] = async (request: Types.DeleteV1AssetRequestsIdRequest): Promise<Types.DeleteV1AssetRequestsIdResponses> => {
  return await _deleteV1AssetRequestsId(baseUrl, request)
}
const _patchV1AssetRequestsIdStatus = async (url: string, request: Types.PatchV1AssetRequestsIdStatusRequest): Promise<Types.PatchV1AssetRequestsIdStatusResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/asset-requests/${request['id']}/status`, {
    method: 'PATCH',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const patchV1AssetRequestsIdStatus: Api['patchV1AssetRequestsIdStatus'] = async (request: Types.PatchV1AssetRequestsIdStatusRequest): Promise<Types.PatchV1AssetRequestsIdStatusResponses> => {
  return await _patchV1AssetRequestsIdStatus(baseUrl, request)
}
const _getV1AssetAllocationInUseAssets = async (url: string, request: Types.GetV1AssetAllocationInUseAssetsRequest): Promise<Types.GetV1AssetAllocationInUseAssetsResponses> => {
  const queryParameters: (keyof Types.GetV1AssetAllocationInUseAssetsRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/asset-allocation/in-use-assets?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1AssetAllocationInUseAssets: Api['getV1AssetAllocationInUseAssets'] = async (request: Types.GetV1AssetAllocationInUseAssetsRequest): Promise<Types.GetV1AssetAllocationInUseAssetsResponses> => {
  return await _getV1AssetAllocationInUseAssets(baseUrl, request)
}
const _postV1AssetAllocationTransfer = async (url: string, request: Types.PostV1AssetAllocationTransferRequest): Promise<Types.PostV1AssetAllocationTransferResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/asset-allocation/transfer`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1AssetAllocationTransfer: Api['postV1AssetAllocationTransfer'] = async (request: Types.PostV1AssetAllocationTransferRequest): Promise<Types.PostV1AssetAllocationTransferResponses> => {
  return await _postV1AssetAllocationTransfer(baseUrl, request)
}
const _getV1AssetAllocationRequestsIdAvailableAssets = async (url: string, request: Types.GetV1AssetAllocationRequestsIdAvailableAssetsRequest): Promise<Types.GetV1AssetAllocationRequestsIdAvailableAssetsResponses> => {
  const queryParameters: (keyof Types.GetV1AssetAllocationRequestsIdAvailableAssetsRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/asset-allocation/requests/${request['id']}/available-assets?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1AssetAllocationRequestsIdAvailableAssets: Api['getV1AssetAllocationRequestsIdAvailableAssets'] = async (request: Types.GetV1AssetAllocationRequestsIdAvailableAssetsRequest): Promise<Types.GetV1AssetAllocationRequestsIdAvailableAssetsResponses> => {
  return await _getV1AssetAllocationRequestsIdAvailableAssets(baseUrl, request)
}
const _postV1AssetAllocationRequestsIdAssign = async (url: string, request: Types.PostV1AssetAllocationRequestsIdAssignRequest): Promise<Types.PostV1AssetAllocationRequestsIdAssignResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/asset-allocation/requests/${request['id']}/assign`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1AssetAllocationRequestsIdAssign: Api['postV1AssetAllocationRequestsIdAssign'] = async (request: Types.PostV1AssetAllocationRequestsIdAssignRequest): Promise<Types.PostV1AssetAllocationRequestsIdAssignResponses> => {
  return await _postV1AssetAllocationRequestsIdAssign(baseUrl, request)
}
const _postV1AssetAllocationRequestsIdUnassign = async (url: string, request: Types.PostV1AssetAllocationRequestsIdUnassignRequest): Promise<Types.PostV1AssetAllocationRequestsIdUnassignResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/asset-allocation/requests/${request['id']}/unassign`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1AssetAllocationRequestsIdUnassign: Api['postV1AssetAllocationRequestsIdUnassign'] = async (request: Types.PostV1AssetAllocationRequestsIdUnassignRequest): Promise<Types.PostV1AssetAllocationRequestsIdUnassignResponses> => {
  return await _postV1AssetAllocationRequestsIdUnassign(baseUrl, request)
}
const _getV1ReceiveHandoverRequests = async (url: string, request: Types.GetV1ReceiveHandoverRequestsRequest): Promise<Types.GetV1ReceiveHandoverRequestsResponses> => {
  const queryParameters: (keyof Types.GetV1ReceiveHandoverRequestsRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/receive-handover/requests?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1ReceiveHandoverRequests: Api['getV1ReceiveHandoverRequests'] = async (request: Types.GetV1ReceiveHandoverRequestsRequest): Promise<Types.GetV1ReceiveHandoverRequestsResponses> => {
  return await _getV1ReceiveHandoverRequests(baseUrl, request)
}
const _getV1ReceiveHandoverRequestsReturns = async (url: string, request: Types.GetV1ReceiveHandoverRequestsReturnsRequest): Promise<Types.GetV1ReceiveHandoverRequestsReturnsResponses> => {
  const queryParameters: (keyof Types.GetV1ReceiveHandoverRequestsReturnsRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/receive-handover/requests/returns?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1ReceiveHandoverRequestsReturns: Api['getV1ReceiveHandoverRequestsReturns'] = async (request: Types.GetV1ReceiveHandoverRequestsReturnsRequest): Promise<Types.GetV1ReceiveHandoverRequestsReturnsResponses> => {
  return await _getV1ReceiveHandoverRequestsReturns(baseUrl, request)
}
const _getV1ReceiveHandoverRequestsId = async (url: string, request: Types.GetV1ReceiveHandoverRequestsIdRequest): Promise<Types.GetV1ReceiveHandoverRequestsIdResponses> => {
  const queryParameters: (keyof Types.GetV1ReceiveHandoverRequestsIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/receive-handover/requests/${request['id']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1ReceiveHandoverRequestsId: Api['getV1ReceiveHandoverRequestsId'] = async (request: Types.GetV1ReceiveHandoverRequestsIdRequest): Promise<Types.GetV1ReceiveHandoverRequestsIdResponses> => {
  return await _getV1ReceiveHandoverRequestsId(baseUrl, request)
}
const _postV1ReceiveHandoverRequestsIdComplete = async (url: string, request: Types.PostV1ReceiveHandoverRequestsIdCompleteRequest): Promise<Types.PostV1ReceiveHandoverRequestsIdCompleteResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/receive-handover/requests/${request['id']}/complete`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1ReceiveHandoverRequestsIdComplete: Api['postV1ReceiveHandoverRequestsIdComplete'] = async (request: Types.PostV1ReceiveHandoverRequestsIdCompleteRequest): Promise<Types.PostV1ReceiveHandoverRequestsIdCompleteResponses> => {
  return await _postV1ReceiveHandoverRequestsIdComplete(baseUrl, request)
}
const _postV1ReceiveHandoverRequestsIdProcessHandover = async (url: string, request: Types.PostV1ReceiveHandoverRequestsIdProcessHandoverRequest): Promise<Types.PostV1ReceiveHandoverRequestsIdProcessHandoverResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/receive-handover/requests/${request['id']}/process-handover`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1ReceiveHandoverRequestsIdProcessHandover: Api['postV1ReceiveHandoverRequestsIdProcessHandover'] = async (request: Types.PostV1ReceiveHandoverRequestsIdProcessHandoverRequest): Promise<Types.PostV1ReceiveHandoverRequestsIdProcessHandoverResponses> => {
  return await _postV1ReceiveHandoverRequestsIdProcessHandover(baseUrl, request)
}
const _getV1ReceiveHandoverMyAssets = async (url: string, request: Types.GetV1ReceiveHandoverMyAssetsRequest): Promise<Types.GetV1ReceiveHandoverMyAssetsResponses> => {
  const queryParameters: (keyof Types.GetV1ReceiveHandoverMyAssetsRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/receive-handover/my-assets?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1ReceiveHandoverMyAssets: Api['getV1ReceiveHandoverMyAssets'] = async (request: Types.GetV1ReceiveHandoverMyAssetsRequest): Promise<Types.GetV1ReceiveHandoverMyAssetsResponses> => {
  return await _getV1ReceiveHandoverMyAssets(baseUrl, request)
}
const _getV1ReceiveHandoverMyAssetsId = async (url: string, request: Types.GetV1ReceiveHandoverMyAssetsIdRequest): Promise<Types.GetV1ReceiveHandoverMyAssetsIdResponses> => {
  const queryParameters: (keyof Types.GetV1ReceiveHandoverMyAssetsIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/receive-handover/my-assets/${request['id']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1ReceiveHandoverMyAssetsId: Api['getV1ReceiveHandoverMyAssetsId'] = async (request: Types.GetV1ReceiveHandoverMyAssetsIdRequest): Promise<Types.GetV1ReceiveHandoverMyAssetsIdResponses> => {
  return await _getV1ReceiveHandoverMyAssetsId(baseUrl, request)
}
const _postV1ReceiveHandoverMyAssetsIdReturn = async (url: string, request: Types.PostV1ReceiveHandoverMyAssetsIdReturnRequest): Promise<Types.PostV1ReceiveHandoverMyAssetsIdReturnResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/receive-handover/my-assets/${request['id']}/return`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1ReceiveHandoverMyAssetsIdReturn: Api['postV1ReceiveHandoverMyAssetsIdReturn'] = async (request: Types.PostV1ReceiveHandoverMyAssetsIdReturnRequest): Promise<Types.PostV1ReceiveHandoverMyAssetsIdReturnResponses> => {
  return await _postV1ReceiveHandoverMyAssetsIdReturn(baseUrl, request)
}
const _getV1MyAssets = async (url: string, request: Types.GetV1MyAssetsRequest): Promise<Types.GetV1MyAssetsResponses> => {
  const queryParameters: (keyof Types.GetV1MyAssetsRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/my-assets/?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1MyAssets: Api['getV1MyAssets'] = async (request: Types.GetV1MyAssetsRequest): Promise<Types.GetV1MyAssetsResponses> => {
  return await _getV1MyAssets(baseUrl, request)
}
const _getV1MyAssetsReceivedAssets = async (url: string, request: Types.GetV1MyAssetsReceivedAssetsRequest): Promise<Types.GetV1MyAssetsReceivedAssetsResponses> => {
  const queryParameters: (keyof Types.GetV1MyAssetsReceivedAssetsRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/my-assets/received-assets?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1MyAssetsReceivedAssets: Api['getV1MyAssetsReceivedAssets'] = async (request: Types.GetV1MyAssetsReceivedAssetsRequest): Promise<Types.GetV1MyAssetsReceivedAssetsResponses> => {
  return await _getV1MyAssetsReceivedAssets(baseUrl, request)
}
const _getV1MyAssetsId = async (url: string, request: Types.GetV1MyAssetsIdRequest): Promise<Types.GetV1MyAssetsIdResponses> => {
  const queryParameters: (keyof Types.GetV1MyAssetsIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/my-assets/${request['id']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1MyAssetsId: Api['getV1MyAssetsId'] = async (request: Types.GetV1MyAssetsIdRequest): Promise<Types.GetV1MyAssetsIdResponses> => {
  return await _getV1MyAssetsId(baseUrl, request)
}
const _getV1MyAssetsCategoriesId = async (url: string, request: Types.GetV1MyAssetsCategoriesIdRequest): Promise<Types.GetV1MyAssetsCategoriesIdResponses> => {
  const queryParameters: (keyof Types.GetV1MyAssetsCategoriesIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select', 'employee_asset_id']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/my-assets/categories/${request['id']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1MyAssetsCategoriesId: Api['getV1MyAssetsCategoriesId'] = async (request: Types.GetV1MyAssetsCategoriesIdRequest): Promise<Types.GetV1MyAssetsCategoriesIdResponses> => {
  return await _getV1MyAssetsCategoriesId(baseUrl, request)
}
const _postV1MyAssetsReturn = async (url: string, request: Types.PostV1MyAssetsReturnRequest): Promise<Types.PostV1MyAssetsReturnResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/my-assets/return`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1MyAssetsReturn: Api['postV1MyAssetsReturn'] = async (request: Types.PostV1MyAssetsReturnRequest): Promise<Types.PostV1MyAssetsReturnResponses> => {
  return await _postV1MyAssetsReturn(baseUrl, request)
}
const _postV1DamageLossClaims = async (url: string, request: Types.PostV1DamageLossClaimsRequest): Promise<Types.PostV1DamageLossClaimsResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/damage-loss-claims/`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1DamageLossClaims: Api['postV1DamageLossClaims'] = async (request: Types.PostV1DamageLossClaimsRequest): Promise<Types.PostV1DamageLossClaimsResponses> => {
  return await _postV1DamageLossClaims(baseUrl, request)
}
const _getV1DamageLossClaims = async (url: string, request: Types.GetV1DamageLossClaimsRequest): Promise<Types.GetV1DamageLossClaimsResponses> => {
  const queryParameters: (keyof Types.GetV1DamageLossClaimsRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/damage-loss-claims/?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1DamageLossClaims: Api['getV1DamageLossClaims'] = async (request: Types.GetV1DamageLossClaimsRequest): Promise<Types.GetV1DamageLossClaimsResponses> => {
  return await _getV1DamageLossClaims(baseUrl, request)
}
const _getV1DamageLossClaimsId = async (url: string, request: Types.GetV1DamageLossClaimsIdRequest): Promise<Types.GetV1DamageLossClaimsIdResponses> => {
  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/damage-loss-claims/${request['id']}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1DamageLossClaimsId: Api['getV1DamageLossClaimsId'] = async (request: Types.GetV1DamageLossClaimsIdRequest): Promise<Types.GetV1DamageLossClaimsIdResponses> => {
  return await _getV1DamageLossClaimsId(baseUrl, request)
}
const _putV1DamageLossClaimsId = async (url: string, request: Types.PutV1DamageLossClaimsIdRequest): Promise<Types.PutV1DamageLossClaimsIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/damage-loss-claims/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1DamageLossClaimsId: Api['putV1DamageLossClaimsId'] = async (request: Types.PutV1DamageLossClaimsIdRequest): Promise<Types.PutV1DamageLossClaimsIdResponses> => {
  return await _putV1DamageLossClaimsId(baseUrl, request)
}
const _patchV1DamageLossClaimsIdStatus = async (url: string, request: Types.PatchV1DamageLossClaimsIdStatusRequest): Promise<Types.PatchV1DamageLossClaimsIdStatusResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/damage-loss-claims/${request['id']}/status`, {
    method: 'PATCH',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const patchV1DamageLossClaimsIdStatus: Api['patchV1DamageLossClaimsIdStatus'] = async (request: Types.PatchV1DamageLossClaimsIdStatusRequest): Promise<Types.PatchV1DamageLossClaimsIdStatusResponses> => {
  return await _patchV1DamageLossClaimsIdStatus(baseUrl, request)
}
const _postV1DamageLossClaimsIdSuggestSplit = async (url: string, request: Types.PostV1DamageLossClaimsIdSuggestSplitRequest): Promise<Types.PostV1DamageLossClaimsIdSuggestSplitResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/damage-loss-claims/${request['id']}/suggest-split`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1DamageLossClaimsIdSuggestSplit: Api['postV1DamageLossClaimsIdSuggestSplit'] = async (request: Types.PostV1DamageLossClaimsIdSuggestSplitRequest): Promise<Types.PostV1DamageLossClaimsIdSuggestSplitResponses> => {
  return await _postV1DamageLossClaimsIdSuggestSplit(baseUrl, request)
}
const _getV1AssetTracker = async (url: string, request: Types.GetV1AssetTrackerRequest): Promise<Types.GetV1AssetTrackerResponses> => {
  const queryParameters: (keyof Types.GetV1AssetTrackerRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/asset-tracker/?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1AssetTracker: Api['getV1AssetTracker'] = async (request: Types.GetV1AssetTrackerRequest): Promise<Types.GetV1AssetTrackerResponses> => {
  return await _getV1AssetTracker(baseUrl, request)
}
const _getV1AssetTrackerAssetsName = async (url: string, request: Types.GetV1AssetTrackerAssetsNameRequest): Promise<Types.GetV1AssetTrackerAssetsNameResponses> => {
  const queryParameters: (keyof Types.GetV1AssetTrackerAssetsNameRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/asset-tracker/assets/${request['name']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1AssetTrackerAssetsName: Api['getV1AssetTrackerAssetsName'] = async (request: Types.GetV1AssetTrackerAssetsNameRequest): Promise<Types.GetV1AssetTrackerAssetsNameResponses> => {
  return await _getV1AssetTrackerAssetsName(baseUrl, request)
}
const _postV1AssetTrackerAssetsAssetIdHistory = async (url: string, request: Types.PostV1AssetTrackerAssetsAssetIdHistoryRequest): Promise<Types.PostV1AssetTrackerAssetsAssetIdHistoryResponses> => {
  const queryParameters: (keyof Types.PostV1AssetTrackerAssetsAssetIdHistoryRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/asset-tracker/assets/${request['assetId']}/history?${searchParams.toString()}`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1AssetTrackerAssetsAssetIdHistory: Api['postV1AssetTrackerAssetsAssetIdHistory'] = async (request: Types.PostV1AssetTrackerAssetsAssetIdHistoryRequest): Promise<Types.PostV1AssetTrackerAssetsAssetIdHistoryResponses> => {
  return await _postV1AssetTrackerAssetsAssetIdHistory(baseUrl, request)
}
const _postV1ResourceAllocationRequests = async (url: string, request: Types.PostV1ResourceAllocationRequestsRequest): Promise<Types.PostV1ResourceAllocationRequestsResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/resource-allocation-requests/`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1ResourceAllocationRequests: Api['postV1ResourceAllocationRequests'] = async (request: Types.PostV1ResourceAllocationRequestsRequest): Promise<Types.PostV1ResourceAllocationRequestsResponses> => {
  return await _postV1ResourceAllocationRequests(baseUrl, request)
}
const _getV1ResourceAllocationRequests = async (url: string, request: Types.GetV1ResourceAllocationRequestsRequest): Promise<Types.GetV1ResourceAllocationRequestsResponses> => {
  const queryParameters: (keyof Types.GetV1ResourceAllocationRequestsRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/resource-allocation-requests/?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1ResourceAllocationRequests: Api['getV1ResourceAllocationRequests'] = async (request: Types.GetV1ResourceAllocationRequestsRequest): Promise<Types.GetV1ResourceAllocationRequestsResponses> => {
  return await _getV1ResourceAllocationRequests(baseUrl, request)
}
const _getV1ResourceAllocationRequestsApprovals = async (url: string, request: Types.GetV1ResourceAllocationRequestsApprovalsRequest): Promise<Types.GetV1ResourceAllocationRequestsApprovalsResponses> => {
  const queryParameters: (keyof Types.GetV1ResourceAllocationRequestsApprovalsRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/resource-allocation-requests/approvals?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1ResourceAllocationRequestsApprovals: Api['getV1ResourceAllocationRequestsApprovals'] = async (request: Types.GetV1ResourceAllocationRequestsApprovalsRequest): Promise<Types.GetV1ResourceAllocationRequestsApprovalsResponses> => {
  return await _getV1ResourceAllocationRequestsApprovals(baseUrl, request)
}
const _getV1ResourceAllocationRequestsId = async (url: string, request: Types.GetV1ResourceAllocationRequestsIdRequest): Promise<Types.GetV1ResourceAllocationRequestsIdResponses> => {
  const queryParameters: (keyof Types.GetV1ResourceAllocationRequestsIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/resource-allocation-requests/${request['id']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1ResourceAllocationRequestsId: Api['getV1ResourceAllocationRequestsId'] = async (request: Types.GetV1ResourceAllocationRequestsIdRequest): Promise<Types.GetV1ResourceAllocationRequestsIdResponses> => {
  return await _getV1ResourceAllocationRequestsId(baseUrl, request)
}
const _putV1ResourceAllocationRequestsId = async (url: string, request: Types.PutV1ResourceAllocationRequestsIdRequest): Promise<Types.PutV1ResourceAllocationRequestsIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/resource-allocation-requests/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1ResourceAllocationRequestsId: Api['putV1ResourceAllocationRequestsId'] = async (request: Types.PutV1ResourceAllocationRequestsIdRequest): Promise<Types.PutV1ResourceAllocationRequestsIdResponses> => {
  return await _putV1ResourceAllocationRequestsId(baseUrl, request)
}
const _deleteV1ResourceAllocationRequestsId = async (url: string, request: Types.DeleteV1ResourceAllocationRequestsIdRequest): Promise<Types.DeleteV1ResourceAllocationRequestsIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/resource-allocation-requests/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1ResourceAllocationRequestsId: Api['deleteV1ResourceAllocationRequestsId'] = async (request: Types.DeleteV1ResourceAllocationRequestsIdRequest): Promise<Types.DeleteV1ResourceAllocationRequestsIdResponses> => {
  return await _deleteV1ResourceAllocationRequestsId(baseUrl, request)
}
const _patchV1ResourceAllocationRequestsIdStatus = async (url: string, request: Types.PatchV1ResourceAllocationRequestsIdStatusRequest): Promise<Types.PatchV1ResourceAllocationRequestsIdStatusResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/resource-allocation-requests/${request['id']}/status`, {
    method: 'PATCH',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const patchV1ResourceAllocationRequestsIdStatus: Api['patchV1ResourceAllocationRequestsIdStatus'] = async (request: Types.PatchV1ResourceAllocationRequestsIdStatusRequest): Promise<Types.PatchV1ResourceAllocationRequestsIdStatusResponses> => {
  return await _patchV1ResourceAllocationRequestsIdStatus(baseUrl, request)
}
const _getV1ResourceAllocationRequestsGenerateExcel = async (url: string, request: Types.GetV1ResourceAllocationRequestsGenerateExcelRequest): Promise<Types.GetV1ResourceAllocationRequestsGenerateExcelResponses> => {
  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/resource-allocation-requests/generate-excel`, {
    headers
  })

  const textResponses = [200]
  if (textResponses.includes(response.status)) {
    return {
      statusCode: response.status as 200,
      headers: headersToJSON(response.headers),
      body: await response.text()
    }
  }
  if (response.headers.get('content-type') === 'application/json') {
    return {
      statusCode: response.status as 200,
      headers: headersToJSON(response.headers),
      body: await response.json() as any
    }
  }
  return {
    statusCode: response.status as 200,
    headers: headersToJSON(response.headers),
    body: await response.text() as any
  }
}

export const getV1ResourceAllocationRequestsGenerateExcel: Api['getV1ResourceAllocationRequestsGenerateExcel'] = async (request: Types.GetV1ResourceAllocationRequestsGenerateExcelRequest): Promise<Types.GetV1ResourceAllocationRequestsGenerateExcelResponses> => {
  return await _getV1ResourceAllocationRequestsGenerateExcel(baseUrl, request)
}
const _getV1ResourceAllocationAssignments = async (url: string, request: Types.GetV1ResourceAllocationAssignmentsRequest): Promise<Types.GetV1ResourceAllocationAssignmentsResponses> => {
  const queryParameters: (keyof Types.GetV1ResourceAllocationAssignmentsRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/resource-allocation-assignments/?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1ResourceAllocationAssignments: Api['getV1ResourceAllocationAssignments'] = async (request: Types.GetV1ResourceAllocationAssignmentsRequest): Promise<Types.GetV1ResourceAllocationAssignmentsResponses> => {
  return await _getV1ResourceAllocationAssignments(baseUrl, request)
}
const _getV1ResourceAllocationAssignmentsId = async (url: string, request: Types.GetV1ResourceAllocationAssignmentsIdRequest): Promise<Types.GetV1ResourceAllocationAssignmentsIdResponses> => {
  const queryParameters: (keyof Types.GetV1ResourceAllocationAssignmentsIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/resource-allocation-assignments/${request['id']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1ResourceAllocationAssignmentsId: Api['getV1ResourceAllocationAssignmentsId'] = async (request: Types.GetV1ResourceAllocationAssignmentsIdRequest): Promise<Types.GetV1ResourceAllocationAssignmentsIdResponses> => {
  return await _getV1ResourceAllocationAssignmentsId(baseUrl, request)
}
const _patchV1ResourceAllocationAssignmentsId = async (url: string, request: Types.PatchV1ResourceAllocationAssignmentsIdRequest): Promise<Types.PatchV1ResourceAllocationAssignmentsIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/resource-allocation-assignments/${request['id']}`, {
    method: 'PATCH',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const patchV1ResourceAllocationAssignmentsId: Api['patchV1ResourceAllocationAssignmentsId'] = async (request: Types.PatchV1ResourceAllocationAssignmentsIdRequest): Promise<Types.PatchV1ResourceAllocationAssignmentsIdResponses> => {
  return await _patchV1ResourceAllocationAssignmentsId(baseUrl, request)
}
const _getV1ResourceAllocationAssignmentsIdPositionPositionId = async (url: string, request: Types.GetV1ResourceAllocationAssignmentsIdPositionPositionIdRequest): Promise<Types.GetV1ResourceAllocationAssignmentsIdPositionPositionIdResponses> => {
  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/resource-allocation-assignments/${request['id']}/position/${request['positionId']}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1ResourceAllocationAssignmentsIdPositionPositionId: Api['getV1ResourceAllocationAssignmentsIdPositionPositionId'] = async (request: Types.GetV1ResourceAllocationAssignmentsIdPositionPositionIdRequest): Promise<Types.GetV1ResourceAllocationAssignmentsIdPositionPositionIdResponses> => {
  return await _getV1ResourceAllocationAssignmentsIdPositionPositionId(baseUrl, request)
}
const _postV1ResourceAllocationAssignmentsIdPositionPositionId = async (url: string, request: Types.PostV1ResourceAllocationAssignmentsIdPositionPositionIdRequest): Promise<Types.PostV1ResourceAllocationAssignmentsIdPositionPositionIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/resource-allocation-assignments/${request['id']}/position/${request['positionId']}`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1ResourceAllocationAssignmentsIdPositionPositionId: Api['postV1ResourceAllocationAssignmentsIdPositionPositionId'] = async (request: Types.PostV1ResourceAllocationAssignmentsIdPositionPositionIdRequest): Promise<Types.PostV1ResourceAllocationAssignmentsIdPositionPositionIdResponses> => {
  return await _postV1ResourceAllocationAssignmentsIdPositionPositionId(baseUrl, request)
}
const _postV1ResourceAllocationAssignmentsAvailableEmployees = async (url: string, request: Types.PostV1ResourceAllocationAssignmentsAvailableEmployeesRequest): Promise<Types.PostV1ResourceAllocationAssignmentsAvailableEmployeesResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/resource-allocation-assignments/available-employees`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1ResourceAllocationAssignmentsAvailableEmployees: Api['postV1ResourceAllocationAssignmentsAvailableEmployees'] = async (request: Types.PostV1ResourceAllocationAssignmentsAvailableEmployeesRequest): Promise<Types.PostV1ResourceAllocationAssignmentsAvailableEmployeesResponses> => {
  return await _postV1ResourceAllocationAssignmentsAvailableEmployees(baseUrl, request)
}
const _postV1LeaveRequestsLeaveManagement = async (url: string, request: Types.PostV1LeaveRequestsLeaveManagementRequest): Promise<Types.PostV1LeaveRequestsLeaveManagementResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/leave-requests/leave-management`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1LeaveRequestsLeaveManagement: Api['postV1LeaveRequestsLeaveManagement'] = async (request: Types.PostV1LeaveRequestsLeaveManagementRequest): Promise<Types.PostV1LeaveRequestsLeaveManagementResponses> => {
  return await _postV1LeaveRequestsLeaveManagement(baseUrl, request)
}
const _postV1LeaveRequests = async (url: string, request: Types.PostV1LeaveRequestsRequest): Promise<Types.PostV1LeaveRequestsResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/leave-requests/`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1LeaveRequests: Api['postV1LeaveRequests'] = async (request: Types.PostV1LeaveRequestsRequest): Promise<Types.PostV1LeaveRequestsResponses> => {
  return await _postV1LeaveRequests(baseUrl, request)
}
const _getV1LeaveRequests = async (url: string, request: Types.GetV1LeaveRequestsRequest): Promise<Types.GetV1LeaveRequestsResponses> => {
  const queryParameters: (keyof Types.GetV1LeaveRequestsRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/leave-requests/?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1LeaveRequests: Api['getV1LeaveRequests'] = async (request: Types.GetV1LeaveRequestsRequest): Promise<Types.GetV1LeaveRequestsResponses> => {
  return await _getV1LeaveRequests(baseUrl, request)
}
const _getV1LeaveRequestsPendingApprovals = async (url: string, request: Types.GetV1LeaveRequestsPendingApprovalsRequest): Promise<Types.GetV1LeaveRequestsPendingApprovalsResponses> => {
  const queryParameters: (keyof Types.GetV1LeaveRequestsPendingApprovalsRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/leave-requests/pending-approvals?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1LeaveRequestsPendingApprovals: Api['getV1LeaveRequestsPendingApprovals'] = async (request: Types.GetV1LeaveRequestsPendingApprovalsRequest): Promise<Types.GetV1LeaveRequestsPendingApprovalsResponses> => {
  return await _getV1LeaveRequestsPendingApprovals(baseUrl, request)
}
const _getV1LeaveRequestsId = async (url: string, request: Types.GetV1LeaveRequestsIdRequest): Promise<Types.GetV1LeaveRequestsIdResponses> => {
  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/leave-requests/${request['id']}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1LeaveRequestsId: Api['getV1LeaveRequestsId'] = async (request: Types.GetV1LeaveRequestsIdRequest): Promise<Types.GetV1LeaveRequestsIdResponses> => {
  return await _getV1LeaveRequestsId(baseUrl, request)
}
const _putV1LeaveRequestsId = async (url: string, request: Types.PutV1LeaveRequestsIdRequest): Promise<Types.PutV1LeaveRequestsIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/leave-requests/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1LeaveRequestsId: Api['putV1LeaveRequestsId'] = async (request: Types.PutV1LeaveRequestsIdRequest): Promise<Types.PutV1LeaveRequestsIdResponses> => {
  return await _putV1LeaveRequestsId(baseUrl, request)
}
const _deleteV1LeaveRequestsId = async (url: string, request: Types.DeleteV1LeaveRequestsIdRequest): Promise<Types.DeleteV1LeaveRequestsIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/leave-requests/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1LeaveRequestsId: Api['deleteV1LeaveRequestsId'] = async (request: Types.DeleteV1LeaveRequestsIdRequest): Promise<Types.DeleteV1LeaveRequestsIdResponses> => {
  return await _deleteV1LeaveRequestsId(baseUrl, request)
}
const _postV1LeaveRequestsSaveAsDraft = async (url: string, request: Types.PostV1LeaveRequestsSaveAsDraftRequest): Promise<Types.PostV1LeaveRequestsSaveAsDraftResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/leave-requests/save-as-draft`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1LeaveRequestsSaveAsDraft: Api['postV1LeaveRequestsSaveAsDraft'] = async (request: Types.PostV1LeaveRequestsSaveAsDraftRequest): Promise<Types.PostV1LeaveRequestsSaveAsDraftResponses> => {
  return await _postV1LeaveRequestsSaveAsDraft(baseUrl, request)
}
const _patchV1LeaveRequestsIdSaveAsDraft = async (url: string, request: Types.PatchV1LeaveRequestsIdSaveAsDraftRequest): Promise<Types.PatchV1LeaveRequestsIdSaveAsDraftResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/leave-requests/${request['id']}/save-as-draft`, {
    method: 'PATCH',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const patchV1LeaveRequestsIdSaveAsDraft: Api['patchV1LeaveRequestsIdSaveAsDraft'] = async (request: Types.PatchV1LeaveRequestsIdSaveAsDraftRequest): Promise<Types.PatchV1LeaveRequestsIdSaveAsDraftResponses> => {
  return await _patchV1LeaveRequestsIdSaveAsDraft(baseUrl, request)
}
const _patchV1LeaveRequestsIdStatus = async (url: string, request: Types.PatchV1LeaveRequestsIdStatusRequest): Promise<Types.PatchV1LeaveRequestsIdStatusResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/leave-requests/${request['id']}/status`, {
    method: 'PATCH',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const patchV1LeaveRequestsIdStatus: Api['patchV1LeaveRequestsIdStatus'] = async (request: Types.PatchV1LeaveRequestsIdStatusRequest): Promise<Types.PatchV1LeaveRequestsIdStatusResponses> => {
  return await _patchV1LeaveRequestsIdStatus(baseUrl, request)
}
const _getV1LeaveRequestsIdConflicts = async (url: string, request: Types.GetV1LeaveRequestsIdConflictsRequest): Promise<Types.GetV1LeaveRequestsIdConflictsResponses> => {
  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/leave-requests/${request['id']}/conflicts`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1LeaveRequestsIdConflicts: Api['getV1LeaveRequestsIdConflicts'] = async (request: Types.GetV1LeaveRequestsIdConflictsRequest): Promise<Types.GetV1LeaveRequestsIdConflictsResponses> => {
  return await _getV1LeaveRequestsIdConflicts(baseUrl, request)
}
const _getV1LeaveRequestsIdApprovalHistory = async (url: string, request: Types.GetV1LeaveRequestsIdApprovalHistoryRequest): Promise<Types.GetV1LeaveRequestsIdApprovalHistoryResponses> => {
  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/leave-requests/${request['id']}/approval-history`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1LeaveRequestsIdApprovalHistory: Api['getV1LeaveRequestsIdApprovalHistory'] = async (request: Types.GetV1LeaveRequestsIdApprovalHistoryRequest): Promise<Types.GetV1LeaveRequestsIdApprovalHistoryResponses> => {
  return await _getV1LeaveRequestsIdApprovalHistory(baseUrl, request)
}
const _postV1LeaveRequestsIdAdvancePayment = async (url: string, request: Types.PostV1LeaveRequestsIdAdvancePaymentRequest): Promise<Types.PostV1LeaveRequestsIdAdvancePaymentResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/leave-requests/${request['id']}/advance-payment`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1LeaveRequestsIdAdvancePayment: Api['postV1LeaveRequestsIdAdvancePayment'] = async (request: Types.PostV1LeaveRequestsIdAdvancePaymentRequest): Promise<Types.PostV1LeaveRequestsIdAdvancePaymentResponses> => {
  return await _postV1LeaveRequestsIdAdvancePayment(baseUrl, request)
}
const _getV1LeaveRequestsGenerateExcel = async (url: string, request: Types.GetV1LeaveRequestsGenerateExcelRequest): Promise<Types.GetV1LeaveRequestsGenerateExcelResponses> => {
  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/leave-requests/generate-excel`, {
    headers
  })

  const textResponses = [200]
  if (textResponses.includes(response.status)) {
    return {
      statusCode: response.status as 200,
      headers: headersToJSON(response.headers),
      body: await response.text()
    }
  }
  if (response.headers.get('content-type') === 'application/json') {
    return {
      statusCode: response.status as 200,
      headers: headersToJSON(response.headers),
      body: await response.json() as any
    }
  }
  return {
    statusCode: response.status as 200,
    headers: headersToJSON(response.headers),
    body: await response.text() as any
  }
}

export const getV1LeaveRequestsGenerateExcel: Api['getV1LeaveRequestsGenerateExcel'] = async (request: Types.GetV1LeaveRequestsGenerateExcelRequest): Promise<Types.GetV1LeaveRequestsGenerateExcelResponses> => {
  return await _getV1LeaveRequestsGenerateExcel(baseUrl, request)
}
const _postV1LeaveRequestsImport = async (url: string, request: Types.PostV1LeaveRequestsImportRequest): Promise<Types.PostV1LeaveRequestsImportResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/leave-requests/import`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  const textResponses = [200]
  if (textResponses.includes(response.status)) {
    return {
      statusCode: response.status as 200,
      headers: headersToJSON(response.headers),
      body: await response.text()
    }
  }
  if (response.headers.get('content-type') === 'application/json') {
    return {
      statusCode: response.status as 200,
      headers: headersToJSON(response.headers),
      body: await response.json() as any
    }
  }
  return {
    statusCode: response.status as 200,
    headers: headersToJSON(response.headers),
    body: await response.text() as any
  }
}

export const postV1LeaveRequestsImport: Api['postV1LeaveRequestsImport'] = async (request: Types.PostV1LeaveRequestsImportRequest): Promise<Types.PostV1LeaveRequestsImportResponses> => {
  return await _postV1LeaveRequestsImport(baseUrl, request)
}
const _putV1LeaveRequestsLeaveRequestIdAttachments = async (url: string, request: Types.PutV1LeaveRequestsLeaveRequestIdAttachmentsRequest): Promise<Types.PutV1LeaveRequestsLeaveRequestIdAttachmentsResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/leave-requests/${request['leave_request_id']}/attachments`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1LeaveRequestsLeaveRequestIdAttachments: Api['putV1LeaveRequestsLeaveRequestIdAttachments'] = async (request: Types.PutV1LeaveRequestsLeaveRequestIdAttachmentsRequest): Promise<Types.PutV1LeaveRequestsLeaveRequestIdAttachmentsResponses> => {
  return await _putV1LeaveRequestsLeaveRequestIdAttachments(baseUrl, request)
}
const _postV1LeaveManagement = async (url: string, request: Types.PostV1LeaveManagementRequest): Promise<Types.PostV1LeaveManagementResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/leave-management/`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1LeaveManagement: Api['postV1LeaveManagement'] = async (request: Types.PostV1LeaveManagementRequest): Promise<Types.PostV1LeaveManagementResponses> => {
  return await _postV1LeaveManagement(baseUrl, request)
}
const _getV1LeaveManagement = async (url: string, request: Types.GetV1LeaveManagementRequest): Promise<Types.GetV1LeaveManagementResponses> => {
  const queryParameters: (keyof Types.GetV1LeaveManagementRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/leave-management/?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1LeaveManagement: Api['getV1LeaveManagement'] = async (request: Types.GetV1LeaveManagementRequest): Promise<Types.GetV1LeaveManagementResponses> => {
  return await _getV1LeaveManagement(baseUrl, request)
}
const _getV1LeaveManagementPendingApprovals = async (url: string, request: Types.GetV1LeaveManagementPendingApprovalsRequest): Promise<Types.GetV1LeaveManagementPendingApprovalsResponses> => {
  const queryParameters: (keyof Types.GetV1LeaveManagementPendingApprovalsRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/leave-management/pending-approvals?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1LeaveManagementPendingApprovals: Api['getV1LeaveManagementPendingApprovals'] = async (request: Types.GetV1LeaveManagementPendingApprovalsRequest): Promise<Types.GetV1LeaveManagementPendingApprovalsResponses> => {
  return await _getV1LeaveManagementPendingApprovals(baseUrl, request)
}
const _getV1LeaveManagementId = async (url: string, request: Types.GetV1LeaveManagementIdRequest): Promise<Types.GetV1LeaveManagementIdResponses> => {
  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/leave-management/${request['id']}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1LeaveManagementId: Api['getV1LeaveManagementId'] = async (request: Types.GetV1LeaveManagementIdRequest): Promise<Types.GetV1LeaveManagementIdResponses> => {
  return await _getV1LeaveManagementId(baseUrl, request)
}
const _putV1LeaveManagementId = async (url: string, request: Types.PutV1LeaveManagementIdRequest): Promise<Types.PutV1LeaveManagementIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/leave-management/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1LeaveManagementId: Api['putV1LeaveManagementId'] = async (request: Types.PutV1LeaveManagementIdRequest): Promise<Types.PutV1LeaveManagementIdResponses> => {
  return await _putV1LeaveManagementId(baseUrl, request)
}
const _deleteV1LeaveManagementId = async (url: string, request: Types.DeleteV1LeaveManagementIdRequest): Promise<Types.DeleteV1LeaveManagementIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/leave-management/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1LeaveManagementId: Api['deleteV1LeaveManagementId'] = async (request: Types.DeleteV1LeaveManagementIdRequest): Promise<Types.DeleteV1LeaveManagementIdResponses> => {
  return await _deleteV1LeaveManagementId(baseUrl, request)
}
const _postV1LeaveManagementSaveAsDraft = async (url: string, request: Types.PostV1LeaveManagementSaveAsDraftRequest): Promise<Types.PostV1LeaveManagementSaveAsDraftResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/leave-management/save-as-draft`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1LeaveManagementSaveAsDraft: Api['postV1LeaveManagementSaveAsDraft'] = async (request: Types.PostV1LeaveManagementSaveAsDraftRequest): Promise<Types.PostV1LeaveManagementSaveAsDraftResponses> => {
  return await _postV1LeaveManagementSaveAsDraft(baseUrl, request)
}
const _patchV1LeaveManagementIdSaveAsDraft = async (url: string, request: Types.PatchV1LeaveManagementIdSaveAsDraftRequest): Promise<Types.PatchV1LeaveManagementIdSaveAsDraftResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/leave-management/${request['id']}/save-as-draft`, {
    method: 'PATCH',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const patchV1LeaveManagementIdSaveAsDraft: Api['patchV1LeaveManagementIdSaveAsDraft'] = async (request: Types.PatchV1LeaveManagementIdSaveAsDraftRequest): Promise<Types.PatchV1LeaveManagementIdSaveAsDraftResponses> => {
  return await _patchV1LeaveManagementIdSaveAsDraft(baseUrl, request)
}
const _patchV1LeaveManagementIdStatus = async (url: string, request: Types.PatchV1LeaveManagementIdStatusRequest): Promise<Types.PatchV1LeaveManagementIdStatusResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/leave-management/${request['id']}/status`, {
    method: 'PATCH',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const patchV1LeaveManagementIdStatus: Api['patchV1LeaveManagementIdStatus'] = async (request: Types.PatchV1LeaveManagementIdStatusRequest): Promise<Types.PatchV1LeaveManagementIdStatusResponses> => {
  return await _patchV1LeaveManagementIdStatus(baseUrl, request)
}
const _getV1LeaveManagementIdConflicts = async (url: string, request: Types.GetV1LeaveManagementIdConflictsRequest): Promise<Types.GetV1LeaveManagementIdConflictsResponses> => {
  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/leave-management/${request['id']}/conflicts`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1LeaveManagementIdConflicts: Api['getV1LeaveManagementIdConflicts'] = async (request: Types.GetV1LeaveManagementIdConflictsRequest): Promise<Types.GetV1LeaveManagementIdConflictsResponses> => {
  return await _getV1LeaveManagementIdConflicts(baseUrl, request)
}
const _getV1LeaveManagementIdApprovalHistory = async (url: string, request: Types.GetV1LeaveManagementIdApprovalHistoryRequest): Promise<Types.GetV1LeaveManagementIdApprovalHistoryResponses> => {
  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/leave-management/${request['id']}/approval-history`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1LeaveManagementIdApprovalHistory: Api['getV1LeaveManagementIdApprovalHistory'] = async (request: Types.GetV1LeaveManagementIdApprovalHistoryRequest): Promise<Types.GetV1LeaveManagementIdApprovalHistoryResponses> => {
  return await _getV1LeaveManagementIdApprovalHistory(baseUrl, request)
}
const _postV1LeaveManagementIdAdvancePayment = async (url: string, request: Types.PostV1LeaveManagementIdAdvancePaymentRequest): Promise<Types.PostV1LeaveManagementIdAdvancePaymentResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/leave-management/${request['id']}/advance-payment`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1LeaveManagementIdAdvancePayment: Api['postV1LeaveManagementIdAdvancePayment'] = async (request: Types.PostV1LeaveManagementIdAdvancePaymentRequest): Promise<Types.PostV1LeaveManagementIdAdvancePaymentResponses> => {
  return await _postV1LeaveManagementIdAdvancePayment(baseUrl, request)
}
const _putV1LeaveManagementLeaveRequestIdAttachments = async (url: string, request: Types.PutV1LeaveManagementLeaveRequestIdAttachmentsRequest): Promise<Types.PutV1LeaveManagementLeaveRequestIdAttachmentsResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/leave-management/${request['leave_request_id']}/attachments`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1LeaveManagementLeaveRequestIdAttachments: Api['putV1LeaveManagementLeaveRequestIdAttachments'] = async (request: Types.PutV1LeaveManagementLeaveRequestIdAttachmentsRequest): Promise<Types.PutV1LeaveManagementLeaveRequestIdAttachmentsResponses> => {
  return await _putV1LeaveManagementLeaveRequestIdAttachments(baseUrl, request)
}
const _postV1Resignations = async (url: string, request: Types.PostV1ResignationsRequest): Promise<Types.PostV1ResignationsResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/resignations/`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1Resignations: Api['postV1Resignations'] = async (request: Types.PostV1ResignationsRequest): Promise<Types.PostV1ResignationsResponses> => {
  return await _postV1Resignations(baseUrl, request)
}
const _getV1Resignations = async (url: string, request: Types.GetV1ResignationsRequest): Promise<Types.GetV1ResignationsResponses> => {
  const queryParameters: (keyof Types.GetV1ResignationsRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/resignations/?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1Resignations: Api['getV1Resignations'] = async (request: Types.GetV1ResignationsRequest): Promise<Types.GetV1ResignationsResponses> => {
  return await _getV1Resignations(baseUrl, request)
}
const _getV1ResignationsMyApprovals = async (url: string, request: Types.GetV1ResignationsMyApprovalsRequest): Promise<Types.GetV1ResignationsMyApprovalsResponses> => {
  const queryParameters: (keyof Types.GetV1ResignationsMyApprovalsRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select', 'approval_status']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/resignations/my-approvals?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1ResignationsMyApprovals: Api['getV1ResignationsMyApprovals'] = async (request: Types.GetV1ResignationsMyApprovalsRequest): Promise<Types.GetV1ResignationsMyApprovalsResponses> => {
  return await _getV1ResignationsMyApprovals(baseUrl, request)
}
const _getV1ResignationsId = async (url: string, request: Types.GetV1ResignationsIdRequest): Promise<Types.GetV1ResignationsIdResponses> => {
  const queryParameters: (keyof Types.GetV1ResignationsIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/resignations/${request['id']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1ResignationsId: Api['getV1ResignationsId'] = async (request: Types.GetV1ResignationsIdRequest): Promise<Types.GetV1ResignationsIdResponses> => {
  return await _getV1ResignationsId(baseUrl, request)
}
const _putV1ResignationsId = async (url: string, request: Types.PutV1ResignationsIdRequest): Promise<Types.PutV1ResignationsIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/resignations/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1ResignationsId: Api['putV1ResignationsId'] = async (request: Types.PutV1ResignationsIdRequest): Promise<Types.PutV1ResignationsIdResponses> => {
  return await _putV1ResignationsId(baseUrl, request)
}
const _deleteV1ResignationsId = async (url: string, request: Types.DeleteV1ResignationsIdRequest): Promise<Types.DeleteV1ResignationsIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/resignations/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1ResignationsId: Api['deleteV1ResignationsId'] = async (request: Types.DeleteV1ResignationsIdRequest): Promise<Types.DeleteV1ResignationsIdResponses> => {
  return await _deleteV1ResignationsId(baseUrl, request)
}
const _getV1ResignationsIdAssignedAssets = async (url: string, request: Types.GetV1ResignationsIdAssignedAssetsRequest): Promise<Types.GetV1ResignationsIdAssignedAssetsResponses> => {
  const queryParameters: (keyof Types.GetV1ResignationsIdAssignedAssetsRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/resignations/${request['id']}/assigned-assets?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1ResignationsIdAssignedAssets: Api['getV1ResignationsIdAssignedAssets'] = async (request: Types.GetV1ResignationsIdAssignedAssetsRequest): Promise<Types.GetV1ResignationsIdAssignedAssetsResponses> => {
  return await _getV1ResignationsIdAssignedAssets(baseUrl, request)
}
const _patchV1ResignationsIdStatus = async (url: string, request: Types.PatchV1ResignationsIdStatusRequest): Promise<Types.PatchV1ResignationsIdStatusResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/resignations/${request['id']}/status`, {
    method: 'PATCH',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const patchV1ResignationsIdStatus: Api['patchV1ResignationsIdStatus'] = async (request: Types.PatchV1ResignationsIdStatusRequest): Promise<Types.PatchV1ResignationsIdStatusResponses> => {
  return await _patchV1ResignationsIdStatus(baseUrl, request)
}
const _postV1ResignationsImport = async (url: string, request: Types.PostV1ResignationsImportRequest): Promise<Types.PostV1ResignationsImportResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/resignations/import`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  const textResponses = [200]
  if (textResponses.includes(response.status)) {
    return {
      statusCode: response.status as 200,
      headers: headersToJSON(response.headers),
      body: await response.text()
    }
  }
  if (response.headers.get('content-type') === 'application/json') {
    return {
      statusCode: response.status as 200,
      headers: headersToJSON(response.headers),
      body: await response.json() as any
    }
  }
  return {
    statusCode: response.status as 200,
    headers: headersToJSON(response.headers),
    body: await response.text() as any
  }
}

export const postV1ResignationsImport: Api['postV1ResignationsImport'] = async (request: Types.PostV1ResignationsImportRequest): Promise<Types.PostV1ResignationsImportResponses> => {
  return await _postV1ResignationsImport(baseUrl, request)
}
const _getV1ResignationsGenerateExcel = async (url: string, request: Types.GetV1ResignationsGenerateExcelRequest): Promise<Types.GetV1ResignationsGenerateExcelResponses> => {
  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/resignations/generate-excel`, {
    headers
  })

  const textResponses = [200]
  if (textResponses.includes(response.status)) {
    return {
      statusCode: response.status as 200,
      headers: headersToJSON(response.headers),
      body: await response.text()
    }
  }
  if (response.headers.get('content-type') === 'application/json') {
    return {
      statusCode: response.status as 200,
      headers: headersToJSON(response.headers),
      body: await response.json() as any
    }
  }
  return {
    statusCode: response.status as 200,
    headers: headersToJSON(response.headers),
    body: await response.text() as any
  }
}

export const getV1ResignationsGenerateExcel: Api['getV1ResignationsGenerateExcel'] = async (request: Types.GetV1ResignationsGenerateExcelRequest): Promise<Types.GetV1ResignationsGenerateExcelResponses> => {
  return await _getV1ResignationsGenerateExcel(baseUrl, request)
}
const _postV1Terminations = async (url: string, request: Types.PostV1TerminationsRequest): Promise<Types.PostV1TerminationsResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/terminations/`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1Terminations: Api['postV1Terminations'] = async (request: Types.PostV1TerminationsRequest): Promise<Types.PostV1TerminationsResponses> => {
  return await _postV1Terminations(baseUrl, request)
}
const _getV1Terminations = async (url: string, request: Types.GetV1TerminationsRequest): Promise<Types.GetV1TerminationsResponses> => {
  const queryParameters: (keyof Types.GetV1TerminationsRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/terminations/?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1Terminations: Api['getV1Terminations'] = async (request: Types.GetV1TerminationsRequest): Promise<Types.GetV1TerminationsResponses> => {
  return await _getV1Terminations(baseUrl, request)
}
const _getV1TerminationsMyApprovals = async (url: string, request: Types.GetV1TerminationsMyApprovalsRequest): Promise<Types.GetV1TerminationsMyApprovalsResponses> => {
  const queryParameters: (keyof Types.GetV1TerminationsMyApprovalsRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select', 'approval_status']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/terminations/my-approvals?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1TerminationsMyApprovals: Api['getV1TerminationsMyApprovals'] = async (request: Types.GetV1TerminationsMyApprovalsRequest): Promise<Types.GetV1TerminationsMyApprovalsResponses> => {
  return await _getV1TerminationsMyApprovals(baseUrl, request)
}
const _getV1TerminationsId = async (url: string, request: Types.GetV1TerminationsIdRequest): Promise<Types.GetV1TerminationsIdResponses> => {
  const queryParameters: (keyof Types.GetV1TerminationsIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/terminations/${request['id']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1TerminationsId: Api['getV1TerminationsId'] = async (request: Types.GetV1TerminationsIdRequest): Promise<Types.GetV1TerminationsIdResponses> => {
  return await _getV1TerminationsId(baseUrl, request)
}
const _putV1TerminationsId = async (url: string, request: Types.PutV1TerminationsIdRequest): Promise<Types.PutV1TerminationsIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/terminations/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1TerminationsId: Api['putV1TerminationsId'] = async (request: Types.PutV1TerminationsIdRequest): Promise<Types.PutV1TerminationsIdResponses> => {
  return await _putV1TerminationsId(baseUrl, request)
}
const _deleteV1TerminationsId = async (url: string, request: Types.DeleteV1TerminationsIdRequest): Promise<Types.DeleteV1TerminationsIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/terminations/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1TerminationsId: Api['deleteV1TerminationsId'] = async (request: Types.DeleteV1TerminationsIdRequest): Promise<Types.DeleteV1TerminationsIdResponses> => {
  return await _deleteV1TerminationsId(baseUrl, request)
}
const _getV1TerminationsIdAssignedAssets = async (url: string, request: Types.GetV1TerminationsIdAssignedAssetsRequest): Promise<Types.GetV1TerminationsIdAssignedAssetsResponses> => {
  const queryParameters: (keyof Types.GetV1TerminationsIdAssignedAssetsRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/terminations/${request['id']}/assigned-assets?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1TerminationsIdAssignedAssets: Api['getV1TerminationsIdAssignedAssets'] = async (request: Types.GetV1TerminationsIdAssignedAssetsRequest): Promise<Types.GetV1TerminationsIdAssignedAssetsResponses> => {
  return await _getV1TerminationsIdAssignedAssets(baseUrl, request)
}
const _patchV1TerminationsIdInitiate = async (url: string, request: Types.PatchV1TerminationsIdInitiateRequest): Promise<Types.PatchV1TerminationsIdInitiateResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/terminations/${request['id']}/initiate`, {
    method: 'PATCH',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const patchV1TerminationsIdInitiate: Api['patchV1TerminationsIdInitiate'] = async (request: Types.PatchV1TerminationsIdInitiateRequest): Promise<Types.PatchV1TerminationsIdInitiateResponses> => {
  return await _patchV1TerminationsIdInitiate(baseUrl, request)
}
const _patchV1TerminationsIdStatus = async (url: string, request: Types.PatchV1TerminationsIdStatusRequest): Promise<Types.PatchV1TerminationsIdStatusResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/terminations/${request['id']}/status`, {
    method: 'PATCH',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const patchV1TerminationsIdStatus: Api['patchV1TerminationsIdStatus'] = async (request: Types.PatchV1TerminationsIdStatusRequest): Promise<Types.PatchV1TerminationsIdStatusResponses> => {
  return await _patchV1TerminationsIdStatus(baseUrl, request)
}
const _postV1TerminationsImport = async (url: string, request: Types.PostV1TerminationsImportRequest): Promise<Types.PostV1TerminationsImportResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/terminations/import`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  const textResponses = [200]
  if (textResponses.includes(response.status)) {
    return {
      statusCode: response.status as 200,
      headers: headersToJSON(response.headers),
      body: await response.text()
    }
  }
  if (response.headers.get('content-type') === 'application/json') {
    return {
      statusCode: response.status as 200,
      headers: headersToJSON(response.headers),
      body: await response.json() as any
    }
  }
  return {
    statusCode: response.status as 200,
    headers: headersToJSON(response.headers),
    body: await response.text() as any
  }
}

export const postV1TerminationsImport: Api['postV1TerminationsImport'] = async (request: Types.PostV1TerminationsImportRequest): Promise<Types.PostV1TerminationsImportResponses> => {
  return await _postV1TerminationsImport(baseUrl, request)
}
const _getV1TerminationsGenerateExcel = async (url: string, request: Types.GetV1TerminationsGenerateExcelRequest): Promise<Types.GetV1TerminationsGenerateExcelResponses> => {
  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/terminations/generate-excel`, {
    headers
  })

  const textResponses = [200]
  if (textResponses.includes(response.status)) {
    return {
      statusCode: response.status as 200,
      headers: headersToJSON(response.headers),
      body: await response.text()
    }
  }
  if (response.headers.get('content-type') === 'application/json') {
    return {
      statusCode: response.status as 200,
      headers: headersToJSON(response.headers),
      body: await response.json() as any
    }
  }
  return {
    statusCode: response.status as 200,
    headers: headersToJSON(response.headers),
    body: await response.text() as any
  }
}

export const getV1TerminationsGenerateExcel: Api['getV1TerminationsGenerateExcel'] = async (request: Types.GetV1TerminationsGenerateExcelRequest): Promise<Types.GetV1TerminationsGenerateExcelResponses> => {
  return await _getV1TerminationsGenerateExcel(baseUrl, request)
}
const _getV1TerminationsIdTerminationLetter = async (url: string, request: Types.GetV1TerminationsIdTerminationLetterRequest): Promise<Types.GetV1TerminationsIdTerminationLetterResponses> => {
  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/terminations/${request['id']}/termination-letter`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1TerminationsIdTerminationLetter: Api['getV1TerminationsIdTerminationLetter'] = async (request: Types.GetV1TerminationsIdTerminationLetterRequest): Promise<Types.GetV1TerminationsIdTerminationLetterResponses> => {
  return await _getV1TerminationsIdTerminationLetter(baseUrl, request)
}
const _patchV1ResignationSettlementsIdAssetClearance = async (url: string, request: Types.PatchV1ResignationSettlementsIdAssetClearanceRequest): Promise<Types.PatchV1ResignationSettlementsIdAssetClearanceResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/resignation-settlements/${request['id']}/asset-clearance`, {
    method: 'PATCH',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const patchV1ResignationSettlementsIdAssetClearance: Api['patchV1ResignationSettlementsIdAssetClearance'] = async (request: Types.PatchV1ResignationSettlementsIdAssetClearanceRequest): Promise<Types.PatchV1ResignationSettlementsIdAssetClearanceResponses> => {
  return await _patchV1ResignationSettlementsIdAssetClearance(baseUrl, request)
}
const _getV1ResignationSettlementsIdDetail = async (url: string, request: Types.GetV1ResignationSettlementsIdDetailRequest): Promise<Types.GetV1ResignationSettlementsIdDetailResponses> => {
  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/resignation-settlements/${request['id']}/detail`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1ResignationSettlementsIdDetail: Api['getV1ResignationSettlementsIdDetail'] = async (request: Types.GetV1ResignationSettlementsIdDetailRequest): Promise<Types.GetV1ResignationSettlementsIdDetailResponses> => {
  return await _getV1ResignationSettlementsIdDetail(baseUrl, request)
}
const _getV1ResignationSettlementsIdEmployeeFinancialOverview = async (url: string, request: Types.GetV1ResignationSettlementsIdEmployeeFinancialOverviewRequest): Promise<Types.GetV1ResignationSettlementsIdEmployeeFinancialOverviewResponses> => {
  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/resignation-settlements/${request['id']}/employee-financial-overview`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1ResignationSettlementsIdEmployeeFinancialOverview: Api['getV1ResignationSettlementsIdEmployeeFinancialOverview'] = async (request: Types.GetV1ResignationSettlementsIdEmployeeFinancialOverviewRequest): Promise<Types.GetV1ResignationSettlementsIdEmployeeFinancialOverviewResponses> => {
  return await _getV1ResignationSettlementsIdEmployeeFinancialOverview(baseUrl, request)
}
const _getV1ResignationSettlementsId = async (url: string, request: Types.GetV1ResignationSettlementsIdRequest): Promise<Types.GetV1ResignationSettlementsIdResponses> => {
  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/resignation-settlements/${request['id']}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1ResignationSettlementsId: Api['getV1ResignationSettlementsId'] = async (request: Types.GetV1ResignationSettlementsIdRequest): Promise<Types.GetV1ResignationSettlementsIdResponses> => {
  return await _getV1ResignationSettlementsId(baseUrl, request)
}
const _postV1ResignationSettlementsIdComponents = async (url: string, request: Types.PostV1ResignationSettlementsIdComponentsRequest): Promise<Types.PostV1ResignationSettlementsIdComponentsResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/resignation-settlements/${request['id']}/components`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1ResignationSettlementsIdComponents: Api['postV1ResignationSettlementsIdComponents'] = async (request: Types.PostV1ResignationSettlementsIdComponentsRequest): Promise<Types.PostV1ResignationSettlementsIdComponentsResponses> => {
  return await _postV1ResignationSettlementsIdComponents(baseUrl, request)
}
const _deleteV1ResignationSettlementsIdComponentsComponentId = async (url: string, request: Types.DeleteV1ResignationSettlementsIdComponentsComponentIdRequest): Promise<Types.DeleteV1ResignationSettlementsIdComponentsComponentIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/resignation-settlements/${request['id']}/components/${request['component_id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1ResignationSettlementsIdComponentsComponentId: Api['deleteV1ResignationSettlementsIdComponentsComponentId'] = async (request: Types.DeleteV1ResignationSettlementsIdComponentsComponentIdRequest): Promise<Types.DeleteV1ResignationSettlementsIdComponentsComponentIdResponses> => {
  return await _deleteV1ResignationSettlementsIdComponentsComponentId(baseUrl, request)
}
const _patchV1ResignationSettlementsIdComponentsComponentId = async (url: string, request: Types.PatchV1ResignationSettlementsIdComponentsComponentIdRequest): Promise<Types.PatchV1ResignationSettlementsIdComponentsComponentIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/resignation-settlements/${request['id']}/components/${request['component_id']}`, {
    method: 'PATCH',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const patchV1ResignationSettlementsIdComponentsComponentId: Api['patchV1ResignationSettlementsIdComponentsComponentId'] = async (request: Types.PatchV1ResignationSettlementsIdComponentsComponentIdRequest): Promise<Types.PatchV1ResignationSettlementsIdComponentsComponentIdResponses> => {
  return await _patchV1ResignationSettlementsIdComponentsComponentId(baseUrl, request)
}
const _patchV1ResignationSettlementsIdStatus = async (url: string, request: Types.PatchV1ResignationSettlementsIdStatusRequest): Promise<Types.PatchV1ResignationSettlementsIdStatusResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/resignation-settlements/${request['id']}/status`, {
    method: 'PATCH',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const patchV1ResignationSettlementsIdStatus: Api['patchV1ResignationSettlementsIdStatus'] = async (request: Types.PatchV1ResignationSettlementsIdStatusRequest): Promise<Types.PatchV1ResignationSettlementsIdStatusResponses> => {
  return await _patchV1ResignationSettlementsIdStatus(baseUrl, request)
}
const _patchV1TerminationSettlementsIdAssetClearance = async (url: string, request: Types.PatchV1TerminationSettlementsIdAssetClearanceRequest): Promise<Types.PatchV1TerminationSettlementsIdAssetClearanceResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/termination-settlements/${request['id']}/asset-clearance`, {
    method: 'PATCH',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const patchV1TerminationSettlementsIdAssetClearance: Api['patchV1TerminationSettlementsIdAssetClearance'] = async (request: Types.PatchV1TerminationSettlementsIdAssetClearanceRequest): Promise<Types.PatchV1TerminationSettlementsIdAssetClearanceResponses> => {
  return await _patchV1TerminationSettlementsIdAssetClearance(baseUrl, request)
}
const _getV1TerminationSettlementsIdDetail = async (url: string, request: Types.GetV1TerminationSettlementsIdDetailRequest): Promise<Types.GetV1TerminationSettlementsIdDetailResponses> => {
  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/termination-settlements/${request['id']}/detail`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1TerminationSettlementsIdDetail: Api['getV1TerminationSettlementsIdDetail'] = async (request: Types.GetV1TerminationSettlementsIdDetailRequest): Promise<Types.GetV1TerminationSettlementsIdDetailResponses> => {
  return await _getV1TerminationSettlementsIdDetail(baseUrl, request)
}
const _getV1TerminationSettlementsIdEmployeeFinancialOverview = async (url: string, request: Types.GetV1TerminationSettlementsIdEmployeeFinancialOverviewRequest): Promise<Types.GetV1TerminationSettlementsIdEmployeeFinancialOverviewResponses> => {
  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/termination-settlements/${request['id']}/employee-financial-overview`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1TerminationSettlementsIdEmployeeFinancialOverview: Api['getV1TerminationSettlementsIdEmployeeFinancialOverview'] = async (request: Types.GetV1TerminationSettlementsIdEmployeeFinancialOverviewRequest): Promise<Types.GetV1TerminationSettlementsIdEmployeeFinancialOverviewResponses> => {
  return await _getV1TerminationSettlementsIdEmployeeFinancialOverview(baseUrl, request)
}
const _getV1TerminationSettlementsId = async (url: string, request: Types.GetV1TerminationSettlementsIdRequest): Promise<Types.GetV1TerminationSettlementsIdResponses> => {
  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/termination-settlements/${request['id']}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1TerminationSettlementsId: Api['getV1TerminationSettlementsId'] = async (request: Types.GetV1TerminationSettlementsIdRequest): Promise<Types.GetV1TerminationSettlementsIdResponses> => {
  return await _getV1TerminationSettlementsId(baseUrl, request)
}
const _postV1TerminationSettlementsIdComponents = async (url: string, request: Types.PostV1TerminationSettlementsIdComponentsRequest): Promise<Types.PostV1TerminationSettlementsIdComponentsResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/termination-settlements/${request['id']}/components`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1TerminationSettlementsIdComponents: Api['postV1TerminationSettlementsIdComponents'] = async (request: Types.PostV1TerminationSettlementsIdComponentsRequest): Promise<Types.PostV1TerminationSettlementsIdComponentsResponses> => {
  return await _postV1TerminationSettlementsIdComponents(baseUrl, request)
}
const _deleteV1TerminationSettlementsIdComponentsComponentId = async (url: string, request: Types.DeleteV1TerminationSettlementsIdComponentsComponentIdRequest): Promise<Types.DeleteV1TerminationSettlementsIdComponentsComponentIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/termination-settlements/${request['id']}/components/${request['component_id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1TerminationSettlementsIdComponentsComponentId: Api['deleteV1TerminationSettlementsIdComponentsComponentId'] = async (request: Types.DeleteV1TerminationSettlementsIdComponentsComponentIdRequest): Promise<Types.DeleteV1TerminationSettlementsIdComponentsComponentIdResponses> => {
  return await _deleteV1TerminationSettlementsIdComponentsComponentId(baseUrl, request)
}
const _patchV1TerminationSettlementsIdComponentsComponentId = async (url: string, request: Types.PatchV1TerminationSettlementsIdComponentsComponentIdRequest): Promise<Types.PatchV1TerminationSettlementsIdComponentsComponentIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/termination-settlements/${request['id']}/components/${request['component_id']}`, {
    method: 'PATCH',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const patchV1TerminationSettlementsIdComponentsComponentId: Api['patchV1TerminationSettlementsIdComponentsComponentId'] = async (request: Types.PatchV1TerminationSettlementsIdComponentsComponentIdRequest): Promise<Types.PatchV1TerminationSettlementsIdComponentsComponentIdResponses> => {
  return await _patchV1TerminationSettlementsIdComponentsComponentId(baseUrl, request)
}
const _patchV1TerminationSettlementsIdStatus = async (url: string, request: Types.PatchV1TerminationSettlementsIdStatusRequest): Promise<Types.PatchV1TerminationSettlementsIdStatusResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/termination-settlements/${request['id']}/status`, {
    method: 'PATCH',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const patchV1TerminationSettlementsIdStatus: Api['patchV1TerminationSettlementsIdStatus'] = async (request: Types.PatchV1TerminationSettlementsIdStatusRequest): Promise<Types.PatchV1TerminationSettlementsIdStatusResponses> => {
  return await _patchV1TerminationSettlementsIdStatus(baseUrl, request)
}
const _getV1MonthlyPayroll = async (url: string, request: Types.GetV1MonthlyPayrollRequest): Promise<Types.GetV1MonthlyPayrollResponses> => {
  const queryParameters: (keyof Types.GetV1MonthlyPayrollRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/monthly-payroll/?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1MonthlyPayroll: Api['getV1MonthlyPayroll'] = async (request: Types.GetV1MonthlyPayrollRequest): Promise<Types.GetV1MonthlyPayrollResponses> => {
  return await _getV1MonthlyPayroll(baseUrl, request)
}
const _postV1MonthlyPayroll = async (url: string, request: Types.PostV1MonthlyPayrollRequest): Promise<Types.PostV1MonthlyPayrollResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/monthly-payroll/`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1MonthlyPayroll: Api['postV1MonthlyPayroll'] = async (request: Types.PostV1MonthlyPayrollRequest): Promise<Types.PostV1MonthlyPayrollResponses> => {
  return await _postV1MonthlyPayroll(baseUrl, request)
}
const _getV1MonthlyPayrollId = async (url: string, request: Types.GetV1MonthlyPayrollIdRequest): Promise<Types.GetV1MonthlyPayrollIdResponses> => {
  const queryParameters: (keyof Types.GetV1MonthlyPayrollIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/monthly-payroll/${request['id']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1MonthlyPayrollId: Api['getV1MonthlyPayrollId'] = async (request: Types.GetV1MonthlyPayrollIdRequest): Promise<Types.GetV1MonthlyPayrollIdResponses> => {
  return await _getV1MonthlyPayrollId(baseUrl, request)
}
const _putV1MonthlyPayrollId = async (url: string, request: Types.PutV1MonthlyPayrollIdRequest): Promise<Types.PutV1MonthlyPayrollIdResponses> => {
  const queryParameters: (keyof Types.PutV1MonthlyPayrollIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/monthly-payroll/${request['id']}?${searchParams.toString()}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1MonthlyPayrollId: Api['putV1MonthlyPayrollId'] = async (request: Types.PutV1MonthlyPayrollIdRequest): Promise<Types.PutV1MonthlyPayrollIdResponses> => {
  return await _putV1MonthlyPayrollId(baseUrl, request)
}
const _deleteV1MonthlyPayrollId = async (url: string, request: Types.DeleteV1MonthlyPayrollIdRequest): Promise<Types.DeleteV1MonthlyPayrollIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/monthly-payroll/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1MonthlyPayrollId: Api['deleteV1MonthlyPayrollId'] = async (request: Types.DeleteV1MonthlyPayrollIdRequest): Promise<Types.DeleteV1MonthlyPayrollIdResponses> => {
  return await _deleteV1MonthlyPayrollId(baseUrl, request)
}
const _postV1MonthlyPayrollSaveAsDraft = async (url: string, request: Types.PostV1MonthlyPayrollSaveAsDraftRequest): Promise<Types.PostV1MonthlyPayrollSaveAsDraftResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/monthly-payroll/save-as-draft`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1MonthlyPayrollSaveAsDraft: Api['postV1MonthlyPayrollSaveAsDraft'] = async (request: Types.PostV1MonthlyPayrollSaveAsDraftRequest): Promise<Types.PostV1MonthlyPayrollSaveAsDraftResponses> => {
  return await _postV1MonthlyPayrollSaveAsDraft(baseUrl, request)
}
const _patchV1MonthlyPayrollIdSaveAsDraft = async (url: string, request: Types.PatchV1MonthlyPayrollIdSaveAsDraftRequest): Promise<Types.PatchV1MonthlyPayrollIdSaveAsDraftResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/monthly-payroll/${request['id']}/save-as-draft`, {
    method: 'PATCH',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const patchV1MonthlyPayrollIdSaveAsDraft: Api['patchV1MonthlyPayrollIdSaveAsDraft'] = async (request: Types.PatchV1MonthlyPayrollIdSaveAsDraftRequest): Promise<Types.PatchV1MonthlyPayrollIdSaveAsDraftResponses> => {
  return await _patchV1MonthlyPayrollIdSaveAsDraft(baseUrl, request)
}
const _postV1MonthlyPayrollIdRun = async (url: string, request: Types.PostV1MonthlyPayrollIdRunRequest): Promise<Types.PostV1MonthlyPayrollIdRunResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/monthly-payroll/${request['id']}/run`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1MonthlyPayrollIdRun: Api['postV1MonthlyPayrollIdRun'] = async (request: Types.PostV1MonthlyPayrollIdRunRequest): Promise<Types.PostV1MonthlyPayrollIdRunResponses> => {
  return await _postV1MonthlyPayrollIdRun(baseUrl, request)
}
const _postV1MonthlyPayrollIdSubmit = async (url: string, request: Types.PostV1MonthlyPayrollIdSubmitRequest): Promise<Types.PostV1MonthlyPayrollIdSubmitResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/monthly-payroll/${request['id']}/submit`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1MonthlyPayrollIdSubmit: Api['postV1MonthlyPayrollIdSubmit'] = async (request: Types.PostV1MonthlyPayrollIdSubmitRequest): Promise<Types.PostV1MonthlyPayrollIdSubmitResponses> => {
  return await _postV1MonthlyPayrollIdSubmit(baseUrl, request)
}
const _postV1MonthlyPayrollIdApprove = async (url: string, request: Types.PostV1MonthlyPayrollIdApproveRequest): Promise<Types.PostV1MonthlyPayrollIdApproveResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/monthly-payroll/${request['id']}/approve`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1MonthlyPayrollIdApprove: Api['postV1MonthlyPayrollIdApprove'] = async (request: Types.PostV1MonthlyPayrollIdApproveRequest): Promise<Types.PostV1MonthlyPayrollIdApproveResponses> => {
  return await _postV1MonthlyPayrollIdApprove(baseUrl, request)
}
const _postV1MonthlyPayrollIdReject = async (url: string, request: Types.PostV1MonthlyPayrollIdRejectRequest): Promise<Types.PostV1MonthlyPayrollIdRejectResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/monthly-payroll/${request['id']}/reject`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1MonthlyPayrollIdReject: Api['postV1MonthlyPayrollIdReject'] = async (request: Types.PostV1MonthlyPayrollIdRejectRequest): Promise<Types.PostV1MonthlyPayrollIdRejectResponses> => {
  return await _postV1MonthlyPayrollIdReject(baseUrl, request)
}
const _postV1MonthlyPayrollIdValidate = async (url: string, request: Types.PostV1MonthlyPayrollIdValidateRequest): Promise<Types.PostV1MonthlyPayrollIdValidateResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/monthly-payroll/${request['id']}/validate`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1MonthlyPayrollIdValidate: Api['postV1MonthlyPayrollIdValidate'] = async (request: Types.PostV1MonthlyPayrollIdValidateRequest): Promise<Types.PostV1MonthlyPayrollIdValidateResponses> => {
  return await _postV1MonthlyPayrollIdValidate(baseUrl, request)
}
const _getV1SalarySheets = async (url: string, request: Types.GetV1SalarySheetsRequest): Promise<Types.GetV1SalarySheetsResponses> => {
  const queryParameters: (keyof Types.GetV1SalarySheetsRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/salary-sheets/?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1SalarySheets: Api['getV1SalarySheets'] = async (request: Types.GetV1SalarySheetsRequest): Promise<Types.GetV1SalarySheetsResponses> => {
  return await _getV1SalarySheets(baseUrl, request)
}
const _postV1SalarySheets = async (url: string, request: Types.PostV1SalarySheetsRequest): Promise<Types.PostV1SalarySheetsResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/salary-sheets/`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1SalarySheets: Api['postV1SalarySheets'] = async (request: Types.PostV1SalarySheetsRequest): Promise<Types.PostV1SalarySheetsResponses> => {
  return await _postV1SalarySheets(baseUrl, request)
}
const _getV1SalarySheetsId = async (url: string, request: Types.GetV1SalarySheetsIdRequest): Promise<Types.GetV1SalarySheetsIdResponses> => {
  const queryParameters: (keyof Types.GetV1SalarySheetsIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/salary-sheets/${request['id']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1SalarySheetsId: Api['getV1SalarySheetsId'] = async (request: Types.GetV1SalarySheetsIdRequest): Promise<Types.GetV1SalarySheetsIdResponses> => {
  return await _getV1SalarySheetsId(baseUrl, request)
}
const _putV1SalarySheetsId = async (url: string, request: Types.PutV1SalarySheetsIdRequest): Promise<Types.PutV1SalarySheetsIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/salary-sheets/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1SalarySheetsId: Api['putV1SalarySheetsId'] = async (request: Types.PutV1SalarySheetsIdRequest): Promise<Types.PutV1SalarySheetsIdResponses> => {
  return await _putV1SalarySheetsId(baseUrl, request)
}
const _deleteV1SalarySheetsId = async (url: string, request: Types.DeleteV1SalarySheetsIdRequest): Promise<Types.DeleteV1SalarySheetsIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/salary-sheets/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1SalarySheetsId: Api['deleteV1SalarySheetsId'] = async (request: Types.DeleteV1SalarySheetsIdRequest): Promise<Types.DeleteV1SalarySheetsIdResponses> => {
  return await _deleteV1SalarySheetsId(baseUrl, request)
}
const _postV1SalarySheetsLoadData = async (url: string, request: Types.PostV1SalarySheetsLoadDataRequest): Promise<Types.PostV1SalarySheetsLoadDataResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/salary-sheets/load-data`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1SalarySheetsLoadData: Api['postV1SalarySheetsLoadData'] = async (request: Types.PostV1SalarySheetsLoadDataRequest): Promise<Types.PostV1SalarySheetsLoadDataResponses> => {
  return await _postV1SalarySheetsLoadData(baseUrl, request)
}
const _postV1SalarySheetsIdValidate = async (url: string, request: Types.PostV1SalarySheetsIdValidateRequest): Promise<Types.PostV1SalarySheetsIdValidateResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/salary-sheets/${request['id']}/validate`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1SalarySheetsIdValidate: Api['postV1SalarySheetsIdValidate'] = async (request: Types.PostV1SalarySheetsIdValidateRequest): Promise<Types.PostV1SalarySheetsIdValidateResponses> => {
  return await _postV1SalarySheetsIdValidate(baseUrl, request)
}
const _postV1SalarySheetsIdGenerateSif = async (url: string, request: Types.PostV1SalarySheetsIdGenerateSifRequest): Promise<Types.PostV1SalarySheetsIdGenerateSifResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/salary-sheets/${request['id']}/generate-sif`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1SalarySheetsIdGenerateSif: Api['postV1SalarySheetsIdGenerateSif'] = async (request: Types.PostV1SalarySheetsIdGenerateSifRequest): Promise<Types.PostV1SalarySheetsIdGenerateSifResponses> => {
  return await _postV1SalarySheetsIdGenerateSif(baseUrl, request)
}
const _postV1SalarySheetsIdMarkProcessed = async (url: string, request: Types.PostV1SalarySheetsIdMarkProcessedRequest): Promise<Types.PostV1SalarySheetsIdMarkProcessedResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/salary-sheets/${request['id']}/mark-processed`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1SalarySheetsIdMarkProcessed: Api['postV1SalarySheetsIdMarkProcessed'] = async (request: Types.PostV1SalarySheetsIdMarkProcessedRequest): Promise<Types.PostV1SalarySheetsIdMarkProcessedResponses> => {
  return await _postV1SalarySheetsIdMarkProcessed(baseUrl, request)
}
const _postV1SalarySheetsIdSaveDraft = async (url: string, request: Types.PostV1SalarySheetsIdSaveDraftRequest): Promise<Types.PostV1SalarySheetsIdSaveDraftResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/salary-sheets/${request['id']}/save-draft`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1SalarySheetsIdSaveDraft: Api['postV1SalarySheetsIdSaveDraft'] = async (request: Types.PostV1SalarySheetsIdSaveDraftRequest): Promise<Types.PostV1SalarySheetsIdSaveDraftResponses> => {
  return await _postV1SalarySheetsIdSaveDraft(baseUrl, request)
}
const _getV1SalarySheetsIdDownloadSif = async (url: string, request: Types.GetV1SalarySheetsIdDownloadSifRequest): Promise<Types.GetV1SalarySheetsIdDownloadSifResponses> => {
  const queryParameters: (keyof Types.GetV1SalarySheetsIdDownloadSifRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/salary-sheets/${request['id']}/download-sif?${searchParams.toString()}`, {
    headers
  })

  const textResponses = [200]
  if (textResponses.includes(response.status)) {
    return {
      statusCode: response.status as 200,
      headers: headersToJSON(response.headers),
      body: await response.text()
    }
  }
  if (response.headers.get('content-type') === 'application/json') {
    return {
      statusCode: response.status as 200,
      headers: headersToJSON(response.headers),
      body: await response.json() as any
    }
  }
  return {
    statusCode: response.status as 200,
    headers: headersToJSON(response.headers),
    body: await response.text() as any
  }
}

export const getV1SalarySheetsIdDownloadSif: Api['getV1SalarySheetsIdDownloadSif'] = async (request: Types.GetV1SalarySheetsIdDownloadSifRequest): Promise<Types.GetV1SalarySheetsIdDownloadSifResponses> => {
  return await _getV1SalarySheetsIdDownloadSif(baseUrl, request)
}
const _getV1Payslips = async (url: string, request: Types.GetV1PayslipsRequest): Promise<Types.GetV1PayslipsResponses> => {
  const queryParameters: (keyof Types.GetV1PayslipsRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/payslips/?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1Payslips: Api['getV1Payslips'] = async (request: Types.GetV1PayslipsRequest): Promise<Types.GetV1PayslipsResponses> => {
  return await _getV1Payslips(baseUrl, request)
}
const _getV1PayslipsId = async (url: string, request: Types.GetV1PayslipsIdRequest): Promise<Types.GetV1PayslipsIdResponses> => {
  const queryParameters: (keyof Types.GetV1PayslipsIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/payslips/${request['id']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1PayslipsId: Api['getV1PayslipsId'] = async (request: Types.GetV1PayslipsIdRequest): Promise<Types.GetV1PayslipsIdResponses> => {
  return await _getV1PayslipsId(baseUrl, request)
}
const _deleteV1PayslipsId = async (url: string, request: Types.DeleteV1PayslipsIdRequest): Promise<Types.DeleteV1PayslipsIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/payslips/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1PayslipsId: Api['deleteV1PayslipsId'] = async (request: Types.DeleteV1PayslipsIdRequest): Promise<Types.DeleteV1PayslipsIdResponses> => {
  return await _deleteV1PayslipsId(baseUrl, request)
}
const _postV1PayslipsGenerate = async (url: string, request: Types.PostV1PayslipsGenerateRequest): Promise<Types.PostV1PayslipsGenerateResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/payslips/generate`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1PayslipsGenerate: Api['postV1PayslipsGenerate'] = async (request: Types.PostV1PayslipsGenerateRequest): Promise<Types.PostV1PayslipsGenerateResponses> => {
  return await _postV1PayslipsGenerate(baseUrl, request)
}
const _postV1PayslipsIdSendEmail = async (url: string, request: Types.PostV1PayslipsIdSendEmailRequest): Promise<Types.PostV1PayslipsIdSendEmailResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/payslips/${request['id']}/send-email`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1PayslipsIdSendEmail: Api['postV1PayslipsIdSendEmail'] = async (request: Types.PostV1PayslipsIdSendEmailRequest): Promise<Types.PostV1PayslipsIdSendEmailResponses> => {
  return await _postV1PayslipsIdSendEmail(baseUrl, request)
}
const _postV1PayslipsIdPublishEss = async (url: string, request: Types.PostV1PayslipsIdPublishEssRequest): Promise<Types.PostV1PayslipsIdPublishEssResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/payslips/${request['id']}/publish-ess`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1PayslipsIdPublishEss: Api['postV1PayslipsIdPublishEss'] = async (request: Types.PostV1PayslipsIdPublishEssRequest): Promise<Types.PostV1PayslipsIdPublishEssResponses> => {
  return await _postV1PayslipsIdPublishEss(baseUrl, request)
}
const _getV1PayslipsEmployeeEmployeeId = async (url: string, request: Types.GetV1PayslipsEmployeeEmployeeIdRequest): Promise<Types.GetV1PayslipsEmployeeEmployeeIdResponses> => {
  const queryParameters: (keyof Types.GetV1PayslipsEmployeeEmployeeIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/payslips/employee/${request['employeeId']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1PayslipsEmployeeEmployeeId: Api['getV1PayslipsEmployeeEmployeeId'] = async (request: Types.GetV1PayslipsEmployeeEmployeeIdRequest): Promise<Types.GetV1PayslipsEmployeeEmployeeIdResponses> => {
  return await _getV1PayslipsEmployeeEmployeeId(baseUrl, request)
}
const _postV1PayslipsEmployeeEmployeeIdGenerate = async (url: string, request: Types.PostV1PayslipsEmployeeEmployeeIdGenerateRequest): Promise<Types.PostV1PayslipsEmployeeEmployeeIdGenerateResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/payslips/employee/${request['employeeId']}/generate`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1PayslipsEmployeeEmployeeIdGenerate: Api['postV1PayslipsEmployeeEmployeeIdGenerate'] = async (request: Types.PostV1PayslipsEmployeeEmployeeIdGenerateRequest): Promise<Types.PostV1PayslipsEmployeeEmployeeIdGenerateResponses> => {
  return await _postV1PayslipsEmployeeEmployeeIdGenerate(baseUrl, request)
}
const _getV1PayslipsDownloadId = async (url: string, request: Types.GetV1PayslipsDownloadIdRequest): Promise<Types.GetV1PayslipsDownloadIdResponses> => {
  const queryParameters: (keyof Types.GetV1PayslipsDownloadIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/payslips/download/${request['id']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1PayslipsDownloadId: Api['getV1PayslipsDownloadId'] = async (request: Types.GetV1PayslipsDownloadIdRequest): Promise<Types.GetV1PayslipsDownloadIdResponses> => {
  return await _getV1PayslipsDownloadId(baseUrl, request)
}
const _postV1ReportsEmployeeList = async (url: string, request: Types.PostV1ReportsEmployeeListRequest): Promise<Types.PostV1ReportsEmployeeListResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/reports/employee-list`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1ReportsEmployeeList: Api['postV1ReportsEmployeeList'] = async (request: Types.PostV1ReportsEmployeeListRequest): Promise<Types.PostV1ReportsEmployeeListResponses> => {
  return await _postV1ReportsEmployeeList(baseUrl, request)
}
const _postV1ReportsContractList = async (url: string, request: Types.PostV1ReportsContractListRequest): Promise<Types.PostV1ReportsContractListResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/reports/contract-list`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1ReportsContractList: Api['postV1ReportsContractList'] = async (request: Types.PostV1ReportsContractListRequest): Promise<Types.PostV1ReportsContractListResponses> => {
  return await _postV1ReportsContractList(baseUrl, request)
}
const _postV1ReportsRecruitmentRequestList = async (url: string, request: Types.PostV1ReportsRecruitmentRequestListRequest): Promise<Types.PostV1ReportsRecruitmentRequestListResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/reports/recruitment-request-list`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1ReportsRecruitmentRequestList: Api['postV1ReportsRecruitmentRequestList'] = async (request: Types.PostV1ReportsRecruitmentRequestListRequest): Promise<Types.PostV1ReportsRecruitmentRequestListResponses> => {
  return await _postV1ReportsRecruitmentRequestList(baseUrl, request)
}
const _postV1ReportsRecruitmentFulfilmentAnalysis = async (url: string, request: Types.PostV1ReportsRecruitmentFulfilmentAnalysisRequest): Promise<Types.PostV1ReportsRecruitmentFulfilmentAnalysisResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/reports/recruitment-fulfilment-analysis`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1ReportsRecruitmentFulfilmentAnalysis: Api['postV1ReportsRecruitmentFulfilmentAnalysis'] = async (request: Types.PostV1ReportsRecruitmentFulfilmentAnalysisRequest): Promise<Types.PostV1ReportsRecruitmentFulfilmentAnalysisResponses> => {
  return await _postV1ReportsRecruitmentFulfilmentAnalysis(baseUrl, request)
}
const _postV1ReportsDepartmentAnalysis = async (url: string, request: Types.PostV1ReportsDepartmentAnalysisRequest): Promise<Types.PostV1ReportsDepartmentAnalysisResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/reports/department-analysis`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1ReportsDepartmentAnalysis: Api['postV1ReportsDepartmentAnalysis'] = async (request: Types.PostV1ReportsDepartmentAnalysisRequest): Promise<Types.PostV1ReportsDepartmentAnalysisResponses> => {
  return await _postV1ReportsDepartmentAnalysis(baseUrl, request)
}
const _postV1ReportsEmployeeSalaryList = async (url: string, request: Types.PostV1ReportsEmployeeSalaryListRequest): Promise<Types.PostV1ReportsEmployeeSalaryListResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/reports/employee-salary-list`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1ReportsEmployeeSalaryList: Api['postV1ReportsEmployeeSalaryList'] = async (request: Types.PostV1ReportsEmployeeSalaryListRequest): Promise<Types.PostV1ReportsEmployeeSalaryListResponses> => {
  return await _postV1ReportsEmployeeSalaryList(baseUrl, request)
}
const _postV1ReportsResignationRequestList = async (url: string, request: Types.PostV1ReportsResignationRequestListRequest): Promise<Types.PostV1ReportsResignationRequestListResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/reports/resignation-request-list`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1ReportsResignationRequestList: Api['postV1ReportsResignationRequestList'] = async (request: Types.PostV1ReportsResignationRequestListRequest): Promise<Types.PostV1ReportsResignationRequestListResponses> => {
  return await _postV1ReportsResignationRequestList(baseUrl, request)
}
const _postV1ReportsTerminationRequestList = async (url: string, request: Types.PostV1ReportsTerminationRequestListRequest): Promise<Types.PostV1ReportsTerminationRequestListResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/reports/termination-request-list`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1ReportsTerminationRequestList: Api['postV1ReportsTerminationRequestList'] = async (request: Types.PostV1ReportsTerminationRequestListRequest): Promise<Types.PostV1ReportsTerminationRequestListResponses> => {
  return await _postV1ReportsTerminationRequestList(baseUrl, request)
}
const _postV1ReportsFinalSettlementReport = async (url: string, request: Types.PostV1ReportsFinalSettlementReportRequest): Promise<Types.PostV1ReportsFinalSettlementReportResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/reports/final-settlement-report`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1ReportsFinalSettlementReport: Api['postV1ReportsFinalSettlementReport'] = async (request: Types.PostV1ReportsFinalSettlementReportRequest): Promise<Types.PostV1ReportsFinalSettlementReportResponses> => {
  return await _postV1ReportsFinalSettlementReport(baseUrl, request)
}
const _postV1ReportsEmployeeGratuityReport = async (url: string, request: Types.PostV1ReportsEmployeeGratuityReportRequest): Promise<Types.PostV1ReportsEmployeeGratuityReportResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/reports/employee-gratuity-report`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1ReportsEmployeeGratuityReport: Api['postV1ReportsEmployeeGratuityReport'] = async (request: Types.PostV1ReportsEmployeeGratuityReportRequest): Promise<Types.PostV1ReportsEmployeeGratuityReportResponses> => {
  return await _postV1ReportsEmployeeGratuityReport(baseUrl, request)
}
const _postV1ReportsEmployeeOvertimeReport = async (url: string, request: Types.PostV1ReportsEmployeeOvertimeReportRequest): Promise<Types.PostV1ReportsEmployeeOvertimeReportResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/reports/employee-overtime-report`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1ReportsEmployeeOvertimeReport: Api['postV1ReportsEmployeeOvertimeReport'] = async (request: Types.PostV1ReportsEmployeeOvertimeReportRequest): Promise<Types.PostV1ReportsEmployeeOvertimeReportResponses> => {
  return await _postV1ReportsEmployeeOvertimeReport(baseUrl, request)
}
const _postV1ReportsLeaveRequestList = async (url: string, request: Types.PostV1ReportsLeaveRequestListRequest): Promise<Types.PostV1ReportsLeaveRequestListResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/reports/leave-request-list`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1ReportsLeaveRequestList: Api['postV1ReportsLeaveRequestList'] = async (request: Types.PostV1ReportsLeaveRequestListRequest): Promise<Types.PostV1ReportsLeaveRequestListResponses> => {
  return await _postV1ReportsLeaveRequestList(baseUrl, request)
}
const _postV1ReportsAnnualLeaveReport = async (url: string, request: Types.PostV1ReportsAnnualLeaveReportRequest): Promise<Types.PostV1ReportsAnnualLeaveReportResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/reports/annual-leave-report`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1ReportsAnnualLeaveReport: Api['postV1ReportsAnnualLeaveReport'] = async (request: Types.PostV1ReportsAnnualLeaveReportRequest): Promise<Types.PostV1ReportsAnnualLeaveReportResponses> => {
  return await _postV1ReportsAnnualLeaveReport(baseUrl, request)
}
const _postV1ReportsEmployeeLoanList = async (url: string, request: Types.PostV1ReportsEmployeeLoanListRequest): Promise<Types.PostV1ReportsEmployeeLoanListResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/reports/employee-loan-list`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1ReportsEmployeeLoanList: Api['postV1ReportsEmployeeLoanList'] = async (request: Types.PostV1ReportsEmployeeLoanListRequest): Promise<Types.PostV1ReportsEmployeeLoanListResponses> => {
  return await _postV1ReportsEmployeeLoanList(baseUrl, request)
}
const _postV1ReportsPendingLoanStatus = async (url: string, request: Types.PostV1ReportsPendingLoanStatusRequest): Promise<Types.PostV1ReportsPendingLoanStatusResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/reports/pending-loan-status`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1ReportsPendingLoanStatus: Api['postV1ReportsPendingLoanStatus'] = async (request: Types.PostV1ReportsPendingLoanStatusRequest): Promise<Types.PostV1ReportsPendingLoanStatusResponses> => {
  return await _postV1ReportsPendingLoanStatus(baseUrl, request)
}
const _postV1ReportsSalarySheet = async (url: string, request: Types.PostV1ReportsSalarySheetRequest): Promise<Types.PostV1ReportsSalarySheetResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/reports/salary-sheet`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1ReportsSalarySheet: Api['postV1ReportsSalarySheet'] = async (request: Types.PostV1ReportsSalarySheetRequest): Promise<Types.PostV1ReportsSalarySheetResponses> => {
  return await _postV1ReportsSalarySheet(baseUrl, request)
}
const _postV1ReportsExpenseReimbursement = async (url: string, request: Types.PostV1ReportsExpenseReimbursementRequest): Promise<Types.PostV1ReportsExpenseReimbursementResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/reports/expense-reimbursement`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1ReportsExpenseReimbursement: Api['postV1ReportsExpenseReimbursement'] = async (request: Types.PostV1ReportsExpenseReimbursementRequest): Promise<Types.PostV1ReportsExpenseReimbursementResponses> => {
  return await _postV1ReportsExpenseReimbursement(baseUrl, request)
}
const _postV1ReportsTimeSheet = async (url: string, request: Types.PostV1ReportsTimeSheetRequest): Promise<Types.PostV1ReportsTimeSheetResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/reports/time-sheet`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1ReportsTimeSheet: Api['postV1ReportsTimeSheet'] = async (request: Types.PostV1ReportsTimeSheetRequest): Promise<Types.PostV1ReportsTimeSheetResponses> => {
  return await _postV1ReportsTimeSheet(baseUrl, request)
}
const _postV1ReportsResourceRequisitions = async (url: string, request: Types.PostV1ReportsResourceRequisitionsRequest): Promise<Types.PostV1ReportsResourceRequisitionsResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/reports/resource-requisitions`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1ReportsResourceRequisitions: Api['postV1ReportsResourceRequisitions'] = async (request: Types.PostV1ReportsResourceRequisitionsRequest): Promise<Types.PostV1ReportsResourceRequisitionsResponses> => {
  return await _postV1ReportsResourceRequisitions(baseUrl, request)
}
const _postV1ReportsTimeCard = async (url: string, request: Types.PostV1ReportsTimeCardRequest): Promise<Types.PostV1ReportsTimeCardResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/reports/time-card`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1ReportsTimeCard: Api['postV1ReportsTimeCard'] = async (request: Types.PostV1ReportsTimeCardRequest): Promise<Types.PostV1ReportsTimeCardResponses> => {
  return await _postV1ReportsTimeCard(baseUrl, request)
}
const _postV1ReportsAttendanceSummary = async (url: string, request: Types.PostV1ReportsAttendanceSummaryRequest): Promise<Types.PostV1ReportsAttendanceSummaryResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/reports/attendance-summary`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1ReportsAttendanceSummary: Api['postV1ReportsAttendanceSummary'] = async (request: Types.PostV1ReportsAttendanceSummaryRequest): Promise<Types.PostV1ReportsAttendanceSummaryResponses> => {
  return await _postV1ReportsAttendanceSummary(baseUrl, request)
}
const _postV1ReportsMissingAttendance = async (url: string, request: Types.PostV1ReportsMissingAttendanceRequest): Promise<Types.PostV1ReportsMissingAttendanceResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/reports/missing-attendance`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1ReportsMissingAttendance: Api['postV1ReportsMissingAttendance'] = async (request: Types.PostV1ReportsMissingAttendanceRequest): Promise<Types.PostV1ReportsMissingAttendanceResponses> => {
  return await _postV1ReportsMissingAttendance(baseUrl, request)
}
const _postV1ReportsEmployeeAssetRecords = async (url: string, request: Types.PostV1ReportsEmployeeAssetRecordsRequest): Promise<Types.PostV1ReportsEmployeeAssetRecordsResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/reports/employee-asset-records`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1ReportsEmployeeAssetRecords: Api['postV1ReportsEmployeeAssetRecords'] = async (request: Types.PostV1ReportsEmployeeAssetRecordsRequest): Promise<Types.PostV1ReportsEmployeeAssetRecordsResponses> => {
  return await _postV1ReportsEmployeeAssetRecords(baseUrl, request)
}
const _postV1ReportsAssetDamage = async (url: string, request: Types.PostV1ReportsAssetDamageRequest): Promise<Types.PostV1ReportsAssetDamageResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/reports/asset-damage`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1ReportsAssetDamage: Api['postV1ReportsAssetDamage'] = async (request: Types.PostV1ReportsAssetDamageRequest): Promise<Types.PostV1ReportsAssetDamageResponses> => {
  return await _postV1ReportsAssetDamage(baseUrl, request)
}
const _postV1ReportsAssetStatus = async (url: string, request: Types.PostV1ReportsAssetStatusRequest): Promise<Types.PostV1ReportsAssetStatusResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/reports/asset-status`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1ReportsAssetStatus: Api['postV1ReportsAssetStatus'] = async (request: Types.PostV1ReportsAssetStatusRequest): Promise<Types.PostV1ReportsAssetStatusResponses> => {
  return await _postV1ReportsAssetStatus(baseUrl, request)
}
const _postV1ReportsEmployeeProbationReport = async (url: string, request: Types.PostV1ReportsEmployeeProbationReportRequest): Promise<Types.PostV1ReportsEmployeeProbationReportResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/reports/employee-probation-report`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1ReportsEmployeeProbationReport: Api['postV1ReportsEmployeeProbationReport'] = async (request: Types.PostV1ReportsEmployeeProbationReportRequest): Promise<Types.PostV1ReportsEmployeeProbationReportResponses> => {
  return await _postV1ReportsEmployeeProbationReport(baseUrl, request)
}
const _postV1ReportsEmployeeTurnoverReport = async (url: string, request: Types.PostV1ReportsEmployeeTurnoverReportRequest): Promise<Types.PostV1ReportsEmployeeTurnoverReportResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/reports/employee-turnover-report`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1ReportsEmployeeTurnoverReport: Api['postV1ReportsEmployeeTurnoverReport'] = async (request: Types.PostV1ReportsEmployeeTurnoverReportRequest): Promise<Types.PostV1ReportsEmployeeTurnoverReportResponses> => {
  return await _postV1ReportsEmployeeTurnoverReport(baseUrl, request)
}
const _postV1ReportsPayrollVarianceReport = async (url: string, request: Types.PostV1ReportsPayrollVarianceReportRequest): Promise<Types.PostV1ReportsPayrollVarianceReportResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/reports/payroll-variance-report`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1ReportsPayrollVarianceReport: Api['postV1ReportsPayrollVarianceReport'] = async (request: Types.PostV1ReportsPayrollVarianceReportRequest): Promise<Types.PostV1ReportsPayrollVarianceReportResponses> => {
  return await _postV1ReportsPayrollVarianceReport(baseUrl, request)
}
const _postV1ReportsExpiringDocumentsReport = async (url: string, request: Types.PostV1ReportsExpiringDocumentsReportRequest): Promise<Types.PostV1ReportsExpiringDocumentsReportResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/reports/expiring-documents-report`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1ReportsExpiringDocumentsReport: Api['postV1ReportsExpiringDocumentsReport'] = async (request: Types.PostV1ReportsExpiringDocumentsReportRequest): Promise<Types.PostV1ReportsExpiringDocumentsReportResponses> => {
  return await _postV1ReportsExpiringDocumentsReport(baseUrl, request)
}
const _postV1ReportsLeaveEncashmentReport = async (url: string, request: Types.PostV1ReportsLeaveEncashmentReportRequest): Promise<Types.PostV1ReportsLeaveEncashmentReportResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/reports/leave-encashment-report`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1ReportsLeaveEncashmentReport: Api['postV1ReportsLeaveEncashmentReport'] = async (request: Types.PostV1ReportsLeaveEncashmentReportRequest): Promise<Types.PostV1ReportsLeaveEncashmentReportResponses> => {
  return await _postV1ReportsLeaveEncashmentReport(baseUrl, request)
}
const _postV1AttendanceCheckIn = async (url: string, request: Types.PostV1AttendanceCheckInRequest): Promise<Types.PostV1AttendanceCheckInResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/attendance/check-in`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1AttendanceCheckIn: Api['postV1AttendanceCheckIn'] = async (request: Types.PostV1AttendanceCheckInRequest): Promise<Types.PostV1AttendanceCheckInResponses> => {
  return await _postV1AttendanceCheckIn(baseUrl, request)
}
const _postV1AttendanceCheckOut = async (url: string, request: Types.PostV1AttendanceCheckOutRequest): Promise<Types.PostV1AttendanceCheckOutResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/attendance/check-out`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1AttendanceCheckOut: Api['postV1AttendanceCheckOut'] = async (request: Types.PostV1AttendanceCheckOutRequest): Promise<Types.PostV1AttendanceCheckOutResponses> => {
  return await _postV1AttendanceCheckOut(baseUrl, request)
}
const _postV1AttendanceStartBreak = async (url: string, request: Types.PostV1AttendanceStartBreakRequest): Promise<Types.PostV1AttendanceStartBreakResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/attendance/start-break`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1AttendanceStartBreak: Api['postV1AttendanceStartBreak'] = async (request: Types.PostV1AttendanceStartBreakRequest): Promise<Types.PostV1AttendanceStartBreakResponses> => {
  return await _postV1AttendanceStartBreak(baseUrl, request)
}
const _postV1AttendanceEndBreak = async (url: string, request: Types.PostV1AttendanceEndBreakRequest): Promise<Types.PostV1AttendanceEndBreakResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/attendance/end-break`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1AttendanceEndBreak: Api['postV1AttendanceEndBreak'] = async (request: Types.PostV1AttendanceEndBreakRequest): Promise<Types.PostV1AttendanceEndBreakResponses> => {
  return await _postV1AttendanceEndBreak(baseUrl, request)
}
const _getV1AttendanceStatus = async (url: string, request: Types.GetV1AttendanceStatusRequest): Promise<Types.GetV1AttendanceStatusResponses> => {
  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/attendance/status`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1AttendanceStatus: Api['getV1AttendanceStatus'] = async (request: Types.GetV1AttendanceStatusRequest): Promise<Types.GetV1AttendanceStatusResponses> => {
  return await _getV1AttendanceStatus(baseUrl, request)
}
const _getV1AttendanceSummaryAttendanceId = async (url: string, request: Types.GetV1AttendanceSummaryAttendanceIdRequest): Promise<Types.GetV1AttendanceSummaryAttendanceIdResponses> => {
  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/attendance/summary/${request['attendanceId']}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1AttendanceSummaryAttendanceId: Api['getV1AttendanceSummaryAttendanceId'] = async (request: Types.GetV1AttendanceSummaryAttendanceIdRequest): Promise<Types.GetV1AttendanceSummaryAttendanceIdResponses> => {
  return await _getV1AttendanceSummaryAttendanceId(baseUrl, request)
}
const _getV1Approvals = async (url: string, request: Types.GetV1ApprovalsRequest): Promise<Types.GetV1ApprovalsResponses> => {
  const queryParameters: (keyof Types.GetV1ApprovalsRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/approvals/?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1Approvals: Api['getV1Approvals'] = async (request: Types.GetV1ApprovalsRequest): Promise<Types.GetV1ApprovalsResponses> => {
  return await _getV1Approvals(baseUrl, request)
}
type BuildOptions = {
  headers?: Object
}
export default function build (url: string, options?: BuildOptions) {
  url = sanitizeUrl(url)
  if (options?.headers) {
    defaultHeaders = options.headers
  }
  return {
    getV1FileUpload: _getV1FileUpload.bind(url, ...arguments),
    postV1FileUploadMarkComplete: _postV1FileUploadMarkComplete.bind(url, ...arguments),
    postV1DocumentMaster: _postV1DocumentMaster.bind(url, ...arguments),
    getV1DocumentMaster: _getV1DocumentMaster.bind(url, ...arguments),
    getV1DocumentMasterId: _getV1DocumentMasterId.bind(url, ...arguments),
    putV1DocumentMasterId: _putV1DocumentMasterId.bind(url, ...arguments),
    deleteV1DocumentMasterId: _deleteV1DocumentMasterId.bind(url, ...arguments),
    patchV1DocumentMasterIdStatus: _patchV1DocumentMasterIdStatus.bind(url, ...arguments),
    postV1DocumentMasterSaveAsDraft: _postV1DocumentMasterSaveAsDraft.bind(url, ...arguments),
    patchV1DocumentMasterIdSaveAsDraft: _patchV1DocumentMasterIdSaveAsDraft.bind(url, ...arguments),
    getV1DocumentMasterGenerateExcel: _getV1DocumentMasterGenerateExcel.bind(url, ...arguments),
    postV1DocumentMasterImport: _postV1DocumentMasterImport.bind(url, ...arguments),
    postV1CompanyCalendar: _postV1CompanyCalendar.bind(url, ...arguments),
    getV1CompanyCalendar: _getV1CompanyCalendar.bind(url, ...arguments),
    getV1CompanyCalendarId: _getV1CompanyCalendarId.bind(url, ...arguments),
    putV1CompanyCalendarId: _putV1CompanyCalendarId.bind(url, ...arguments),
    deleteV1CompanyCalendarId: _deleteV1CompanyCalendarId.bind(url, ...arguments),
    patchV1CompanyCalendarIdStatus: _patchV1CompanyCalendarIdStatus.bind(url, ...arguments),
    postV1CompanyCalendarSaveAsDraft: _postV1CompanyCalendarSaveAsDraft.bind(url, ...arguments),
    patchV1CompanyCalendarIdSaveAsDraft: _patchV1CompanyCalendarIdSaveAsDraft.bind(url, ...arguments),
    getV1CompanyCalendarGenerateExcel: _getV1CompanyCalendarGenerateExcel.bind(url, ...arguments),
    postV1CompanyCalendarImport: _postV1CompanyCalendarImport.bind(url, ...arguments),
    postV1LoanMaster: _postV1LoanMaster.bind(url, ...arguments),
    getV1LoanMaster: _getV1LoanMaster.bind(url, ...arguments),
    getV1LoanMasterId: _getV1LoanMasterId.bind(url, ...arguments),
    putV1LoanMasterId: _putV1LoanMasterId.bind(url, ...arguments),
    deleteV1LoanMasterId: _deleteV1LoanMasterId.bind(url, ...arguments),
    patchV1LoanMasterIdStatus: _patchV1LoanMasterIdStatus.bind(url, ...arguments),
    postV1LoanMasterDraft: _postV1LoanMasterDraft.bind(url, ...arguments),
    postV1LoanRequests: _postV1LoanRequests.bind(url, ...arguments),
    getV1LoanRequests: _getV1LoanRequests.bind(url, ...arguments),
    getV1LoanRequestsEligibilityEmployeeIdLoanMasters: _getV1LoanRequestsEligibilityEmployeeIdLoanMasters.bind(url, ...arguments),
    postV1LoanRequestsCheckEligibility: _postV1LoanRequestsCheckEligibility.bind(url, ...arguments),
    postV1LoanRequestsPreviewEmi: _postV1LoanRequestsPreviewEmi.bind(url, ...arguments),
    getV1LoanRequestsId: _getV1LoanRequestsId.bind(url, ...arguments),
    putV1LoanRequestsId: _putV1LoanRequestsId.bind(url, ...arguments),
    deleteV1LoanRequestsId: _deleteV1LoanRequestsId.bind(url, ...arguments),
    getV1LoanRequestsGenerateExcel: _getV1LoanRequestsGenerateExcel.bind(url, ...arguments),
    getV1LoanAllotments: _getV1LoanAllotments.bind(url, ...arguments),
    getV1LoanAllotmentsMyApprovals: _getV1LoanAllotmentsMyApprovals.bind(url, ...arguments),
    getV1LoanAllotmentsId: _getV1LoanAllotmentsId.bind(url, ...arguments),
    patchV1LoanAllotmentsIdStatus: _patchV1LoanAllotmentsIdStatus.bind(url, ...arguments),
    getV1LoanAllotmentsActiveLoans: _getV1LoanAllotmentsActiveLoans.bind(url, ...arguments),
    getV1LoanAllotmentsActiveLoansId: _getV1LoanAllotmentsActiveLoansId.bind(url, ...arguments),
    getV1LoanAllotmentsActiveLoansIdEmiScheduleExport: _getV1LoanAllotmentsActiveLoansIdEmiScheduleExport.bind(url, ...arguments),
    getV1LeaveCategory: _getV1LeaveCategory.bind(url, ...arguments),
    getV1LeaveCategoryId: _getV1LeaveCategoryId.bind(url, ...arguments),
    getV1AccrualType: _getV1AccrualType.bind(url, ...arguments),
    getV1AccrualTypeId: _getV1AccrualTypeId.bind(url, ...arguments),
    postV1AccrualMaster: _postV1AccrualMaster.bind(url, ...arguments),
    getV1AccrualMaster: _getV1AccrualMaster.bind(url, ...arguments),
    getV1AccrualMasterId: _getV1AccrualMasterId.bind(url, ...arguments),
    putV1AccrualMasterId: _putV1AccrualMasterId.bind(url, ...arguments),
    deleteV1AccrualMasterId: _deleteV1AccrualMasterId.bind(url, ...arguments),
    patchV1AccrualMasterIdStatus: _patchV1AccrualMasterIdStatus.bind(url, ...arguments),
    postV1AccrualMasterDraft: _postV1AccrualMasterDraft.bind(url, ...arguments),
    patchV1AccrualMasterIdDraft: _patchV1AccrualMasterIdDraft.bind(url, ...arguments),
    getV1AccrualMasterGenerateExcel: _getV1AccrualMasterGenerateExcel.bind(url, ...arguments),
    postV1AccrualMasterImport: _postV1AccrualMasterImport.bind(url, ...arguments),
    postV1AccrualMasterCalculateAmount: _postV1AccrualMasterCalculateAmount.bind(url, ...arguments),
    postV1LeavePolicyMaster: _postV1LeavePolicyMaster.bind(url, ...arguments),
    getV1LeavePolicyMaster: _getV1LeavePolicyMaster.bind(url, ...arguments),
    getV1LeavePolicyMasterId: _getV1LeavePolicyMasterId.bind(url, ...arguments),
    putV1LeavePolicyMasterId: _putV1LeavePolicyMasterId.bind(url, ...arguments),
    deleteV1LeavePolicyMasterId: _deleteV1LeavePolicyMasterId.bind(url, ...arguments),
    patchV1LeavePolicyMasterIdStatus: _patchV1LeavePolicyMasterIdStatus.bind(url, ...arguments),
    postV1LeavePolicyMasterSaveAsDraft: _postV1LeavePolicyMasterSaveAsDraft.bind(url, ...arguments),
    patchV1LeavePolicyMasterIdSaveAsDraft: _patchV1LeavePolicyMasterIdSaveAsDraft.bind(url, ...arguments),
    getV1LeavePolicyMasterGenerateExcel: _getV1LeavePolicyMasterGenerateExcel.bind(url, ...arguments),
    postV1LeavePolicyMasterImport: _postV1LeavePolicyMasterImport.bind(url, ...arguments),
    postV1Grades: _postV1Grades.bind(url, ...arguments),
    getV1Grades: _getV1Grades.bind(url, ...arguments),
    getV1GradesId: _getV1GradesId.bind(url, ...arguments),
    putV1GradesId: _putV1GradesId.bind(url, ...arguments),
    deleteV1GradesId: _deleteV1GradesId.bind(url, ...arguments),
    patchV1GradesIdStatus: _patchV1GradesIdStatus.bind(url, ...arguments),
    postV1Teams: _postV1Teams.bind(url, ...arguments),
    getV1Teams: _getV1Teams.bind(url, ...arguments),
    getV1TeamsId: _getV1TeamsId.bind(url, ...arguments),
    putV1TeamsId: _putV1TeamsId.bind(url, ...arguments),
    deleteV1TeamsId: _deleteV1TeamsId.bind(url, ...arguments),
    postV1Skills: _postV1Skills.bind(url, ...arguments),
    getV1Skills: _getV1Skills.bind(url, ...arguments),
    getV1SkillsId: _getV1SkillsId.bind(url, ...arguments),
    putV1SkillsId: _putV1SkillsId.bind(url, ...arguments),
    deleteV1SkillsId: _deleteV1SkillsId.bind(url, ...arguments),
    postV1Designation: _postV1Designation.bind(url, ...arguments),
    getV1Designation: _getV1Designation.bind(url, ...arguments),
    getV1DesignationId: _getV1DesignationId.bind(url, ...arguments),
    putV1DesignationId: _putV1DesignationId.bind(url, ...arguments),
    deleteV1DesignationId: _deleteV1DesignationId.bind(url, ...arguments),
    postV1DesignationDraft: _postV1DesignationDraft.bind(url, ...arguments),
    postV1Departments: _postV1Departments.bind(url, ...arguments),
    getV1Departments: _getV1Departments.bind(url, ...arguments),
    getV1DepartmentsGenerateExcel: _getV1DepartmentsGenerateExcel.bind(url, ...arguments),
    getV1DepartmentsId: _getV1DepartmentsId.bind(url, ...arguments),
    patchV1DepartmentsId: _patchV1DepartmentsId.bind(url, ...arguments),
    putV1DepartmentsId: _putV1DepartmentsId.bind(url, ...arguments),
    deleteV1DepartmentsId: _deleteV1DepartmentsId.bind(url, ...arguments),
    getV1DepartmentsIdSubDepartments: _getV1DepartmentsIdSubDepartments.bind(url, ...arguments),
    getV1DepartmentsIdTeams: _getV1DepartmentsIdTeams.bind(url, ...arguments),
    postV1DepartmentsTeams: _postV1DepartmentsTeams.bind(url, ...arguments),
    patchV1DepartmentsTeamsId: _patchV1DepartmentsTeamsId.bind(url, ...arguments),
    deleteV1DepartmentsTeamsId: _deleteV1DepartmentsTeamsId.bind(url, ...arguments),
    getV1DepartmentsCheckCode: _getV1DepartmentsCheckCode.bind(url, ...arguments),
    postV1DepartmentsImport: _postV1DepartmentsImport.bind(url, ...arguments),
    postV1DepartmentsDraft: _postV1DepartmentsDraft.bind(url, ...arguments),
    postV1Timezones: _postV1Timezones.bind(url, ...arguments),
    getV1Timezones: _getV1Timezones.bind(url, ...arguments),
    getV1TimezonesId: _getV1TimezonesId.bind(url, ...arguments),
    putV1TimezonesId: _putV1TimezonesId.bind(url, ...arguments),
    deleteV1TimezonesId: _deleteV1TimezonesId.bind(url, ...arguments),
    postV1SalaryStructureMaster: _postV1SalaryStructureMaster.bind(url, ...arguments),
    getV1SalaryStructureMaster: _getV1SalaryStructureMaster.bind(url, ...arguments),
    getV1SalaryStructureMasterId: _getV1SalaryStructureMasterId.bind(url, ...arguments),
    putV1SalaryStructureMasterId: _putV1SalaryStructureMasterId.bind(url, ...arguments),
    deleteV1SalaryStructureMasterId: _deleteV1SalaryStructureMasterId.bind(url, ...arguments),
    patchV1SalaryStructureMasterIdStatus: _patchV1SalaryStructureMasterIdStatus.bind(url, ...arguments),
    postV1SalaryStructureMasterSaveAsDraft: _postV1SalaryStructureMasterSaveAsDraft.bind(url, ...arguments),
    patchV1SalaryStructureMasterIdSaveAsDraft: _patchV1SalaryStructureMasterIdSaveAsDraft.bind(url, ...arguments),
    postV1SalaryStructureMasterCalculate: _postV1SalaryStructureMasterCalculate.bind(url, ...arguments),
    getV1SalaryStructureMasterGenerateExcel: _getV1SalaryStructureMasterGenerateExcel.bind(url, ...arguments),
    postV1SalaryStructureMasterImport: _postV1SalaryStructureMasterImport.bind(url, ...arguments),
    postV1Employee: _postV1Employee.bind(url, ...arguments),
    getV1Employee: _getV1Employee.bind(url, ...arguments),
    getV1EmployeeId: _getV1EmployeeId.bind(url, ...arguments),
    putV1EmployeeId: _putV1EmployeeId.bind(url, ...arguments),
    deleteV1EmployeeId: _deleteV1EmployeeId.bind(url, ...arguments),
    patchV1EmployeeIdStatus: _patchV1EmployeeIdStatus.bind(url, ...arguments),
    postV1EmployeeSaveAsDraft: _postV1EmployeeSaveAsDraft.bind(url, ...arguments),
    patchV1EmployeeIdSaveAsDraft: _patchV1EmployeeIdSaveAsDraft.bind(url, ...arguments),
    getV1EmployeeIdContracts: _getV1EmployeeIdContracts.bind(url, ...arguments),
    getV1EmployeeIdContractsContractId: _getV1EmployeeIdContractsContractId.bind(url, ...arguments),
    getV1EmployeeGenerateExcel: _getV1EmployeeGenerateExcel.bind(url, ...arguments),
    postV1EmployeeImport: _postV1EmployeeImport.bind(url, ...arguments),
    postV1EmployeeContracts: _postV1EmployeeContracts.bind(url, ...arguments),
    getV1EmployeeContracts: _getV1EmployeeContracts.bind(url, ...arguments),
    getV1EmployeeContractsId: _getV1EmployeeContractsId.bind(url, ...arguments),
    putV1EmployeeContractsId: _putV1EmployeeContractsId.bind(url, ...arguments),
    deleteV1EmployeeContractsId: _deleteV1EmployeeContractsId.bind(url, ...arguments),
    patchV1EmployeeContractsIdStatus: _patchV1EmployeeContractsIdStatus.bind(url, ...arguments),
    getV1EmployeeContractsExportExcel: _getV1EmployeeContractsExportExcel.bind(url, ...arguments),
    postV1HireRequests: _postV1HireRequests.bind(url, ...arguments),
    getV1HireRequests: _getV1HireRequests.bind(url, ...arguments),
    getV1HireRequestsRequisitionManagement: _getV1HireRequestsRequisitionManagement.bind(url, ...arguments),
    getV1HireRequestsIdCandidatesByStage: _getV1HireRequestsIdCandidatesByStage.bind(url, ...arguments),
    getV1HireRequestsId: _getV1HireRequestsId.bind(url, ...arguments),
    putV1HireRequestsId: _putV1HireRequestsId.bind(url, ...arguments),
    deleteV1HireRequestsId: _deleteV1HireRequestsId.bind(url, ...arguments),
    patchV1HireRequestsIdStatus: _patchV1HireRequestsIdStatus.bind(url, ...arguments),
    postV1HireRequestsSaveAsDraft: _postV1HireRequestsSaveAsDraft.bind(url, ...arguments),
    patchV1HireRequestsIdSaveAsDraft: _patchV1HireRequestsIdSaveAsDraft.bind(url, ...arguments),
    getV1HireRequestsGenerateExcel: _getV1HireRequestsGenerateExcel.bind(url, ...arguments),
    postV1HireRequestsImport: _postV1HireRequestsImport.bind(url, ...arguments),
    postV1HireRequestsHireRequestIdBudgets: _postV1HireRequestsHireRequestIdBudgets.bind(url, ...arguments),
    putV1HireRequestsHireRequestIdBudgetsId: _putV1HireRequestsHireRequestIdBudgetsId.bind(url, ...arguments),
    postV1JobPosts: _postV1JobPosts.bind(url, ...arguments),
    getV1JobPosts: _getV1JobPosts.bind(url, ...arguments),
    getV1JobPostsId: _getV1JobPostsId.bind(url, ...arguments),
    putV1JobPostsId: _putV1JobPostsId.bind(url, ...arguments),
    deleteV1JobPostsId: _deleteV1JobPostsId.bind(url, ...arguments),
    patchV1JobPostsIdStatus: _patchV1JobPostsIdStatus.bind(url, ...arguments),
    postV1JobPostsSaveAsDraft: _postV1JobPostsSaveAsDraft.bind(url, ...arguments),
    patchV1JobPostsIdSaveAsDraft: _patchV1JobPostsIdSaveAsDraft.bind(url, ...arguments),
    postV1InterviewRounds: _postV1InterviewRounds.bind(url, ...arguments),
    getV1InterviewRounds: _getV1InterviewRounds.bind(url, ...arguments),
    getV1InterviewRoundsId: _getV1InterviewRoundsId.bind(url, ...arguments),
    putV1InterviewRoundsId: _putV1InterviewRoundsId.bind(url, ...arguments),
    deleteV1InterviewRoundsId: _deleteV1InterviewRoundsId.bind(url, ...arguments),
    patchV1InterviewRoundsIdReschedule: _patchV1InterviewRoundsIdReschedule.bind(url, ...arguments),
    postV1Candidates: _postV1Candidates.bind(url, ...arguments),
    getV1Candidates: _getV1Candidates.bind(url, ...arguments),
    getV1CandidatesId: _getV1CandidatesId.bind(url, ...arguments),
    putV1CandidatesId: _putV1CandidatesId.bind(url, ...arguments),
    deleteV1CandidatesId: _deleteV1CandidatesId.bind(url, ...arguments),
    patchV1CandidatesIdStatus: _patchV1CandidatesIdStatus.bind(url, ...arguments),
    postV1CandidatesSaveAsDraft: _postV1CandidatesSaveAsDraft.bind(url, ...arguments),
    patchV1CandidatesIdSaveAsDraft: _patchV1CandidatesIdSaveAsDraft.bind(url, ...arguments),
    patchV1CandidatesCandidateIdInterviewRoundsCandidateInterviewRoundIdReschedule: _patchV1CandidatesCandidateIdInterviewRoundsCandidateInterviewRoundIdReschedule.bind(url, ...arguments),
    getV1CandidatesGenerateExcel: _getV1CandidatesGenerateExcel.bind(url, ...arguments),
    postV1CandidatesImport: _postV1CandidatesImport.bind(url, ...arguments),
    postV1InterviewFeedbacks: _postV1InterviewFeedbacks.bind(url, ...arguments),
    getV1InterviewFeedbacks: _getV1InterviewFeedbacks.bind(url, ...arguments),
    getV1InterviewFeedbacksId: _getV1InterviewFeedbacksId.bind(url, ...arguments),
    putV1InterviewFeedbacksId: _putV1InterviewFeedbacksId.bind(url, ...arguments),
    deleteV1InterviewFeedbacksId: _deleteV1InterviewFeedbacksId.bind(url, ...arguments),
    getV1TalentPoolDashboard: _getV1TalentPoolDashboard.bind(url, ...arguments),
    getV1TalentPoolDashboardSummaryStats: _getV1TalentPoolDashboardSummaryStats.bind(url, ...arguments),
    getV1TalentPoolDashboardRecentCandidates: _getV1TalentPoolDashboardRecentCandidates.bind(url, ...arguments),
    getV1TalentPoolDashboardRecentEvaluations: _getV1TalentPoolDashboardRecentEvaluations.bind(url, ...arguments),
    getV1TalentPoolDashboardUpcomingInterviews: _getV1TalentPoolDashboardUpcomingInterviews.bind(url, ...arguments),
    getV1Dashboard: _getV1Dashboard.bind(url, ...arguments),
    getV1DashboardHeaderStats: _getV1DashboardHeaderStats.bind(url, ...arguments),
    getV1DashboardEmployeesByDepartment: _getV1DashboardEmployeesByDepartment.bind(url, ...arguments),
    getV1DashboardAvailabilityStats: _getV1DashboardAvailabilityStats.bind(url, ...arguments),
    getV1DashboardResourceAllocation: _getV1DashboardResourceAllocation.bind(url, ...arguments),
    getV1DashboardBirthdayDashboard: _getV1DashboardBirthdayDashboard.bind(url, ...arguments),
    getV1DashboardLeaveRequests: _getV1DashboardLeaveRequests.bind(url, ...arguments),
    getV1DashboardResignationRequests: _getV1DashboardResignationRequests.bind(url, ...arguments),
    getV1DashboardIssueHrLetters: _getV1DashboardIssueHrLetters.bind(url, ...arguments),
    getV1DashboardApprovalDashboard: _getV1DashboardApprovalDashboard.bind(url, ...arguments),
    getV1DashboardOngoingJobs: _getV1DashboardOngoingJobs.bind(url, ...arguments),
    getV1DashboardNewHireRequests: _getV1DashboardNewHireRequests.bind(url, ...arguments),
    getV1DashboardEventsDashboard: _getV1DashboardEventsDashboard.bind(url, ...arguments),
    getV1DashboardTaskSignoffs: _getV1DashboardTaskSignoffs.bind(url, ...arguments),
    getV1DashboardKpiStatistics: _getV1DashboardKpiStatistics.bind(url, ...arguments),
    getV1DashboardRpsStatistics: _getV1DashboardRpsStatistics.bind(url, ...arguments),
    getV1DashboardPayrollStatistics: _getV1DashboardPayrollStatistics.bind(url, ...arguments),
    getV1DashboardAttendanceTrends: _getV1DashboardAttendanceTrends.bind(url, ...arguments),
    getV1DashboardDepartmentHeadcount: _getV1DashboardDepartmentHeadcount.bind(url, ...arguments),
    getV1DashboardLeaveBalanceSummary: _getV1DashboardLeaveBalanceSummary.bind(url, ...arguments),
    getV1DashboardRecruitmentFunnel: _getV1DashboardRecruitmentFunnel.bind(url, ...arguments),
    getV1DashboardTeamCalendar: _getV1DashboardTeamCalendar.bind(url, ...arguments),
    getV1DashboardTaskOverview: _getV1DashboardTaskOverview.bind(url, ...arguments),
    getV1DashboardAnnouncements: _getV1DashboardAnnouncements.bind(url, ...arguments),
    getV1DashboardLeaveStatistics: _getV1DashboardLeaveStatistics.bind(url, ...arguments),
    getV1DashboardPendingInterviews: _getV1DashboardPendingInterviews.bind(url, ...arguments),
    getV1DashboardVacationPlanConflicts: _getV1DashboardVacationPlanConflicts.bind(url, ...arguments),
    getV1DashboardManagerHeaderStats: _getV1DashboardManagerHeaderStats.bind(url, ...arguments),
    getV1DashboardManagerKpiStatistics: _getV1DashboardManagerKpiStatistics.bind(url, ...arguments),
    getV1DashboardEmployee: _getV1DashboardEmployee.bind(url, ...arguments),
    getV1DashboardEmployeeWorkingHours: _getV1DashboardEmployeeWorkingHours.bind(url, ...arguments),
    getV1DashboardEmployeeAttendance: _getV1DashboardEmployeeAttendance.bind(url, ...arguments),
    getV1DashboardEmployeeAttendanceBreaks: _getV1DashboardEmployeeAttendanceBreaks.bind(url, ...arguments),
    getV1DashboardEmployeeAttendanceHistory: _getV1DashboardEmployeeAttendanceHistory.bind(url, ...arguments),
    getV1DashboardEmployeeRequests: _getV1DashboardEmployeeRequests.bind(url, ...arguments),
    getV1DashboardEmployeeLoans: _getV1DashboardEmployeeLoans.bind(url, ...arguments),
    getV1DashboardEmployeeHolidaysEvents: _getV1DashboardEmployeeHolidaysEvents.bind(url, ...arguments),
    getV1DashboardEmployeeAssets: _getV1DashboardEmployeeAssets.bind(url, ...arguments),
    getV1DashboardEmployeeActivities: _getV1DashboardEmployeeActivities.bind(url, ...arguments),
    getV1DashboardEmployeeWorkingStatistics: _getV1DashboardEmployeeWorkingStatistics.bind(url, ...arguments),
    getV1DashboardEmployeeTasks: _getV1DashboardEmployeeTasks.bind(url, ...arguments),
    postV1OfferLetters: _postV1OfferLetters.bind(url, ...arguments),
    getV1OfferLetters: _getV1OfferLetters.bind(url, ...arguments),
    getV1OfferLettersId: _getV1OfferLettersId.bind(url, ...arguments),
    putV1OfferLettersId: _putV1OfferLettersId.bind(url, ...arguments),
    deleteV1OfferLettersId: _deleteV1OfferLettersId.bind(url, ...arguments),
    patchV1OfferLettersIdStatus: _patchV1OfferLettersIdStatus.bind(url, ...arguments),
    patchV1OfferLettersIdDocumentsDocumentId: _patchV1OfferLettersIdDocumentsDocumentId.bind(url, ...arguments),
    postV1OfferLettersIdDocumentsDocumentIdVerify: _postV1OfferLettersIdDocumentsDocumentIdVerify.bind(url, ...arguments),
    getV1OfferLettersGenerateExcel: _getV1OfferLettersGenerateExcel.bind(url, ...arguments),
    postV1OfferLettersImport: _postV1OfferLettersImport.bind(url, ...arguments),
    getV1OfferLettersExportExcel: _getV1OfferLettersExportExcel.bind(url, ...arguments),
    postV1OfferLettersSaveAsDraft: _postV1OfferLettersSaveAsDraft.bind(url, ...arguments),
    patchV1OfferLettersIdSaveAsDraft: _patchV1OfferLettersIdSaveAsDraft.bind(url, ...arguments),
    getV1OfferLettersIdPreviewPdf: _getV1OfferLettersIdPreviewPdf.bind(url, ...arguments),
    postV1OfferLettersIdSend: _postV1OfferLettersIdSend.bind(url, ...arguments),
    getV1OfferLettersPublicWelcomeToken: _getV1OfferLettersPublicWelcomeToken.bind(url, ...arguments),
    getV1OfferLettersPublicWelcomeTokenPdf: _getV1OfferLettersPublicWelcomeTokenPdf.bind(url, ...arguments),
    postV1OfferLettersPublicWelcomeTokenAccept: _postV1OfferLettersPublicWelcomeTokenAccept.bind(url, ...arguments),
    postV1OfferLettersPublicWelcomeTokenReject: _postV1OfferLettersPublicWelcomeTokenReject.bind(url, ...arguments),
    patchV1OfferLettersPublicWelcomeTokenDocumentsDocumentId: _patchV1OfferLettersPublicWelcomeTokenDocumentsDocumentId.bind(url, ...arguments),
    postV1OfferLettersPublicWelcomeTokenSubmit: _postV1OfferLettersPublicWelcomeTokenSubmit.bind(url, ...arguments),
    postV1OfferLettersPublicWelcomeTokenDraft: _postV1OfferLettersPublicWelcomeTokenDraft.bind(url, ...arguments),
    postV1TimeCards: _postV1TimeCards.bind(url, ...arguments),
    getV1TimeCards: _getV1TimeCards.bind(url, ...arguments),
    getV1TimeCardsId: _getV1TimeCardsId.bind(url, ...arguments),
    putV1TimeCardsId: _putV1TimeCardsId.bind(url, ...arguments),
    deleteV1TimeCardsId: _deleteV1TimeCardsId.bind(url, ...arguments),
    postV1TimeCardsSaveAsDraft: _postV1TimeCardsSaveAsDraft.bind(url, ...arguments),
    patchV1TimeCardsIdSaveAsDraft: _patchV1TimeCardsIdSaveAsDraft.bind(url, ...arguments),
    postV1TimeCardsIdPost: _postV1TimeCardsIdPost.bind(url, ...arguments),
    getV1TimeCardsGenerateExcel: _getV1TimeCardsGenerateExcel.bind(url, ...arguments),
    postV1TimeCardsImport: _postV1TimeCardsImport.bind(url, ...arguments),
    getV1TimeCardsIdEmployees: _getV1TimeCardsIdEmployees.bind(url, ...arguments),
    postV1TimeCardsEmployees: _postV1TimeCardsEmployees.bind(url, ...arguments),
    getV1TimeCardsIdEmployeeEmployeeId: _getV1TimeCardsIdEmployeeEmployeeId.bind(url, ...arguments),
    postV1TimeCardsEmployeeEmployeeId: _postV1TimeCardsEmployeeEmployeeId.bind(url, ...arguments),
    postV1Timesheets: _postV1Timesheets.bind(url, ...arguments),
    getV1Timesheets: _getV1Timesheets.bind(url, ...arguments),
    getV1TimesheetsId: _getV1TimesheetsId.bind(url, ...arguments),
    putV1TimesheetsId: _putV1TimesheetsId.bind(url, ...arguments),
    deleteV1TimesheetsId: _deleteV1TimesheetsId.bind(url, ...arguments),
    patchV1TimesheetsIdStatus: _patchV1TimesheetsIdStatus.bind(url, ...arguments),
    postV1TimesheetsSaveAsDraft: _postV1TimesheetsSaveAsDraft.bind(url, ...arguments),
    patchV1TimesheetsIdSaveAsDraft: _patchV1TimesheetsIdSaveAsDraft.bind(url, ...arguments),
    postV1TimesheetsGenerate: _postV1TimesheetsGenerate.bind(url, ...arguments),
    getV1TimesheetsIdApprovalHistory: _getV1TimesheetsIdApprovalHistory.bind(url, ...arguments),
    getV1TimesheetsIdPdf: _getV1TimesheetsIdPdf.bind(url, ...arguments),
    postV1OrganisationStructure: _postV1OrganisationStructure.bind(url, ...arguments),
    getV1OrganisationStructure: _getV1OrganisationStructure.bind(url, ...arguments),
    getV1OrganisationStructureId: _getV1OrganisationStructureId.bind(url, ...arguments),
    putV1OrganisationStructureId: _putV1OrganisationStructureId.bind(url, ...arguments),
    deleteV1OrganisationStructureId: _deleteV1OrganisationStructureId.bind(url, ...arguments),
    putV1OrganisationStructureIdTeamsTeamNodeIdTransferMembers: _putV1OrganisationStructureIdTeamsTeamNodeIdTransferMembers.bind(url, ...arguments),
    getV1OrganisationStructureHierarchyLevels: _getV1OrganisationStructureHierarchyLevels.bind(url, ...arguments),
    getV1OrganisationStructureHierarchy: _getV1OrganisationStructureHierarchy.bind(url, ...arguments),
    postV1AssetRequests: _postV1AssetRequests.bind(url, ...arguments),
    getV1AssetRequests: _getV1AssetRequests.bind(url, ...arguments),
    getV1AssetRequestsMyApprovals: _getV1AssetRequestsMyApprovals.bind(url, ...arguments),
    getV1AssetRequestsId: _getV1AssetRequestsId.bind(url, ...arguments),
    putV1AssetRequestsId: _putV1AssetRequestsId.bind(url, ...arguments),
    deleteV1AssetRequestsId: _deleteV1AssetRequestsId.bind(url, ...arguments),
    patchV1AssetRequestsIdStatus: _patchV1AssetRequestsIdStatus.bind(url, ...arguments),
    getV1AssetAllocationInUseAssets: _getV1AssetAllocationInUseAssets.bind(url, ...arguments),
    postV1AssetAllocationTransfer: _postV1AssetAllocationTransfer.bind(url, ...arguments),
    getV1AssetAllocationRequestsIdAvailableAssets: _getV1AssetAllocationRequestsIdAvailableAssets.bind(url, ...arguments),
    postV1AssetAllocationRequestsIdAssign: _postV1AssetAllocationRequestsIdAssign.bind(url, ...arguments),
    postV1AssetAllocationRequestsIdUnassign: _postV1AssetAllocationRequestsIdUnassign.bind(url, ...arguments),
    getV1ReceiveHandoverRequests: _getV1ReceiveHandoverRequests.bind(url, ...arguments),
    getV1ReceiveHandoverRequestsReturns: _getV1ReceiveHandoverRequestsReturns.bind(url, ...arguments),
    getV1ReceiveHandoverRequestsId: _getV1ReceiveHandoverRequestsId.bind(url, ...arguments),
    postV1ReceiveHandoverRequestsIdComplete: _postV1ReceiveHandoverRequestsIdComplete.bind(url, ...arguments),
    postV1ReceiveHandoverRequestsIdProcessHandover: _postV1ReceiveHandoverRequestsIdProcessHandover.bind(url, ...arguments),
    getV1ReceiveHandoverMyAssets: _getV1ReceiveHandoverMyAssets.bind(url, ...arguments),
    getV1ReceiveHandoverMyAssetsId: _getV1ReceiveHandoverMyAssetsId.bind(url, ...arguments),
    postV1ReceiveHandoverMyAssetsIdReturn: _postV1ReceiveHandoverMyAssetsIdReturn.bind(url, ...arguments),
    getV1MyAssets: _getV1MyAssets.bind(url, ...arguments),
    getV1MyAssetsReceivedAssets: _getV1MyAssetsReceivedAssets.bind(url, ...arguments),
    getV1MyAssetsId: _getV1MyAssetsId.bind(url, ...arguments),
    getV1MyAssetsCategoriesId: _getV1MyAssetsCategoriesId.bind(url, ...arguments),
    postV1MyAssetsReturn: _postV1MyAssetsReturn.bind(url, ...arguments),
    postV1DamageLossClaims: _postV1DamageLossClaims.bind(url, ...arguments),
    getV1DamageLossClaims: _getV1DamageLossClaims.bind(url, ...arguments),
    getV1DamageLossClaimsId: _getV1DamageLossClaimsId.bind(url, ...arguments),
    putV1DamageLossClaimsId: _putV1DamageLossClaimsId.bind(url, ...arguments),
    patchV1DamageLossClaimsIdStatus: _patchV1DamageLossClaimsIdStatus.bind(url, ...arguments),
    postV1DamageLossClaimsIdSuggestSplit: _postV1DamageLossClaimsIdSuggestSplit.bind(url, ...arguments),
    getV1AssetTracker: _getV1AssetTracker.bind(url, ...arguments),
    getV1AssetTrackerAssetsName: _getV1AssetTrackerAssetsName.bind(url, ...arguments),
    postV1AssetTrackerAssetsAssetIdHistory: _postV1AssetTrackerAssetsAssetIdHistory.bind(url, ...arguments),
    postV1ResourceAllocationRequests: _postV1ResourceAllocationRequests.bind(url, ...arguments),
    getV1ResourceAllocationRequests: _getV1ResourceAllocationRequests.bind(url, ...arguments),
    getV1ResourceAllocationRequestsApprovals: _getV1ResourceAllocationRequestsApprovals.bind(url, ...arguments),
    getV1ResourceAllocationRequestsId: _getV1ResourceAllocationRequestsId.bind(url, ...arguments),
    putV1ResourceAllocationRequestsId: _putV1ResourceAllocationRequestsId.bind(url, ...arguments),
    deleteV1ResourceAllocationRequestsId: _deleteV1ResourceAllocationRequestsId.bind(url, ...arguments),
    patchV1ResourceAllocationRequestsIdStatus: _patchV1ResourceAllocationRequestsIdStatus.bind(url, ...arguments),
    getV1ResourceAllocationRequestsGenerateExcel: _getV1ResourceAllocationRequestsGenerateExcel.bind(url, ...arguments),
    getV1ResourceAllocationAssignments: _getV1ResourceAllocationAssignments.bind(url, ...arguments),
    getV1ResourceAllocationAssignmentsId: _getV1ResourceAllocationAssignmentsId.bind(url, ...arguments),
    patchV1ResourceAllocationAssignmentsId: _patchV1ResourceAllocationAssignmentsId.bind(url, ...arguments),
    getV1ResourceAllocationAssignmentsIdPositionPositionId: _getV1ResourceAllocationAssignmentsIdPositionPositionId.bind(url, ...arguments),
    postV1ResourceAllocationAssignmentsIdPositionPositionId: _postV1ResourceAllocationAssignmentsIdPositionPositionId.bind(url, ...arguments),
    postV1ResourceAllocationAssignmentsAvailableEmployees: _postV1ResourceAllocationAssignmentsAvailableEmployees.bind(url, ...arguments),
    postV1LeaveRequestsLeaveManagement: _postV1LeaveRequestsLeaveManagement.bind(url, ...arguments),
    postV1LeaveRequests: _postV1LeaveRequests.bind(url, ...arguments),
    getV1LeaveRequests: _getV1LeaveRequests.bind(url, ...arguments),
    getV1LeaveRequestsPendingApprovals: _getV1LeaveRequestsPendingApprovals.bind(url, ...arguments),
    getV1LeaveRequestsId: _getV1LeaveRequestsId.bind(url, ...arguments),
    putV1LeaveRequestsId: _putV1LeaveRequestsId.bind(url, ...arguments),
    deleteV1LeaveRequestsId: _deleteV1LeaveRequestsId.bind(url, ...arguments),
    postV1LeaveRequestsSaveAsDraft: _postV1LeaveRequestsSaveAsDraft.bind(url, ...arguments),
    patchV1LeaveRequestsIdSaveAsDraft: _patchV1LeaveRequestsIdSaveAsDraft.bind(url, ...arguments),
    patchV1LeaveRequestsIdStatus: _patchV1LeaveRequestsIdStatus.bind(url, ...arguments),
    getV1LeaveRequestsIdConflicts: _getV1LeaveRequestsIdConflicts.bind(url, ...arguments),
    getV1LeaveRequestsIdApprovalHistory: _getV1LeaveRequestsIdApprovalHistory.bind(url, ...arguments),
    postV1LeaveRequestsIdAdvancePayment: _postV1LeaveRequestsIdAdvancePayment.bind(url, ...arguments),
    getV1LeaveRequestsGenerateExcel: _getV1LeaveRequestsGenerateExcel.bind(url, ...arguments),
    postV1LeaveRequestsImport: _postV1LeaveRequestsImport.bind(url, ...arguments),
    putV1LeaveRequestsLeaveRequestIdAttachments: _putV1LeaveRequestsLeaveRequestIdAttachments.bind(url, ...arguments),
    postV1LeaveManagement: _postV1LeaveManagement.bind(url, ...arguments),
    getV1LeaveManagement: _getV1LeaveManagement.bind(url, ...arguments),
    getV1LeaveManagementPendingApprovals: _getV1LeaveManagementPendingApprovals.bind(url, ...arguments),
    getV1LeaveManagementId: _getV1LeaveManagementId.bind(url, ...arguments),
    putV1LeaveManagementId: _putV1LeaveManagementId.bind(url, ...arguments),
    deleteV1LeaveManagementId: _deleteV1LeaveManagementId.bind(url, ...arguments),
    postV1LeaveManagementSaveAsDraft: _postV1LeaveManagementSaveAsDraft.bind(url, ...arguments),
    patchV1LeaveManagementIdSaveAsDraft: _patchV1LeaveManagementIdSaveAsDraft.bind(url, ...arguments),
    patchV1LeaveManagementIdStatus: _patchV1LeaveManagementIdStatus.bind(url, ...arguments),
    getV1LeaveManagementIdConflicts: _getV1LeaveManagementIdConflicts.bind(url, ...arguments),
    getV1LeaveManagementIdApprovalHistory: _getV1LeaveManagementIdApprovalHistory.bind(url, ...arguments),
    postV1LeaveManagementIdAdvancePayment: _postV1LeaveManagementIdAdvancePayment.bind(url, ...arguments),
    putV1LeaveManagementLeaveRequestIdAttachments: _putV1LeaveManagementLeaveRequestIdAttachments.bind(url, ...arguments),
    postV1Resignations: _postV1Resignations.bind(url, ...arguments),
    getV1Resignations: _getV1Resignations.bind(url, ...arguments),
    getV1ResignationsMyApprovals: _getV1ResignationsMyApprovals.bind(url, ...arguments),
    getV1ResignationsId: _getV1ResignationsId.bind(url, ...arguments),
    putV1ResignationsId: _putV1ResignationsId.bind(url, ...arguments),
    deleteV1ResignationsId: _deleteV1ResignationsId.bind(url, ...arguments),
    getV1ResignationsIdAssignedAssets: _getV1ResignationsIdAssignedAssets.bind(url, ...arguments),
    patchV1ResignationsIdStatus: _patchV1ResignationsIdStatus.bind(url, ...arguments),
    postV1ResignationsImport: _postV1ResignationsImport.bind(url, ...arguments),
    getV1ResignationsGenerateExcel: _getV1ResignationsGenerateExcel.bind(url, ...arguments),
    postV1Terminations: _postV1Terminations.bind(url, ...arguments),
    getV1Terminations: _getV1Terminations.bind(url, ...arguments),
    getV1TerminationsMyApprovals: _getV1TerminationsMyApprovals.bind(url, ...arguments),
    getV1TerminationsId: _getV1TerminationsId.bind(url, ...arguments),
    putV1TerminationsId: _putV1TerminationsId.bind(url, ...arguments),
    deleteV1TerminationsId: _deleteV1TerminationsId.bind(url, ...arguments),
    getV1TerminationsIdAssignedAssets: _getV1TerminationsIdAssignedAssets.bind(url, ...arguments),
    patchV1TerminationsIdInitiate: _patchV1TerminationsIdInitiate.bind(url, ...arguments),
    patchV1TerminationsIdStatus: _patchV1TerminationsIdStatus.bind(url, ...arguments),
    postV1TerminationsImport: _postV1TerminationsImport.bind(url, ...arguments),
    getV1TerminationsGenerateExcel: _getV1TerminationsGenerateExcel.bind(url, ...arguments),
    getV1TerminationsIdTerminationLetter: _getV1TerminationsIdTerminationLetter.bind(url, ...arguments),
    patchV1ResignationSettlementsIdAssetClearance: _patchV1ResignationSettlementsIdAssetClearance.bind(url, ...arguments),
    getV1ResignationSettlementsIdDetail: _getV1ResignationSettlementsIdDetail.bind(url, ...arguments),
    getV1ResignationSettlementsIdEmployeeFinancialOverview: _getV1ResignationSettlementsIdEmployeeFinancialOverview.bind(url, ...arguments),
    getV1ResignationSettlementsId: _getV1ResignationSettlementsId.bind(url, ...arguments),
    postV1ResignationSettlementsIdComponents: _postV1ResignationSettlementsIdComponents.bind(url, ...arguments),
    deleteV1ResignationSettlementsIdComponentsComponentId: _deleteV1ResignationSettlementsIdComponentsComponentId.bind(url, ...arguments),
    patchV1ResignationSettlementsIdComponentsComponentId: _patchV1ResignationSettlementsIdComponentsComponentId.bind(url, ...arguments),
    patchV1ResignationSettlementsIdStatus: _patchV1ResignationSettlementsIdStatus.bind(url, ...arguments),
    patchV1TerminationSettlementsIdAssetClearance: _patchV1TerminationSettlementsIdAssetClearance.bind(url, ...arguments),
    getV1TerminationSettlementsIdDetail: _getV1TerminationSettlementsIdDetail.bind(url, ...arguments),
    getV1TerminationSettlementsIdEmployeeFinancialOverview: _getV1TerminationSettlementsIdEmployeeFinancialOverview.bind(url, ...arguments),
    getV1TerminationSettlementsId: _getV1TerminationSettlementsId.bind(url, ...arguments),
    postV1TerminationSettlementsIdComponents: _postV1TerminationSettlementsIdComponents.bind(url, ...arguments),
    deleteV1TerminationSettlementsIdComponentsComponentId: _deleteV1TerminationSettlementsIdComponentsComponentId.bind(url, ...arguments),
    patchV1TerminationSettlementsIdComponentsComponentId: _patchV1TerminationSettlementsIdComponentsComponentId.bind(url, ...arguments),
    patchV1TerminationSettlementsIdStatus: _patchV1TerminationSettlementsIdStatus.bind(url, ...arguments),
    getV1MonthlyPayroll: _getV1MonthlyPayroll.bind(url, ...arguments),
    postV1MonthlyPayroll: _postV1MonthlyPayroll.bind(url, ...arguments),
    getV1MonthlyPayrollId: _getV1MonthlyPayrollId.bind(url, ...arguments),
    putV1MonthlyPayrollId: _putV1MonthlyPayrollId.bind(url, ...arguments),
    deleteV1MonthlyPayrollId: _deleteV1MonthlyPayrollId.bind(url, ...arguments),
    postV1MonthlyPayrollSaveAsDraft: _postV1MonthlyPayrollSaveAsDraft.bind(url, ...arguments),
    patchV1MonthlyPayrollIdSaveAsDraft: _patchV1MonthlyPayrollIdSaveAsDraft.bind(url, ...arguments),
    postV1MonthlyPayrollIdRun: _postV1MonthlyPayrollIdRun.bind(url, ...arguments),
    postV1MonthlyPayrollIdSubmit: _postV1MonthlyPayrollIdSubmit.bind(url, ...arguments),
    postV1MonthlyPayrollIdApprove: _postV1MonthlyPayrollIdApprove.bind(url, ...arguments),
    postV1MonthlyPayrollIdReject: _postV1MonthlyPayrollIdReject.bind(url, ...arguments),
    postV1MonthlyPayrollIdValidate: _postV1MonthlyPayrollIdValidate.bind(url, ...arguments),
    getV1SalarySheets: _getV1SalarySheets.bind(url, ...arguments),
    postV1SalarySheets: _postV1SalarySheets.bind(url, ...arguments),
    getV1SalarySheetsId: _getV1SalarySheetsId.bind(url, ...arguments),
    putV1SalarySheetsId: _putV1SalarySheetsId.bind(url, ...arguments),
    deleteV1SalarySheetsId: _deleteV1SalarySheetsId.bind(url, ...arguments),
    postV1SalarySheetsLoadData: _postV1SalarySheetsLoadData.bind(url, ...arguments),
    postV1SalarySheetsIdValidate: _postV1SalarySheetsIdValidate.bind(url, ...arguments),
    postV1SalarySheetsIdGenerateSif: _postV1SalarySheetsIdGenerateSif.bind(url, ...arguments),
    postV1SalarySheetsIdMarkProcessed: _postV1SalarySheetsIdMarkProcessed.bind(url, ...arguments),
    postV1SalarySheetsIdSaveDraft: _postV1SalarySheetsIdSaveDraft.bind(url, ...arguments),
    getV1SalarySheetsIdDownloadSif: _getV1SalarySheetsIdDownloadSif.bind(url, ...arguments),
    getV1Payslips: _getV1Payslips.bind(url, ...arguments),
    getV1PayslipsId: _getV1PayslipsId.bind(url, ...arguments),
    deleteV1PayslipsId: _deleteV1PayslipsId.bind(url, ...arguments),
    postV1PayslipsGenerate: _postV1PayslipsGenerate.bind(url, ...arguments),
    postV1PayslipsIdSendEmail: _postV1PayslipsIdSendEmail.bind(url, ...arguments),
    postV1PayslipsIdPublishEss: _postV1PayslipsIdPublishEss.bind(url, ...arguments),
    getV1PayslipsEmployeeEmployeeId: _getV1PayslipsEmployeeEmployeeId.bind(url, ...arguments),
    postV1PayslipsEmployeeEmployeeIdGenerate: _postV1PayslipsEmployeeEmployeeIdGenerate.bind(url, ...arguments),
    getV1PayslipsDownloadId: _getV1PayslipsDownloadId.bind(url, ...arguments),
    postV1ReportsEmployeeList: _postV1ReportsEmployeeList.bind(url, ...arguments),
    postV1ReportsContractList: _postV1ReportsContractList.bind(url, ...arguments),
    postV1ReportsRecruitmentRequestList: _postV1ReportsRecruitmentRequestList.bind(url, ...arguments),
    postV1ReportsRecruitmentFulfilmentAnalysis: _postV1ReportsRecruitmentFulfilmentAnalysis.bind(url, ...arguments),
    postV1ReportsDepartmentAnalysis: _postV1ReportsDepartmentAnalysis.bind(url, ...arguments),
    postV1ReportsEmployeeSalaryList: _postV1ReportsEmployeeSalaryList.bind(url, ...arguments),
    postV1ReportsResignationRequestList: _postV1ReportsResignationRequestList.bind(url, ...arguments),
    postV1ReportsTerminationRequestList: _postV1ReportsTerminationRequestList.bind(url, ...arguments),
    postV1ReportsFinalSettlementReport: _postV1ReportsFinalSettlementReport.bind(url, ...arguments),
    postV1ReportsEmployeeGratuityReport: _postV1ReportsEmployeeGratuityReport.bind(url, ...arguments),
    postV1ReportsEmployeeOvertimeReport: _postV1ReportsEmployeeOvertimeReport.bind(url, ...arguments),
    postV1ReportsLeaveRequestList: _postV1ReportsLeaveRequestList.bind(url, ...arguments),
    postV1ReportsAnnualLeaveReport: _postV1ReportsAnnualLeaveReport.bind(url, ...arguments),
    postV1ReportsEmployeeLoanList: _postV1ReportsEmployeeLoanList.bind(url, ...arguments),
    postV1ReportsPendingLoanStatus: _postV1ReportsPendingLoanStatus.bind(url, ...arguments),
    postV1ReportsSalarySheet: _postV1ReportsSalarySheet.bind(url, ...arguments),
    postV1ReportsExpenseReimbursement: _postV1ReportsExpenseReimbursement.bind(url, ...arguments),
    postV1ReportsTimeSheet: _postV1ReportsTimeSheet.bind(url, ...arguments),
    postV1ReportsResourceRequisitions: _postV1ReportsResourceRequisitions.bind(url, ...arguments),
    postV1ReportsTimeCard: _postV1ReportsTimeCard.bind(url, ...arguments),
    postV1ReportsAttendanceSummary: _postV1ReportsAttendanceSummary.bind(url, ...arguments),
    postV1ReportsMissingAttendance: _postV1ReportsMissingAttendance.bind(url, ...arguments),
    postV1ReportsEmployeeAssetRecords: _postV1ReportsEmployeeAssetRecords.bind(url, ...arguments),
    postV1ReportsAssetDamage: _postV1ReportsAssetDamage.bind(url, ...arguments),
    postV1ReportsAssetStatus: _postV1ReportsAssetStatus.bind(url, ...arguments),
    postV1ReportsEmployeeProbationReport: _postV1ReportsEmployeeProbationReport.bind(url, ...arguments),
    postV1ReportsEmployeeTurnoverReport: _postV1ReportsEmployeeTurnoverReport.bind(url, ...arguments),
    postV1ReportsPayrollVarianceReport: _postV1ReportsPayrollVarianceReport.bind(url, ...arguments),
    postV1ReportsExpiringDocumentsReport: _postV1ReportsExpiringDocumentsReport.bind(url, ...arguments),
    postV1ReportsLeaveEncashmentReport: _postV1ReportsLeaveEncashmentReport.bind(url, ...arguments),
    postV1AttendanceCheckIn: _postV1AttendanceCheckIn.bind(url, ...arguments),
    postV1AttendanceCheckOut: _postV1AttendanceCheckOut.bind(url, ...arguments),
    postV1AttendanceStartBreak: _postV1AttendanceStartBreak.bind(url, ...arguments),
    postV1AttendanceEndBreak: _postV1AttendanceEndBreak.bind(url, ...arguments),
    getV1AttendanceStatus: _getV1AttendanceStatus.bind(url, ...arguments),
    getV1AttendanceSummaryAttendanceId: _getV1AttendanceSummaryAttendanceId.bind(url, ...arguments),
    getV1Approvals: _getV1Approvals.bind(url, ...arguments)
  }
}